import React, { createRef, Fragment, useEffect, useState } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { ExpandCollapse } from '@tds/core-expand-collapse';
import Modal from '@tds/community-modal';
import moment from 'moment-business-days';
import addDays from 'date-fns/addDays';

import request from '../utils/request';
import { parseProvince } from '../../helpers/common';
import { disableOptions, getFieldOption, getFieldValue, msgDisplay } from './utils';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import { useTranslationsContext } from '../context/TranslationsContext';
import FormField from './formField';
import { Error, Image } from '../design/elements';
import ValidateLoader from '../UI/validateLoader';
import { ProgressBar, StatusBar } from '../design';
import { getFlow } from './formSubmitLogic';
import {
  getHBBQualificationAnswers,
  hasQuebecInAddress,
  is7XChannel,
  isChannelOptikTvCompatible,
  isChannelOptikTvCompatibleABAndBC,
  isChannelSMBDigitalFr,
  isChannelValidForPhoneRemoval,
  isChannelVulcanCompatible,
  isNGM,
  isSbsTelesalesTiChannel,
  isSMBGrowthSalesCBS
} from './businessLogic/utils';
import { updateSecureBusinessRates } from './businessLogic/secureBusines/index';
import { calcInstallationFeeDiscount, setDisabledOptions } from './businessLogic/secureBusines/offers';
import { getSecureBusinessOffersList, getSmartCameraOffersList } from './businessLogic/secureBusines/utils';
import EN from '../../EN.json';
import FR from '../../FR.json';
import { getLocale } from '../misc';

import { FormFieldsWrapper, GroupTitle, GroupWrapper, SummaryGroupWrapper } from './css';
import {
  $100offInstallation,
  $199offInstallation,
  ab,
  alberta,
  allowedChannelsListForHomeBased,
  allowedProvinceListForDealers,
  BACKEND_KEYS,
  bc,
  britishColumbia,
  businessLegalName,
  businessLegalNameQuoteTool,
  businessType,
  channelComplexNote,
  complexChannels,
  complexNote,
  CONSTANT,
  contractBuyoutBillCredit600,
  customerProfileID,
  easyFiveYearSmokeFireDetector,
  easySmokeFireDetector,
  easySmokeFireDetectorProtector,
  easyTemperatureSensor,
  errorMessageInc,
  existingConnection,
  existingConnectionMapping,
  existingConnectionYes,
  existingInternetProvider,
  existingInternetProviderAlberta,
  existingNo,
  existingProvider,
  feildBetterBusinessBundleCopper,
  feildBetterBusinessBundleFibre,
  feildSourceOfSale,
  fibre25GLocality,
  FibreInternet300CBMGroup1,
  FibreInternet300CBMGroup2,
  FibreInternet300MPP,
  fibreNoteCheckbox,
  fibreNoteOnCustomerInfomationPage,
  fieldAccountDetails,
  fieldAccountDetailsFr,
  fieldBetterBusinessBundleFibre,
  fieldBuildingSize,
  fieldBusinessConnect,
  fieldBusinessRegular,
  fieldBusinessTVmigrationOptik,
  fieldCallToBookIt,
  fieldCamerasInstalled,
  fieldContractLanguagePreference,
  fieldControl,
  fieldCustomerHaveLiquorLicense,
  fieldCustomerPrivateWifiConnection,
  fieldCustomerRequestFibre3G,
  fieldCustomerSecuritySystems,
  fieldCustomerServiceAddressNote,
  fieldDoesCustomerAgreeToAltercations,
  fieldDoesCustomerHaveLawnOrFenceOnPremise,
  fieldDoesTheCustomerHaveLteCoverage,
  fieldEightCameras,
  fieldEmergencyContactDetails,
  fieldEmergencyPremiseContactNumberNonRepeated,
  fieldExistingInternetProviderErrorNote,
  fieldExistingInternetProviderRoC,
  fieldExpirationKey,
  fieldFiberInternet,
  fieldFiberInternetG1,
  fieldFiberInternetG2,
  fieldFiberInternetMPP,
  fieldFiberSwitch15GSwitch,
  fieldFiberSwitch1GSwitch,
  fieldForbearance,
  fieldGisId,
  fieldHBBQualificationErrorNote,
  fieldHighestQualifiedSpeed,
  fieldHighValueItems,
  fieldInstallation,
  fieldInstallationPreferredArrivalWindow,
  fieldInternetType,
  fieldIsPureFibreEastLeadWLN,
  fieldIsThePurposeToProtectHBB,
  fieldIsThisHBBRegisteredBusiness,
  fieldIsThisHomeBasedBusiness,
  fieldIsVulcanOrderWLN,
  fieldKeyAddress,
  fieldLeadID,
  fieldLimitedMonthlyOfferFibre,
  fieldLimitedMonthlyOfferFibre75,
  fieldLimitedOfferFI,
  fieldLimitedTimeBasicOffer,
  fieldLimitedTimeOffer,
  fieldLimitedTimeOfferYearly15g,
  fieldLimitedTimeOfferYearly3g3000,
  fieldLimitedYearlyOffersFibre,
  fieldLimitedYearlyOffersFibre150,
  fieldLimitedYearlyOffersFibre300,
  fieldLTESpeedErrorNote,
  fieldManagerSpecialDiscount,
  fieldMppOffers,
  fieldObdNoteOnCustomerInformation,
  fieldObdOrder,
  fieldOptionStaticIp0,
  fieldOptionStaticIp5,
  fieldOptionStaticIpDynamic5,
  fieldOrderType,
  fieldOutletStoreCode,
  fieldPermitNumberUserAccountDetail,
  fieldPrefferedDateSecurityNote,
  fieldPrefieldPreferredArrivalWindow,
  fieldProductHomeBasedBusiness,
  fieldProductSelection,
  fieldProductSelectionFibre,
  fieldProductThatIsAdded,
  fieldProductType,
  fieldPromoDurationFibre,
  fieldProtect,
  fieldQualifiedSpeed,
  fieldQualifiedSpeedFibre,
  fieldRegularMonthlyOffers,
  fieldRegularMonthlyOffersFibre,
  fieldRegularYearlyOffers,
  fieldRegularYearlyOffersFibre,
  fieldRegularYearlyOffersFibreBundled,
  fieldSecureBusinessOffers,
  fieldSigningAuthority,
  fieldSigningAuthorityV,
  fieldsKeyLocalStorage,
  fieldSmartCamera,
  fieldSmartCameraOffers,
  fieldSpecialRetailer,
  fieldStaticIpPromotion,
  fieldStaticIPRequired,
  fieldStaticIPRequiredFibre,
  fieldStaticIpSubnet1,
  fieldStaticIpSubnet5,
  fieldsToHideforNonOptikAndPhoneChannels,
  fieldStoreCodeWLN,
  fieldsToShowforNonOptikAndPhoneChannels,
  fieldsToShowforOptikTV,
  fieldTelusBusinessWifi,
  fieldTelusBusinessWifiTypeCopper,
  fieldTelusBusinessWifiTypeFibre,
  fieldtelusOptikTvAccessibleToEmpAndStaff,
  fieldTelusOptikTvExtraThemePackHomeBased,
  fieldTelusOptikTvFreeThemePacks,
  fieldTelusOptikTvFreeThemePacksForHomeBased,
  fieldTelusOptikTvMonthlyRatePlan,
  fieldTelusOptikTvNumberWiredSetTopBoxes,
  fieldTelusOptikTvNumberWirelessSetTopBoxes,
  fieldTelusOptikTvPricingAndOffers,
  fieldTelusOptikTvProfileType,
  fieldTelusOptikTvPromoDuration,
  fieldTelusSecureBusinessSecurityPackage,
  fieldTerm,
  fieldTermBusinessTV,
  fieldTermFibre,
  fieldTsbPreferedInstallDate,
  fieldTsbSecondaryPreferredInstallDate,
  fieldTsbTertiaryPreferredInstallDate,
  fieldTwBasicWifiApAmount,
  fieldTwoMonthsDuration,
  fieldTwoMonthsDurationFibre,
  fieldValueHSIA,
  fieldWhatIsUploadSpeed,
  fieldWhatSubjectWouldYouLikeToDisplayOnTheQuote,
  fieldWinback,
  fieldWinbackFibre,
  fieldWirelinePreferedInstallDate,
  fieldWirelineSecondaryInstallDate,
  fiveDollarsOff,
  fiveYearlyCopperPromos,
  fiveYearlyFibrePromos,
  formCategoriesWirelineWireless,
  hBBQualificationFields,
  includedEquipmentSelection,
  inputTypeFile,
  installationCalendarDateFormat,
  internetAndBusinessConnectBundleBillCredit200,
  internetCopper,
  internetFibre,
  internetTypesOptionLables,
  keyAdditionalEquipment,
  keyControlAdditionalEquipment,
  keyControlIncludedEquipmentSelection,
  keyFileSizeExceeded,
  keyMonitorAdditionalEquipment,
  keyOrderCustomerInformation,
  keyProtectAdditionalEquipment,
  keyProtectIncludedEquipmentSelection,
  keySecureBusiness,
  keySecurityCameraEquipment,
  keySmartCameraIncludedEquipment,
  keyTelusOptikTvAdditionalSetTopBoxes,
  keyYes,
  listChannelForTSB,
  localeFrench,
  manitoba,
  maxUploadSizeErrorMessage,
  maxUploadSizeValue,
  mb,
  MM_CHANNELS,
  MM_CHANNELS_FLOW_KEYS,
  MM_CHANNELS_KEYS_NOTES,
  mppCrossSellOffer15,
  mppFibreInternet1G,
  nameTelusTVForBusiness,
  newAndAcquired,
  nonRoSProvinces,
  noteNumberTelusWifiAccessPointsFibre,
  numberTelusAccessPoints,
  numberTelusWifiAccessPointsCopper,
  numberTelusWifiAccessPointsFibre,
  numberTelusWifiAccessPointsTelusBusiness,
  officePhoneExclusionChannels,
  optikTvIncludedChannels,
  orderDetailsForm,
  orderStatus,
  packageMonitor,
  poeSwitch,
  PRE_QUALIFICATION_QUESTIONS,
  privateWifi,
  productSelection,
  productSelectionValues,
  promosForAB,
  provinceAlias,
  qualifiedSpeedOptions,
  quoteToolForm,
  regexBusinessInc,
  reminder,
  roleLabels,
  saskatchewan,
  sectionTelusOptikTvInstallDetails,
  secureBusinessLegalNameFieldTypes,
  secureBusinessResetFields,
  secureBusinessTerm,
  selfInstall,
  sixByTweleveonthPromo,
  sixMonthsFree,
  sixMonthsFreePromo,
  sixTwelvePromo,
  sk,
  smartCameraKey,
  smartThermostat,
  smartThermostatFree,
  smbPlatinum,
  smbPlatinumForm,
  smokeDetector,
  smokeDetectorWarningNote,
  sourceOfChannelsList,
  standardRate,
  standardRateLabel,
  staticIp1LabelPromotion,
  staticIp5LabelPromotion,
  stepKeyMain,
  storageItemProvince,
  storeCodeOutletMapping,
  storeCodes,
  storedItemQualifiedSpeedOptions,
  switchCredit$100,
  switchCreditCopper,
  telusCaseNumber,
  telusNo,
  telusOptictvTimeZone,
  telusOptikTvSetTopBoxTotalLimit,
  telusPublicWifiFibre,
  telusSecureBusiness,
  telusTVforBusiness,
  telusUpgrade,
  telusUpgradeMapping,
  telusUploadSpeed,
  telusYes,
  temperatureSensor,
  temperatureSensorFeeNote1,
  temperatureSensorFeeNote2,
  term36MonthValue,
  thermostatWarningNote,
  tradeNameOrName,
  tsbInstallDateFields,
  tsbPreferedInstallDate,
  tsbSecondaryPreferredInstallDate,
  tsbSecurityOffersObject,
  twoMonthsDuration,
  typeCheckbox,
  upgradeCaseNumber,
  uploadSpeed,
  uploadSpeedLogic,
  uploadSpeedTrue,
  valueBusinessPersonal,
  valueControl,
  valueNewTelusBusinessOrder,
  valueNonProfitOrgs,
  valueOfficeInternetBasic,
  valueProductInformation,
  valueProductTypeStandaloneFr,
  valueProtect,
  valueQualifiedSpeed150mbps,
  valueQualifiedSpeed15gFibre,
  valueQualifiedSpeed15mbps,
  valueQualifiedSpeed25mbps,
  valueQualifiedSpeed300mbps,
  valueQualifiedSpeed3gFibre,
  valueQualifiedSpeed750mbps,
  valueQualifiedSpeed75mbps,
  valueQualifiedSpeed940mbps,
  waivedMovingFromCompetitor,
  waivedMultiProductOrder,
  warningNote,
  warningNoteSmbTiDigitalFr,
  wifiError,
  wifiPrivate,
  wifiSecurityErrorNote,
  winbackPrefferedInstallationNoteProvinces,
  wireLineDateFields,
  wirelinePreferedInstallDate,
  wirelineSecondaryInstallDate,
  Yes
} from '../utils/constant';
import { removeItem, setItem } from '../utils';
import { secureBusinessFields, telusOptikTvPricing } from './businessLogic/rates';
import { getDisabledDates, getDiscountAmountSum, scrollToErrors } from '../utils/utils';
import UserDetailsForm from './userDetailsForm';
import Note from '../note';
import RepeatedForm from './repeatedForm';
import stringInterpolation from '../utils/stringInterpolation';
import OfficePhone from './officePhone/index';
import QuoteSummary from './quoteSummary';
import EquipmentSectionForm from './equipmentSectionForm';
import OptikRepeaterForm from './optikRepeaterForm';
import PrequalificationHelpers from './WLNHelpers/prequalificationHelpers';
import OrderSummary from './orderSummary';
import { findField, getFormData, isRelatedFieldExisted, normalizeEquipmentGroupSection } from './formStepUtils';
import {
  calculateFibreRates,
  calculateOfficeCopperRates,
  calculateTelusOptikRates
} from './businessLogic/calculateRates';

const {
  KEYS: { ROLES}
} = CONSTANT;

const formFieldsGroup = 'formFieldsGroup';
const formSection = 'formSection';
const userDetailsKey = 'userDetails';
const repeatedFormKey = 'repeatedForm';
const typeMultiCheckbox = 'MultiCheckbox';
const equipmentGroupSectionKey = 'equipmentGroupSection';
// @Todo: need to refactor this variable. Maybe it should go into useState.
let topBoxDetailOptions = [];

const profile = request.getProfile();
const initialRates = {
  addAmountToMonthly: 0
};
const locale = getLocale();

const {
  WLS: {
    errorNumberTelusWifiAccessPoints,
    _valueTerm60Month,
    _valueTerm36Month,
    _term60MonthValue,
    _tenDollarOff,
    _valueThreeMonthsFree,
    _tenDollarBundleDiscount,
    _yes,
    _no,
    _monthly,
    _standardPricing,
    _bundled,
    _valueFiveGSpeed,
    mobility,
    _100DollarOffInstallation,
    _valueStaticIpSubnet1Fibre,
    _valueStaticIpSubnet5Fibre,
    valuePrivateHomeBasedOpus,
    valuePrivateLegacy,
    valuePublicLegacy,
    valuePublicOpus,
    _valueCopperStaticIpSubnet1,
    _valueCopperStaticIpSubnet5
  },
  contentfulValues: {
    _valueTerm36MonthBT,
    secureBusinessOffers: {
      twentyDollarMonthlyDiscount,
      waivedInstallationFee
    }
  },
  formStep: {
    maxNumberOfSetTopBoxes
  }
} = locale === 'en-US' ? EN : FR;

const isEqual = (field, value) => (field === value);

const initEquipmentPrices = {
  subtractAmountFromPrice: 0,
  addAmountToPrice: 0,
  addAmountToMonthly: 0,
  subtractAmountFromMonthly: 0,
  addAmountToFiveYearMonthly: 0,
  subtractAmountFromFiveYearMonthly: 0
};

moment.updateLocale('en-CA', {
  workingWeekdays: [1, 2, 3, 4, 5]
});

const FormStep = ({
  stepData,
  steps,
  progressBarSteps,
  updateProgressBarSteps,
  step,
  updateStep,
  history,
  setFormRef,
  onFormSubmit,
  onSaveAndExit,
  onViewPdf,
  orderData,
  hideProgressBar,
  isEditing,
  formName,
  setQuoteSummaryData,
  onSaveAndContinue,
  onCreateNewOrder,
  isCreateOrderVisible,
  setOrderData,
  isCreateOrderButtonVisible
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const translations = useTranslationsContext();
  let telusSecureBusinessSelection;
  const {
    contentfulValues: {
      yes,
      yearsTerm,
      fiveYearsTerm,
      threeMonthsFree,
      bundled,
      monthPromo,
      standardPricing,
      standaloneOffer,
      no,
      telusOptikTvMonthlyRatePlanOptionValues,
      mbps15,
      standalone,
      betterBusinessBundleCopper,
      betterBusinessBundleFibre,
      serviceAddressError,
      mbps750,
      mbps3g,
      mbps3g3000,
      mbps300,
      secureBusinessOffers: {
        threeMonthFree,
        hardwareCredit,
        tenOffWirelene,
        twentyOffWireline,
        tenOffMpp,
        twentyOffMpp,
        zeroInstallation
      },
      secureBusinessSelectPackageError,
      formStepNames: { orderFibreInternet, quoteOptikTV, orderOptikTV },
      productInformation,
      winbackFields
    },
    formButtons: { confirmButtonLabel, cancelButtinLabel },
    summaryForm: { summaryLabel },
    formStep: {
      minValueErrorMessage,
      maxValueErrorMessage,
      minLengthErrorMessage,
      maxLengthErrorMessage,
      telusOptikCopperDisclaimerMessage,
      telusOptikMustBeQualifiedMessage,
      maxAllowedFreeThemePacksMessage
    },
    modalForm: { fieldRequiredMessage, fieldLessThanTwo },
    quoteSummary: {
      secureBusinessPackages: { smartCamera, Monitor, Protect, Control },
      products: {
        officeInternetCopper,
        officeInternetFiber,
        secureBusiness,
        officePhone,
        telusOptikTv,
        telusBusinessWifi
      }
    },
    smartCameraErrorMessage,
    MESSAGES: { ERROR }
  } = translations;

  const {
    KEYS: {
      CHANNELS: {
        TAG_BC,
        TAG_AB,
        ELITE_PROMOTIONS_AND_MARKETING_INC,
        EVOLUTION_CLOUD_INC,
        INSTINCTIVE_BUSINESS_TECHNOLOGY_INC,
        TECH23_SOLUTIONS_INC,
        OUTPUT_INC
      }
    }
  } = CONSTANT;

  if (!stepData) return null;
  const {
    fields: {
      name: formStepName,
      backendKey: formStepBackendKey,
      image,
      formStepFields,
      formSummary,
      showTotal,
      modalForms
    }
  } = stepData;

  const [disableContinue, setdisableContinue] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [movingToStep2, setMovingToStep2] = useState(false);
  const [isFormTouched, setIsFormTouched] = useState(false);
  const [isFormValidated, setIsFormValidated] = useState(false);
  const [isChannelTISales, setIsChannelTISales] = useState(false);
  const [formFields, setFormFields] = useState({});
  const [defaultFormFields, setDefaultFormFields] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [sections, setSections] = useState([]);
  const [dueNow, setDueNow] = useState(0);
  const [dueMonthly, setDueMonthly] = useState(0);
  const [fieldsWithValue, setFieldsWithValue] = useState();
  const [officePhoneRequired, setOfficePhoneRequired] = useState(false);
  const [rates, setRates] = useState(initialRates);
  const [isEligible, setIsEligible] = useState(false);
  const [redeemOfferData, setRedeemOfferData] = useState();
  const [codeBasedPromotions, setCodeBasedPromotions] = useState();
  const [modalData, setModalData] = useState({
    title: '',
    body: '',
    confirmText: confirmButtonLabel,
    cancelText: cancelButtinLabel,
    open: false
  });
  const [isAlert, setIsAlertOpen] = useState(false);
  const [bodyText, setBodyText] = useState('');
  const formStepRef = createRef();
  const [equipmentTotalPrice, setEquipmentTotalPrice] = useState(initEquipmentPrices);
  const [installationFeeDiscountAmount, setInstallationFeeDiscountAmount] = useState(0);
  const [isInstallationFeeDiscount, setIsInstallationFeeDiscount] = useState(false);
  const [twentyDollarsDiscountAmount, setTwentyDollarsDiscountAmount] = useState(0); // It is applied by default
  const [isTwentyDollarsDiscountAmount, setIsTwentyDollarsDiscountAmount] = useState(true);
  const [hardwareDiscountAmount, setHardwareDiscountAmount] = useState(0);
  const [isHardwareDiscount, setIsHardwareDiscount] = useState(false);
  const { channel, channels = [] } = (typeof profile !== 'undefined' && profile) || {};
  const { province, provinces = [] } = (typeof profile !== 'undefined' && profile) || {};
  const { role, outlet } = (typeof profile !== 'undefined' && profile) || {};
  const { name: userChannelName } = channel || {};
  const userProvince  = province || {};
  const [hideBackButton, setHideBackButton] = useState(false);
  const hidePricing = formName === orderDetailsForm;
  const [initialPricingUpdate, setInitialPricingUpdate] = useState(true);
  const [resetQualificationFields, setResetQualificationFields] = useState(false);
  const [internetTypeoptions, setInternetTypeoptions] = useState(null);
  const [isFieldReset, setIsFieldReset] = useState(false);
  const [firstTotalCalculation, setFirstTotalCalculation] = useState([]);
  const [renderTempSensor,setRenderTempSensor] = useState(false);

  let hardStop = false;

  useEffect(() => {
    if (
      formFields &&
      formFields.emergencyContactDetails &&
      orderData &&
      orderData.emergencyContactDetails
    ) {
      formFields.emergencyContactDetails[0].firstName_emergencyContactDetails =
        orderData.emergencyContactDetails[0].firstName_emergencyContactDetails;

      formFields.emergencyContactDetails[0].lastName_emergencyContactDetails =
        orderData.emergencyContactDetails[0].lastName_emergencyContactDetails;

      formFields.emergencyContactDetails[0].positionOrTitle_emergencyContactDetails =
        orderData.emergencyContactDetails[0].positionOrTitle_emergencyContactDetails;

      formFields.emergencyContactDetails[0].premiseContactNumber_emergencyContactDetails =
        orderData.emergencyContactDetails[0].premiseContactNumber_emergencyContactDetails;

      formFields.emergencyContactDetails[0].telephoneNumber1_emergencyContactDetails =
        orderData.emergencyContactDetails[0].telephoneNumber1_emergencyContactDetails;

      formFields.emergencyContactDetails[0].extension_emergencyContactDetails =
        orderData.emergencyContactDetails[0].extension_emergencyContactDetails;

      formFields.emergencyContactDetails[0].telephoneNumber2_emergencyContactDetails =
        orderData.emergencyContactDetails[0].telephoneNumber2_emergencyContactDetails;
    }
  }, [orderData, isLoading]);

  useEffect(() => {
    if (orderData.parsedProvince) {
      localStorage.setItem(storageItemProvince, orderData.parsedProvince);
    }
  }, [orderData]);

  useEffect(() => {
    const productIndex = steps.findIndex((el) => (
      el.fields.backendKey === valueProductInformation ||
      el.fields.backendKey === keyOrderCustomerInformation
    ));
    if (productIndex > -1 && step > 0) {
      const shouldHide = step - 1 > productIndex;
      if (shouldHide !== hideBackButton) setHideBackButton(shouldHide);
    }
    window.scrollTo(0, 0);
  }, [step]);

  useEffect(() => {
    if (equipmentTotalPrice.willUpdate) {
      return;
    }

    let updatedDueMonthly = dueMonthly + equipmentTotalPrice.addAmountToMonthly - equipmentTotalPrice.subtractAmountFromMonthly + equipmentTotalPrice.addAmountToFiveYearMonthly - equipmentTotalPrice.subtractAmountFromFiveYearMonthly;
    let updateAmount = dueNow - equipmentTotalPrice.subtractAmountFromPrice + equipmentTotalPrice.addAmountToPrice;
    if (isHardwareDiscount) updateAmount -= hardwareDiscountAmount;
    // Waived Installation Fee
    const discountAmount = calcInstallationFeeDiscount(formFields);
    if (discountAmount !== installationFeeDiscountAmount && discountAmount !== undefined && updateAmount) {
      updateAmount += installationFeeDiscountAmount - discountAmount;
      setInstallationFeeDiscountAmount(discountAmount);
      setIsInstallationFeeDiscount(false);
    } else if (isInstallationFeeDiscount && installationFeeDiscountAmount && updateAmount) {
      updateAmount -= updateAmount >= installationFeeDiscountAmount
        ? installationFeeDiscountAmount
        : 0;
      setIsInstallationFeeDiscount(false);
    }
    // $20 Monthly offer
    if (isTwentyDollarsDiscountAmount && twentyDollarsDiscountAmount && updatedDueMonthly) {
      updatedDueMonthly -= updatedDueMonthly >= twentyDollarsDiscountAmount
        ? twentyDollarsDiscountAmount
        : 0;
      setIsTwentyDollarsDiscountAmount(false);
    }
    if (dueMonthly !== updatedDueMonthly) setDueMonthly(updatedDueMonthly);
    if (dueNow !== updateAmount) setDueNow(updateAmount);
  }, [equipmentTotalPrice]);

  const getDefaultValue = (key, value) => {
    if (
      isEditing &&
      orderData &&
      key === existingConnection &&
      orderData.existingConnection
    ) {
      orderData.existingConnection =
        existingConnectionMapping[orderData.existingConnection];
      return orderData.existingConnection;
    }
    if (
      isEditing &&
      orderData &&
      key === telusUpgrade &&
      orderData.telusUpgrade
    ) {
      orderData.telusUpgrade = telusUpgradeMapping[orderData.telusUpgrade];
      return orderData.telusUpgrade;
    }
    if (isEditing && orderData) return orderData[key];
    return value || '';
  };

  const normalizedFields = (data, initFields) => {
    let result = initFields;
    if (data) {
      data.forEach(item => {
        const { sys, fields } = item;
        const {
          name,
          type,
          required,
          value,
          minValue,
          maxValue,
          minLength,
          maxLength,
          price,
          monthlyPayment,
          fiveYearEasyPayment,
          options,
          tooltip,
          noteAppearsBelowField,
          resetFields,
          customResetFields
        } = fields;
        const {
          contentType: {
            sys: { id }
          }
        } = sys;
        const key = name;
        const ref = createRef();
        let data1;
        if (Array.isArray(fields.formStepFields && fields.easyPaymentFields && fields.fiveYearEasyPaymentFields)) {
          data1 = [...fields.formStepFields, ...fields.easyPaymentFields, ...fields.fiveYearEasyPaymentFields];
        } else {
          data1 = fields.formStepFields;
        }
        const equipmentGroupData = { data: data1, isEditing, orderData, key };
        if (id === formFieldsGroup) {
          result = normalizedFields(fields.fields, result);
        } else if (id === formSection) {
          result = normalizedFields(fields.formFields, result);
        } else if (id === userDetailsKey) {
          result = normalizedFields(fields.formStepFields, result);
        } else if (id === equipmentGroupSectionKey) {
          const formObjectKeys = normalizeEquipmentGroupSection(
            equipmentGroupData
          );
          result[key] = formObjectKeys;
        } else if (id === repeatedFormKey) {
          if (fields.key === keyTelusOptikTvAdditionalSetTopBoxes) {
            if (orderData && orderData[fields.key])
              result[fields.key] = orderData[fields.key];
            else result[fields.key] = [];
          } else {
            const formObjectKeys = fields.formFields.reduce(
              (acc, { fields: { name: formNameKey, value: defaultValue } }) => {
                acc[formNameKey] = defaultValue;
                return acc;
              },
              {}
            );
            result[fields.key] = [formObjectKeys];
          }
        } else if (!Object.prototype.hasOwnProperty.call(result, key)) {
          const defaultValue = getDefaultValue(key, value);
          let updatedMonthlyPayment = monthlyPayment;
          let updatedFiveYearMonthlyPayment = fiveYearEasyPayment;
          let updatedPrice = price;

          if (['Select', 'Radio'].includes(type)) {
            if (options && defaultValue) {
              const currentOption = options.find(
                o => o.fields.value === defaultValue
              );

              if (typeof currentOption !== 'undefined') {
                updatedPrice = currentOption.fields.price;
                updatedMonthlyPayment = currentOption.fields.monthlyPayment;
                updatedFiveYearMonthlyPayment = currentOption.fields.fiveYearEasyPayment;
              }
            }
          }

          if (type === typeMultiCheckbox) {
            if (defaultValue && defaultValue.length > 0 && options) {
              const updateDefaultValue =
                typeof defaultValue === 'string'
                  ? defaultValue.split(',')
                  : defaultValue;
              const mappedValues = updateDefaultValue.reduce(
                (ac, a) => ({ ...ac, [a]: true }),
                {}
              );
              updatedPrice = options.reduce(
                (ac, a) =>
                  ac + ((mappedValues[a.fields.value] && a.fields.price) || 0),
                0
              );
              updatedMonthlyPayment = options.reduce(
                (ac, a) =>
                  ac +
                  ((mappedValues[a.fields.value] && a.fields.monthlyPayment) ||
                    0),
                0
              );
              updatedFiveYearMonthlyPayment = options.reduce(
                (ac, a) =>
                  ac +
                  ((mappedValues[a.fields.value] && a.fields.fiveYearEasyPayment) ||
                    0),
                0
              );
            }
          }

          result[key] = {
            name,
            ref,
            type,
            value: defaultValue || value,
            initPrice: updatedPrice || 0,
            price: updatedPrice || 0,
            initMonthlyPayment: updatedMonthlyPayment || 0,
            monthlyPayment: updatedMonthlyPayment || 0,
            initFiveYearMonthlyPayment : updatedFiveYearMonthlyPayment || 0,
            fiveYearEasyPayment : updatedFiveYearMonthlyPayment || 0,
            minValue,
            maxValue,
            minLength,
            maxLength,
            isRequired: required || false,
            isVisible: true,
            options,
            tooltip,
            noteAppearsBelowField
          };

          if (resetFields) {
            result[key].resetFields = resetFields;
          }

          if (customResetFields) {
            result[key].customResetFields = customResetFields;
          }

          if (type === 'Checkbox') {
            result[key].checked = defaultValue;
          }

          if (
            type === 'PlusMinusInput' &&
            defaultValue === undefined &&
            value
          ) {
            result[key].value = value;
          }
        }
        /**
         * Update 'whatSubjectWouldYouLikeToDisplayOnTheQuote' form field value when locale changes
         * and no order data is sent to API, otherwise load order data from API
         */
        if (
          key === fieldWhatSubjectWouldYouLikeToDisplayOnTheQuote &&
          (Object.keys(orderData).length === 0 || !orderData)
        ) {
          result[key].value = value;
        }
      });
    }

    return result;
  };

  const formSections = formStepFields.filter(({ sys }) => {
    const {
      contentType: {
        sys: { id }
      }
    } = sys;
    return id === formSection;
  });

  const getHiddenSections = fields => {
    const hiddenSections = [];

    formSections.forEach(section => {
      const {
        fields: { name: sectionName }
      } = section;
      if (
        !isRelatedFieldExisted(section.fields, fields, orderData, isFormTouched)
      ) {
        hiddenSections.push(sectionName);
      }
    });

    return hiddenSections;
  };

  const updateSections = updatedSections => {
    let newSections = [...formSections];
    updatedSections.forEach(item => {
      newSections = newSections.filter(section => section.fields.name !== item);
    });
    setSections(newSections);
  };

  const calcInitialEquipmentPrice = fields => {
    const { additionalEquipmentKeys } = secureBusinessFields;
    const fieldTelusSecureBusinessSecurityPackageValue = getFieldValue(
      fieldTelusSecureBusinessSecurityPackage,
      fields
    );
    const smartCameraOffersValue = getFieldValue(
      fieldSmartCameraOffers,
      fields
    );
    const secureBusinessOffersValue = getFieldValue(
      fieldSecureBusinessOffers,
      fields
    );
    const equipmentSectionKey = additionalEquipmentKeys[fieldTelusSecureBusinessSecurityPackageValue];
    const formObjectKeys = { ...fields[equipmentSectionKey] };

    if (isEditing && orderData && orderData[equipmentSectionKey]) {
      const equipmentSectionPrice = Object.keys(formObjectKeys).reduce(
        (acc, kc) => {
          const {
            isVisible,
            price: optionPrice,
            name: productKey
          } = formObjectKeys[kc];
          let sum = acc;
          if (isVisible && orderData[equipmentSectionKey][productKey]) {
            sum +=
              parseInt(orderData[equipmentSectionKey][productKey] || 0, 10) *
              parseInt(optionPrice || 0, 10);
          }
          return sum;
        },
        0
      );
      const equipmentSectionMonthlyTotal = Object.keys(formObjectKeys).reduce(
        (acc, kc) => {
          const {
            isVisible,
            monthlyPayment: optionPrice,
            name: productKey
          } = formObjectKeys[kc];
          let sum = acc;
          if (isVisible && orderData[equipmentSectionKey][productKey]) {
            sum +=
              parseInt(orderData[equipmentSectionKey][productKey] || 0, 10) *
              parseInt(optionPrice || 0, 10);
          }
          return sum;
        },
        0
      );
      const equipmentSectionFiveYearMonthlyTotal = Object.keys(formObjectKeys).reduce(
        (acc, kc) => {
          const {
            isVisible,
            fiveYearEasyPayment: optionPrice,
            name: productKey
          } = formObjectKeys[kc];
          let sum = acc;
          if (isVisible && orderData[equipmentSectionKey][productKey]) {
            sum +=
              parseInt(orderData[equipmentSectionKey][productKey] || 0, 10) *
              parseInt(optionPrice || 0, 10);
          }
          return sum;
        },
        0
      );

      // Hardware Credit
      if ((secureBusinessOffersValue || []).includes(hardwareCredit))
        setIsHardwareDiscount(true);

      let discountAmount = 0;
      if (equipmentSectionPrice >= 200) {
        discountAmount = 200;
      } else if (equipmentSectionPrice > 0) {
        discountAmount = equipmentSectionPrice;
      }
      setHardwareDiscountAmount(discountAmount);

      if (equipmentSectionPrice > 0) {
        const currentPrice = equipmentTotalPrice.addAmountToPrice;
        const newPrice = currentPrice + equipmentSectionPrice;
        const currentMonthlyTotal = equipmentTotalPrice.addAmountToMonthly;
        const newMonthlyTotal = currentMonthlyTotal + equipmentSectionMonthlyTotal;
        const currentFiveYearMonthlyTotal = equipmentTotalPrice.addAmountToFiveYearMonthly;
        const newFiveYearMonthlyPayment = currentFiveYearMonthlyTotal + equipmentSectionFiveYearMonthlyTotal;
        setEquipmentTotalPrice({
          subtractAmountFromPrice: currentPrice,
          addAmountToPrice: newPrice,
          addAmountToMonthly: newMonthlyTotal,
          subtractAmountFromMonthly: currentMonthlyTotal,
          addAmountToFiveYearMonthly: newFiveYearMonthlyPayment,
          subtractAmountFromFiveYearMonthly: currentFiveYearMonthlyTotal,
          willUpdate: true
        });
      }
    }
  };

  useEffect(() => {
    if (
      (!isEditing && formStepFields) ||
      (isEditing && orderData && orderData.id)
    ) {
      const updatedFields = normalizedFields(formStepFields, formFields);
      calcInitialEquipmentPrice(updatedFields);
      setFormFields(updatedFields);
      setDefaultFormFields(updatedFields);
      updateSections(getHiddenSections(updatedFields));
      if (movingToStep2) {
        setMovingToStep2(false);
        if (formStepBackendKey === BACKEND_KEYS.productInformation) {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
      setIsFormTouched(false);
      if (formStepRef && formStepRef.current)
        formStepRef.current.scrollTo(0, 0);
    }
  }, [formStepFields, orderData, locale]);

  const open = sections.reduce((acc, section) => {
    const {
      fields: { name, isPanelInitiallyOpen, formFields: sectionFields }
    } = section;

    if (isPanelInitiallyOpen) {
      acc.push(name);
    } else if (sectionFields) {
      const isErrors = sectionFields.find(item => {
        const {
          fields: { name: itemName }
        } = item;
        return formErrors[itemName];
      });
      if (typeof isErrors !== 'undefined') acc.push(name);
    }

    return acc;
  }, []);

  const sectionIsVisible = name =>
    typeof sections.find(item => item.fields.name === name) !== 'undefined';

  const getRepeatedFormErrors = (contentfulFields, formValues) => {
    const fields =
      contentfulFields &&
      contentfulFields.filter(
        ({ fields: content }) => content.required || content.fieldValidation
      );
    return (
      formValues &&
      Object.values(formValues).filter(formValue => {
        let filteredValues = fields.filter(
          ({ fields: { name: formKeyValue } }, index) => {
            return (
              !formValue[formKeyValue] || fields[index].fields.fieldValidation
            );
          }
        );
        if (!telusSecureBusinessSelection) {
          const removeUnnecessaryFeildsFromErrors =
            fields &&
            fields.filter(
              item =>
                item.fields.name &&
                item.fields.name.split('_')[1] !== fieldEmergencyContactDetails
            );
          filteredValues = removeUnnecessaryFeildsFromErrors;
        }
        if (!(orderData.serviceAddress && hasQuebecInAddress(orderData.serviceAddress))) {
          const removeUnnecessaryFeildsFromErrors =
            filteredValues &&
            filteredValues.filter(item => {
              return (
                item.fields.name &&
                item.fields.name.split('_')[0] !==
                'preferredLanguageOfContact' &&
                item.fields.name.split('_')[0] !==
                'preferredLanguageOfContactOne' &&
                item.fields.name.split('_')[0] !==
                'preferredLanguageOfContactTwo'
              );
            });
          filteredValues = removeUnnecessaryFeildsFromErrors;
        }
        const removeValidationErrors =
          filteredValues &&
          filteredValues.filter(item => {
            if (item.fields.fieldValidation) {
              if (
                item.fields.fieldValidation.fields.logic &&
                item.fields.fieldValidation.fields.logic === 'regex'
              ) {
                const regex = new RegExp(
                  item.fields.fieldValidation.fields.value
                );
                if (
                  (!winbackPrefferedInstallationNoteProvinces.includes(
                      request.getProvince()
                    ) &&
                    item.fields.name ===
                    fieldEmergencyPremiseContactNumberNonRepeated) ||
                  !item.fields.name ===
                  fieldEmergencyPremiseContactNumberNonRepeated
                ) {
                  if (
                    !regex.test(
                      formFields.emergencyContactDetails[0][item.fields.name]
                    )
                  ) {
                    return item;
                  }
                  if (
                    formFields.emergencyContactDetails[0][item.fields.name]
                      .length > item.fields.maxLength
                  ) {
                    return item;
                  }
                }
              }
            }
            return null;
          });
        filteredValues = removeValidationErrors;
        return filteredValues && filteredValues.length > 0;
      })
    );
  };

  const getAdditionalSetTopBoxErrors = formValues => {
    return (
      formValues &&
      Object.values(formValues).filter(
        ({ telusOptikTvAdditionalSetTopBox: value }) => !value
      )
    );
  };

  const getErrors = (data, errors) => {
    scrollToErrors(errors);
    let result = errors;
    const internetChoice = getFieldValue(fieldProductSelection, formFields);
    const existingConnectionVal = getFieldValue(existingConnection, formFields);
    const telusUpgradeVal = getFieldValue(telusUpgrade, formFields);
    const productType = getFieldValue(fieldProductType, formFields);
    const qualifiedSpeedFibreValue = getFieldValue(
      fieldQualifiedSpeedFibre,
      formFields
    );
    if (!data) return result;

    if (!telusSecureBusinessSelection) {
      Object.keys(errors).forEach(key => {
        if (key.split('_')[1] === fieldSigningAuthorityV) {
          delete errors[key];
        }
      });
    }

    const productSelectionVal = getFieldValue(
      fieldProductSelection,
      formFields
    );
    if (
      productSelectionVal &&
      productSelectionVal.length > 1 &&
      productSelectionVal.includes(keySecureBusiness)
    ) {
      delete result[existingConnection];
      delete result[telusUpgrade];
    }

    if (formStepBackendKey === BACKEND_KEYS.officePhone) return result;
    const getAccumulatedFilesSize = files => {
      const keys = Object.keys(files);
      let size = 0;
      // eslint-disable-next-line no-unused-expressions
      keys.length > 0 &&
      keys.forEach(key => {
        if (files[key]) {
          const [file] = Object.keys(files[key]);
          if (files[key][file] && files[key][file].size) {
            size += files[key][file].size;
          }
        }
      });
      return size;
    };
    data.forEach(({ sys, fields }) => {
      const {
        contentType: {
          sys: { id }
        }
      } = sys;
      const { name: key, type } = fields;
      const {
        value,
        minValue,
        maxValue,
        isRequired,
        isVisible,
        ref,
        minLength,
        maxLength
      } =
      formFields &&
      Object.prototype.hasOwnProperty.call(formFields, key) &&
      formFields[key];
      const { files } = formFields;
      const isLimitedOfferSelected =
        (formFields[fieldLimitedTimeOffer] &&
          formFields[fieldLimitedTimeOffer].value &&
          formFields[fieldLimitedTimeOffer].value.length) ||
        (formFields[fieldLimitedTimeBasicOffer] &&
          formFields[fieldLimitedTimeBasicOffer].value &&
          formFields[fieldLimitedTimeBasicOffer].value.length);
      if (key === fieldSecureBusinessOffers) {
        const selectedSecureBusinessOffers = _.get(formFields, `${fieldSecureBusinessOffers}.value`, []);

        // Check if both $100 and $199 off installation are selected
        const is$100Selected = selectedSecureBusinessOffers.includes($100offInstallation);
        const is$199Selected = selectedSecureBusinessOffers.includes($199offInstallation);

        // If both offers are selected, show error message
        if (is$100Selected && is$199Selected) {
          result[key] = {
            text: '$100 off installation cannot be combined with $199 off installation',
            ref: key
          };
          return;
        }
      }
      if (
        [fieldRegularMonthlyOffers, fieldRegularYearlyOffers].includes(key) &&
        isLimitedOfferSelected
      ) {
        formFields[key].isRequired = false;
      }
      if (
        id === formFieldsGroup &&
        isRelatedFieldExisted(fields, formFields, orderData, isFormTouched)
      ) {
        result = getErrors(fields.fields, result);
      } else if (id === formSection && sectionIsVisible(key)) {
        result = getErrors(fields.formFields, result);
      } else if (id === userDetailsKey) {
        result = getErrors(fields.formStepFields, result);
      } else if (id === equipmentGroupSectionKey) {
        result = getErrors(fields.formStepFields, result);
      } else if (id === repeatedFormKey) {
        const repeatedFormErrors =
          key === keyTelusOptikTvAdditionalSetTopBoxes
            ? getAdditionalSetTopBoxErrors(formFields[fields.key])
            : getRepeatedFormErrors(
              fields && fields.formFields,
              formFields && formFields[fields.key]
            );
        if (repeatedFormErrors && repeatedFormErrors.length) {
          result[fields.key] = repeatedFormErrors;
        } else {
          delete result[fields.key];
        }
      } else if (isVisible) {
        if (isRequired) {
          let fieldValue = value;
          if (type === typeMultiCheckbox) {
            const multiCheckboxValue = getFieldValue(key, formFields);
            fieldValue = multiCheckboxValue && multiCheckboxValue.length > 0;
          }
          if (
            !fieldValue &&
            isRelatedFieldExisted(fields, formFields, orderData, isFormTouched)
          ) {
            if (!(type === typeCheckbox && formFields[key].checked)) {
              result[key] = {
                text: fieldRequiredMessage,
                ref
              };
            } else {
              delete result[key];
            }
          } else {
            delete result[key];
          }
        }
        if (typeof minValue !== 'undefined' && parseFloat(value) < minValue) {
          result[key] = {
            text: msgDisplay(minValue, minValueErrorMessage),
            ref
          };
        }
        if (typeof maxValue !== 'undefined' && parseFloat(value) > maxValue) {
          result[key] = {
            text: msgDisplay(maxValue, maxValueErrorMessage),
            ref
          };
        }
        if (minLength && value && value.length < minLength) {
          result[key] = {
            text: msgDisplay(minLength, minLengthErrorMessage),
            ref
          };
        }
        if (maxLength && value && value.length > maxLength) {
          result[key] = {
            text: msgDisplay(maxLength, maxLengthErrorMessage),
            ref
          };
        }
        if (!sourceOfChannelsList.includes(userChannelName)) {
          delete result[feildSourceOfSale];
        }
        if (type === inputTypeFile && files) {
          if (getAccumulatedFilesSize(files) > maxUploadSizeValue) {
            result[keyFileSizeExceeded] = {
              text: maxUploadSizeErrorMessage,
              ref
            };
          } else {
            delete result[keyFileSizeExceeded];
          }
        }
        if (
          internetChoice &&
          internetChoice.includes(keySecureBusiness) &&
          existingConnectionVal === existingConnectionYes &&
          telusUpgradeVal === telusNo
        ) {
          delete result[existingInternetProvider];
        }
        if (
          !(
            orderData.productType === fieldBetterBusinessBundleFibre ||
            _.get(orderData, 'productSelection', []).includes(fieldFiberInternet)
          )
        ) {
          delete result[fieldGisId];
        }
        if (
          productType === fieldBetterBusinessBundleFibre ||
          productType === feildBetterBusinessBundleCopper
        ) {
          delete result[telusUpgrade];
          delete result[existingConnection];
        }
        if (
          internetChoice &&
          internetChoice.length > 1 &&
          internetChoice.includes(keySecureBusiness)
        ) {
          delete result[telusUpgrade];
        }

        // custom required logic in the offers on the basis of package selection
        if (telusSecureBusinessSelection) {
          const isSelected = getFieldValue(
            fieldTelusSecureBusinessSecurityPackage,
            formFields
          );
          if (isSelected === smartCameraKey) {
            const smartCameraEquipments = formFields[keySmartCameraIncludedEquipment];
            let isError = true;
            Object.keys(smartCameraEquipments).forEach(eKey => {
              if (
                smartCameraEquipments[eKey].value &&
                smartCameraEquipments[eKey].value !== '0'
              ) {
                isError = false;
              }
            });
            if (isError) {
              result[keySmartCameraIncludedEquipment] = {
                text: ERROR,
                ref
              };
            } else {
              delete result[keySmartCameraIncludedEquipment];
            }
          }
          if (isSelected === fieldProtect) {
            const protectIncludedEquipement = formFields[keyProtectIncludedEquipmentSelection];
            let isError = true;
            Object.keys(protectIncludedEquipement).forEach(eKey => {
              if (
                protectIncludedEquipement[eKey].value &&
                protectIncludedEquipement[eKey].value !== '0'
              ) {
                isError = false;
              }
            });
            if (isError) {
              result[keyProtectIncludedEquipmentSelection] = {
                text: ERROR,
                ref
              };
            } else {
              delete result[keyProtectIncludedEquipmentSelection];
            }
          }
          if (isSelected === fieldControl) {
            const controlIncludedEquipmentSelection = formFields[keyControlIncludedEquipmentSelection];
            let selectedValueCount = 0;
            Object.keys(controlIncludedEquipmentSelection).forEach(eKey => {
              if (
                controlIncludedEquipmentSelection[eKey].value &&
                controlIncludedEquipmentSelection[eKey].value !== '0'
              ) {
                if (
                  !(controlIncludedEquipmentSelection[eKey].name === poeSwitch)
                ) {
                  selectedValueCount += Number(
                    controlIncludedEquipmentSelection[eKey].value
                  );
                }
              }
            });
            if (selectedValueCount < 2) {
              result[keyControlIncludedEquipmentSelection] = {
                text: fieldLessThanTwo,
                ref
              };
            } else {
              delete result[keyControlIncludedEquipmentSelection];
            }
          }
        }

        if (fields.fieldValidation && fields.fieldValidation.fields) {
          if (
            typeof fields.appearsAfterField === 'undefined' ||
            (typeof fields.appearsAfterField !== 'undefined' &&
              isRelatedFieldExisted(
                fields,
                formFields,
                orderData,
                isFormTouched
              ))
          ) {
            const {
              errorMessage,
              logic,
              value: expectedValue
            } = fields.fieldValidation.fields;
            let hasError = false;
            switch (logic) {
              case 'equal':
                // eslint-disable-next-line eqeqeq
                hasError = !expectedValue.split('|').includes(value);
                break;
              case 'regex':
              {
                const regexLogic = new RegExp(expectedValue);
                hasError = !regexLogic.test(value);
              }
                break;
              case 'gt':
                hasError = parseInt(value, 10) < parseInt(expectedValue, 10);
                break;
              case 'gte':
                hasError = parseInt(value, 10) <= parseInt(expectedValue, 10);
                break;
              case 'lt':
                hasError = parseInt(value, 10) < parseInt(expectedValue, 10);
                break;
              default:
            }
            if (hasError)
              result[key] = {
                text: errorMessage,
                ref
              };
          }
        }
      }
      const {
        businessLegalName // eslint-disable-line
      } = secureBusinessLegalNameFieldTypes;
      if (fields.name === businessLegalName) {
        const tempValue = getFieldValue(businessType, formFields);
        if (
          tempValue === valueNonProfitOrgs ||
          tempValue === valueBusinessPersonal
        ) {
          delete result[businessLegalName];
        }
      }
      if (
        !localStorage.getItem('province') &&
        fields.name === fieldKeyAddress
      ) {
        result[fieldKeyAddress] = {
          text: serviceAddressError
        };
      } else if (
        localStorage.getItem('province') &&
        fields.name === fieldKeyAddress
      ) {
        delete result[fieldKeyAddress];
      }
      if (!_.get(orderData, 'productSelection', []).includes(internetFibre)
        && fields.name === fieldObdOrder) {
        delete result[fieldObdOrder];
      }
      // 613
      const orderTypeValue = getFieldValue(fieldOrderType, formFields);
      if (fields.name === fieldWinbackFibre
        && orderTypeValue !== valueNewTelusBusinessOrder) {
        delete result[fieldWinbackFibre];
      }
      // 603
      const selectProvince = window.localStorage.getItem(storageItemProvince);
      if (fields.name === fieldPrefieldPreferredArrivalWindow) {
        if (
          _.get(orderData, 'productSelection', []).includes(keySecureBusiness)
        ) {
          if (
            !(
              getFieldValue(
                fieldTelusSecureBusinessSecurityPackage,
                formFields
              ) === valueProtect ||
              getFieldValue(
                fieldTelusSecureBusinessSecurityPackage,
                formFields
              ) === valueControl
            )
          ) {
            delete result[fields.name];
          }
        } else if (
          !(
            orderData.productSelection.length > 1 &&
            _.get(orderData, 'productSelection', []).includes(internetFibre)
          )
        ) {
          delete result[fields.name];
        }
      }
      if (
        fields.name === fieldInstallationPreferredArrivalWindow &&
        !nonRoSProvinces.includes(selectProvince)
      ) {
        delete result[fields.name];
      }
      if (tsbInstallDateFields.includes(fields.name)) {
        if (!_.get(orderData, 'productSelection', []).includes(keySecureBusiness)
          || nonRoSProvinces.includes(selectProvince)) {
          delete result[fields.name];
        }
      }
      if (fields.name === existingConnection
        && !getFieldValue(fieldProductSelection, formFields).includes(secureBusiness)) {
        delete result[existingConnection];
      }
      // Remove Wifi error if field is hidden
      if (
        fields.name === telusPublicWifiFibre &&
        qualifiedSpeedFibreValue === valueQualifiedSpeed15gFibre
      ) {
        delete result[telusPublicWifiFibre];
      }
      if (
        fields.name === telusPublicWifiFibre &&
        qualifiedSpeedFibreValue === valueQualifiedSpeed3gFibre
      ) {
        delete result[telusPublicWifiFibre];
      }
      if (
        fields.name === fieldRegularYearlyOffersFibre &&
        qualifiedSpeedFibreValue === mbps15
      ) {
        delete result[fieldRegularYearlyOffersFibre];
      }
      // remove error if fieldCustomerRequestFibre3G field is hidden and
      // role equals SALES_REP
      if (
        fields.name === fieldCustomerRequestFibre3G &&
        role.name === ROLES.SALES_REP
      ) {
        delete result[fieldCustomerRequestFibre3G];
      }
      if (fields.name === fieldCustomerRequestFibre3G) {
        const {
          British_Columbia: bColumbiaProvince,
          Alberta: albertaProvince
        } = provinceAlias;
        // if province in address is Alberta or British Columbia then show error
        // else remove error
        if ([albertaProvince, bColumbiaProvince].includes(localStorage.getItem('province'))) {
          // console.log('SHOW ERROR')
        } else {
          delete result[fieldCustomerRequestFibre3G];
        }
      }
      // remove Copper Promos error if 36 Month Term option is selected
      const valueTermCopper = getFieldValue(fieldTerm, formFields);
      if (
        fields.name === fiveYearlyCopperPromos &&
        valueTermCopper !== _valueTerm60Month
      ) {
        delete result[fiveYearlyCopperPromos];
      }
      // remove Fibre Promos error if 36 Month Term option is selected
      const valueTermFibre = getFieldValue(fieldTermFibre, formFields);
      if (
        fields.name === fiveYearlyFibrePromos &&
        valueTermFibre !== _valueTerm60Month
      ) {
        delete result[fiveYearlyFibrePromos];
      }
      if (
        fields.name === fiveYearlyFibrePromos &&
        valueTermFibre === _valueTerm60Month &&
        (qualifiedSpeedFibreValue === valueQualifiedSpeed750mbps ||
          qualifiedSpeedFibreValue === valueQualifiedSpeed15mbps)
      ) {
        delete result[fiveYearlyFibrePromos];
      }
    });
    let selectProvince = window.localStorage.getItem(storageItemProvince);
    if (!nonRoSProvinces.includes(selectProvince)) {
      delete result[telusUpgrade];
    } else {
      delete result[fieldExistingInternetProviderRoC];
    }
    /**
     * Hide Forbearance for province other than Alberta, British Columbia
     */
    const prvSelected = parseProvince(orderData.serviceAddress);

    const {
      British_Columbia: bColumbiaProvince,
      Alberta: albertaProvince
    } = provinceAlias;
    if (
      !(prvSelected === albertaProvince || prvSelected === bColumbiaProvince)
    ) {
      delete result[fieldForbearance];
    }
    /**
     Hide wirelineSecondaryInstallDate and wirelinePreferedInstallDate
     if product selection includes only secureBusiness
     */
    const valueTelusPublicWifiFibre = getFieldValue(
      telusPublicWifiFibre,
      formFields
    );
    const valueTelusBusinessWifi = getFieldValue(
      fieldTelusBusinessWifi,
      formFields
    );
    const valuePublicWifiCopper = getFieldValue('publicWifi', formFields);
    if (formStepBackendKey === BACKEND_KEYS.officeInternetFiber) {
      if (valueTelusPublicWifiFibre && valueTelusPublicWifiFibre === yes) {
        delete result[numberTelusWifiAccessPointsFibre];
        delete result[fieldTelusBusinessWifi];
        delete result[fieldTelusBusinessWifiTypeFibre];
      }
      if (!(valueTelusBusinessWifi && valueTelusBusinessWifi === yes)) {
        delete result[numberTelusWifiAccessPointsFibre];
        delete result[fieldTelusBusinessWifiTypeFibre];
      }
      if (
        ![
          valueQualifiedSpeed15mbps,
          valueQualifiedSpeed25mbps,
          valueQualifiedSpeed75mbps,
          valueQualifiedSpeed150mbps,
          valueQualifiedSpeed300mbps,
          valueQualifiedSpeed750mbps,
          valueQualifiedSpeed940mbps,
          valueQualifiedSpeed3gFibre,
          mbps3g3000,
          _valueFiveGSpeed,
        ].includes(getFieldValue(fieldQualifiedSpeedFibre, formFields))
      ) {
        delete result[fieldTelusBusinessWifi];
      }
    }
    if (formStepBackendKey === BACKEND_KEYS.officeInternetCopper) {
      if (valuePublicWifiCopper && valuePublicWifiCopper === yes) {
        delete result[numberTelusWifiAccessPointsCopper];
        delete result[fieldTelusBusinessWifi];
        delete result[fieldTelusBusinessWifiTypeCopper];
      }
      if (!(valueTelusBusinessWifi && valueTelusBusinessWifi === yes)) {
        delete result[numberTelusWifiAccessPointsCopper];
        delete result[fieldTelusBusinessWifiTypeCopper];
      }
    }
    const shouldHideWirelineInstallationDates = _.get(orderData, 'productSelection', []).includes(keySecureBusiness);
    if (shouldHideWirelineInstallationDates) {
      delete result[fieldWirelineSecondaryInstallDate];
      delete result[fieldWirelinePreferedInstallDate];
    }

    if (!(orderData.serviceAddress && hasQuebecInAddress(orderData.serviceAddress))) {
      Object.keys(errors).forEach(key => {
        if (key === fieldContractLanguagePreference) {
          delete errors[key];
        }
      });
    }

    if (!_.get(orderData, 'productSelection', []).includes('Secure Business')) {
      Object.keys(errors).forEach(key => {
        if (key === fieldIsThisHomeBasedBusiness) {
          delete errors[key];
        }
        if (key === fieldDoesCustomerHaveLawnOrFenceOnPremise) {
          delete errors[key];
        }
      });
    }
    if (!selectProvince) selectProvince = orderData.parsedProvince;

    const isValidSelection = value => !(Array.isArray(value) && value.includes('Secure Business') && value.length >= 1);
    const productSelectionValuesArr = getFieldValue(
      'productSelection',
      formFields
    );
    if (MM_CHANNELS.includes(userChannelName)) {
      if (isValidSelection(productSelectionValuesArr)) {
        Object.keys(productSelectionValues).forEach(
          item => delete errors[item]
        );
        Object.keys(MM_CHANNELS_FLOW_KEYS).forEach(item => delete errors[item]);
      } else {
        Object.keys(productSelectionValues).forEach(
          item => delete errors[item]
        );
      }
    } else {
      Object.keys(MM_CHANNELS_FLOW_KEYS).forEach(item => delete errors[item]);
    }

    if ([mbps750, mbps3g, mbps3g3000].includes(qualifiedSpeedFibreValue)) {
      delete errors[fiveYearlyFibrePromos];
    }

    // SOF-2191
    if (officePhoneExclusionChannels.includes(userChannelName)) {
      fieldsToHideforNonOptikAndPhoneChannels.forEach(field => {
        delete errors[field];
      });
    } else {
      fieldsToShowforNonOptikAndPhoneChannels.forEach(field => {
        delete errors[field];
      });
    }

    if (
      Array.isArray(orderData.productSelection) &&
      _.get(orderData, 'productSelection', []).includes(nameTelusTVForBusiness)
    ) {
      fieldsToShowforNonOptikAndPhoneChannels.forEach(field => {
        delete errors[field];
      });
    } else {
      fieldsToShowforOptikTV.forEach(field => {
        delete errors[field];
      });
    }

    if (!is7XChannel(userChannelName)) {
      delete result[fieldLeadID];
    }

    if (isSbsTelesalesTiChannel(userChannelName)) {
      setIsChannelTISales(true);
    }

    const valueProductSelection = getFieldValue(
      fieldProductSelection,
      formFields
    );

    const shouldShowWarningNoteSmbTiDigitalFr =
      isChannelSMBDigitalFr(userChannelName) &&
      valueProductSelection &&
      (valueProductSelection.includes(telusBusinessWifi) ||
        valueProductSelection.includes(telusSecureBusiness)) &&
      !valueProductSelection.includes(officeInternetCopper) &&
      !valueProductSelection.includes(officeInternetFiber) &&
      parseProvince(orderData.serviceAddress) !== provinceAlias.Quebec;

    if (shouldShowWarningNoteSmbTiDigitalFr) {
      result[fieldProductSelection] = true;
    }

    return result;
  };

  const saveAndExit = () => {
    const fields = getFormData(formFields);
    const duePrices = {
      dueMonthly,
      dueNow
    };
    if (fields[existingConnection])
      fields[existingConnection] =
        fields[existingConnection] === existingConnectionYes ? yes : no;
    if (fields[telusUpgrade])
      fields[telusUpgrade] = fields[telusUpgrade] === telusYes ? yes : no;
    if (fields[fieldKeyAddress]) {
      const keyAddress = [];
      keyAddress.push(fields[fieldKeyAddress]);
      fields.keyServiceAddresses = keyAddress;
    }
    if (Object.entries(fields).length) {
      onSaveAndExit({ ...fields, ...duePrices });
    }
  };

  const saveAndContinue = async () => {
    const {
      fields: { backendKey: nextStepBackendKey }
    } = progressBarSteps[step] || { fields: {} };
    const currentData = getFormData(
      formFields,
      formStepFields,
      orderData,
      true
    );
    const duePrices = {
      dueMonthly,
      dueNow
    };

    if (currentData[existingConnection])
      currentData[existingConnection] =
        currentData[existingConnection] === existingConnectionYes ? yes : no;
    if (currentData[telusUpgrade])
      currentData[telusUpgrade] =
        currentData[telusUpgrade] === telusYes ? yes : no;
    if (currentData[fieldRegularMonthlyOffersFibre]) {
      currentData[fieldRegularMonthlyOffersFibre] =
        currentData[fieldRegularMonthlyOffersFibre] === standardPricing
          ? standardRateLabel
          : sixTwelvePromo;
    }
    if (currentData[fieldRegularMonthlyOffers]) {
      currentData[fieldRegularMonthlyOffers] =
        currentData[fieldRegularMonthlyOffers] === standardRate
          ? standardRateLabel
          : sixTwelvePromo;
    }
    if (currentData[fieldKeyAddress]) {
      const keyAddress = [];
      keyAddress.push(currentData[fieldKeyAddress]);
      currentData.serviceAddresses = keyAddress;
    }
    if (Object.entries(currentData).length) {
      const newOrderData = await onSaveAndContinue({
        ...currentData,
        ...duePrices,
        isLastQuoteStep: false
      });
      if (
        orderData &&
        isEditing &&
        nextStepBackendKey !== BACKEND_KEYS.quoteSummary
      ) {
        updateStep(step + 1);
        if (step + 1 === 3) window.location.reload();
      }
      if (newOrderData) {
        setOrderData(newOrderData);
      }
    } else if (
      orderData &&
      isEditing &&
      nextStepBackendKey !== BACKEND_KEYS.quoteSummary
    ) {
      updateStep(step + 1);
    }
    if (nextStepBackendKey === BACKEND_KEYS.quoteSummary) updateStep(step + 1);
  };

  const prevStep = e => {
    e.preventDefault();
    setFormErrors({});
    setIsLoading(true);
    updateStep(step - 1);
    const { id: orderID, locale, categoryName, formName } = orderData;
    const searchString = `?orderId=${orderID}&step=${step - 1}&isEditing=true`;
    history.push({
      pathname: `/${locale}/${categoryName}/${formName}`,
      search: searchString
    });
    window.location.reload();
  };

  const nextStep = e => {
    e.preventDefault();
    const errors = getErrors(formStepFields, { ...formErrors });
    if (Object.entries(errors).length === 1 && errors[keyFileSizeExceeded]) {
      alert(maxUploadSizeErrorMessage);
    }
    if (
      Object.entries(errors).length === 1 &&
      errors[keySecurityCameraEquipment]
    ) {
      const text = errors[keySecurityCameraEquipment];
      setIsAlertOpen(true);
      setBodyText(text);
    }
    setFormErrors(errors);
    if (Object.entries(errors).length === 0) {
      if (
        (onFormSubmit && step === steps.length) ||
        formStepBackendKey === BACKEND_KEYS.quoteSummary
      ) {
        const fields = getFormData(formFields, formStepFields, orderData, true);
        if (codeBasedPromotions) {
          setIsFormValidated(true);
          if (orderData) {
            onFormSubmit(
              {
                ...fields,
                redeemOfferData,
                ...codeBasedPromotions,
                dueNow,
                dueMonthly,
                isLastQuoteStep: true
              },
              formStepBackendKey === BACKEND_KEYS.quoteSummary,
              null,
              false
            );
          }
        } else {
          onFormSubmit(
            { ...fields },
            formStepBackendKey === BACKEND_KEYS.quoteSummary,
            null,
            true
          );
        }
      } else if (formStepBackendKey === BACKEND_KEYS.orderSummary) {
        const fields = getFormData(formFields, formStepFields, orderData, true);
        fields.status = orderStatus.validated;
        onFormSubmit({ ...fields }, null, true);
      } else {
        if (formStepBackendKey === BACKEND_KEYS.customerInformation) {
          setMovingToStep2(true);
        }
        setIsLoading(true);
        saveAndContinue();
      }
      const valueInstallation = getFieldValue(
        fieldInstallation,
        formFields
      );
      const valueProdSelection = _.get(orderData, fieldProductSelection, []);
      const currentSearch = new URLSearchParams(history.location.search);
      const currentStepNum = parseInt(currentSearch.get('step') || 0);
      const stepOverCondition = formStepBackendKey === BACKEND_KEYS.optikTv && valueProdSelection.length === 1 && valueProdSelection[0] === telusOptikTv && valueInstallation === selfInstall && formName === 'Order_Details';
      if (currentStepNum !== progressBarSteps.length) {
        let stepOver = 1; // Use 'let' instead of 'const' to allow reassignment
        if (stepOverCondition) {
          stepOver = 2; // Reassign value to stepOver if condition is met
        }
        currentSearch.set('step', parseInt(currentSearch.get('step')) + stepOver);
      }
      history.push({
        search: currentSearch.toString()
      });
      if (stepOverCondition) {
        window.location.reload();
      }
    } else {
      const firstError = errors[Object.keys(errors)[0]];
      const { ref } = firstError;
      if (ref && ref.current) ref.current.focus();
    }
  };

  const isFieldCalculated = (type, value, checked, price) => {
    switch (type) {
      case 'Radio':
        return ((value === yes || value !== undefined) && price) || 0;
      case 'Checkbox':
        return (checked && price) || 0;
      default:
        return (value && price) || 0;
    }
  };

  const updateTotals = (name, field) => {
    const { value, checked, type, price, monthlyPayment,fiveYearEasyPayment, isVisible } = field;

    if (!isVisible) return;

    let oldQuantity;
    let newQuantity;
    let oldPrice;
    let newPrice;

    if (type === 'Number') {
      if (
        firstTotalCalculation.includes(name) ||
        formStepName !== internetCopper
      ) {
        oldQuantity = (formFields[name] && formFields[name].value) || 0;
      } else {
        oldQuantity = 0;
        setFirstTotalCalculation([...firstTotalCalculation, name]);
      }
      newQuantity = value ? Number(value) : 0;
      if (price > 0) {
        oldPrice = price * oldQuantity;
        newPrice = price * newQuantity;
        if (name === fieldTwBasicWifiApAmount) {
          if (oldQuantity === 0 && newQuantity > 0) {
            setDueNow(dueNow + price);
          } else if (oldQuantity > 0 && newQuantity === 0) {
            setDueNow(dueNow - price);
          }
        } else setDueNow(dueNow - oldPrice + newPrice);
      }
      if (monthlyPayment > 0) {
        oldPrice = monthlyPayment * oldQuantity;
        newPrice = monthlyPayment * newQuantity;
        setDueMonthly(dueMonthly - oldPrice + newPrice);
      }
      if (fiveYearEasyPayment > 0) {
        oldPrice = fiveYearEasyPayment * oldQuantity;
        newPrice = monthlyPayment * newQuantity;
        setDueMonthly(fiveYearEasyPayment - oldPrice + newPrice);
      }
    } else if (type === 'Checkbox') {
      oldQuantity = formFields[name] && formFields[name].checked ? 1 : 0;
      newQuantity = checked ? 1 : 0;
      if (price) {
        oldPrice = price * oldQuantity;
        newPrice = price * newQuantity;
        setDueNow(dueNow - oldPrice + newPrice);
      }
      if (monthlyPayment) {
        oldPrice = monthlyPayment * oldQuantity;
        newPrice = monthlyPayment * newQuantity;
        setDueMonthly(dueMonthly - oldPrice + newPrice);
      }
    } else {
      oldQuantity = formFields[name] && formFields[name].value ? 1 : 0;
      newQuantity = value ? 1 : 0;

      if (isFieldCalculated(type, value, checked, price)) {
        oldPrice = price * oldQuantity;
        newPrice = price * newQuantity;
        setDueNow(dueNow - oldPrice + newPrice);
      }
      if (isFieldCalculated(type, value, checked, monthlyPayment)) {
        oldPrice = monthlyPayment * oldQuantity;
        newPrice = monthlyPayment * newQuantity;
        setDueMonthly(dueMonthly - oldPrice + newPrice);
      }
      if (isFieldCalculated(type, value, checked, fiveYearEasyPayment)) {
        oldPrice = fiveYearEasyPayment * oldQuantity;
        newPrice = fiveYearEasyPayment * newQuantity;
        setDueMonthly(dueMonthly - oldPrice + newPrice);
      }
    }
  };

  const checkEligibility = (eligibilityFields, ...rest) => {
    const fieldValues = rest.map(fieldName => getFieldValue(fieldName, eligibilityFields));
    const eligibilityStatus = fieldValues.every(keyValue => keyValue === no);
    setResetQualificationFields(!eligibilityStatus);
    setIsEligible(eligibilityStatus);
  };

  const setEligibility = (
    stepName,
    valueProductSelection,
    valueProductType,
    fieldDetails
  ) => {
    if (
      stepName === productInformation &&
      (!valueProductSelection ||
        (valueProductSelection && valueProductSelection.length === 0))
    )
      setIsEligible(false);

    if (
      (stepName === productInformation &&
        valueProductSelection &&
        valueProductSelection.length &&
        valueProductSelection.includes(secureBusiness)) ||
      [valueProductType].includes(
        betterBusinessBundleCopper,
        betterBusinessBundleFibre
      )
    ) {
      checkEligibility(
        fieldDetails,
        fieldSpecialRetailer,
        fieldHighValueItems,
        fieldBuildingSize,
        fieldEightCameras,
        fieldCamerasInstalled
      );
    } else if (
      formStepName === productInformation &&
      valueProductSelection &&
      valueProductSelection.length &&
      (valueProductSelection.includes(officePhone) ||
        valueProductSelection.includes(telusOptikTv) ||
        valueProductSelection.includes(officeInternetCopper) ||
        valueProductSelection.includes(officeInternetFiber) ||
        valueProductSelection.includes(telusBusinessWifi))
    ) {
      setIsEligible(true);
    } else if (
      formStepName === productInformation &&
      valueProductType === standalone &&
      valueProductSelection &&
      valueProductSelection.length
    ) {
      setIsEligible(true);
    }
  };

  if (formStepBackendKey === BACKEND_KEYS.orderSummaryForm && !isEligible) {
    setIsEligible(true);
  }

  const updateRates = fields => {
    let finalRates;
    if (formStepName === internetCopper) {
      finalRates = calculateOfficeCopperRates(fields, localizedStrings);
    } else if (
      formStepName === internetFibre ||
      formStepName === orderFibreInternet
    ) {
      finalRates = calculateFibreRates(fields, localizedStrings, orderData);
    } else if (
      formStepName === quoteOptikTV ||
      formStepName === orderOptikTV
    ) {
      finalRates = calculateTelusOptikRates(fields);
    }

    return finalRates;
  };

  useEffect(() => {
    if (isEditing && orderData && orderData.id) {
      const updatedFields = normalizedFields(formStepFields, formFields);
      const newRates = updateRates(updatedFields);
      setFormFields(updatedFields);
      if (orderData.dueMonthly || orderData.dueNow) {
        setDueMonthly(orderData.dueMonthly);
        setDueNow(orderData.dueNow);
        setRates(newRates);
      }
    }
  }, [orderData, formStepFields]);

  useEffect(() => {
    setRates(initialRates);
    setDueMonthly(dueMonthly);
    setDueNow(dueNow);
  }, [step]);

  useEffect(() => {
    const newRates = updateRates(formFields);
    const valueProdSelection = _.get(orderData, fieldProductSelection, []);
    if (formFields && newRates) {
      setRates(newRates);
      setDueMonthly(dueMonthly + newRates.addAmountToMonthly - rates.addAmountToMonthly);
      setDueNow((dueNow || 0) + (newRates.addAmountToPrice || 0) - (rates.addAmountToPrice || 0));
    }
    if (valueProdSelection.includes(officeInternetCopper)) {
      const valueQualifiedSpeed = getFieldValue(
        fieldQualifiedSpeed,
        formFields
      );
      const valueTerm = getFieldValue(fieldTerm, formFields);
      const valueStaticIPRequired = getFieldValue(
        fieldStaticIPRequired,
        formFields
      );
      const valueAccessPoints = getFieldValue(
        numberTelusWifiAccessPointsCopper,
        formFields
      ) || 0;

      /**
       * For Copper Internet Basic
       * if term is 36 or 60 then Standalone and Bundled price will be $40
       */
      const isSpeedValid = valueQualifiedSpeed === mbps15;
      const isTermValid = [yearsTerm, fiveYearsTerm].includes(valueTerm);

      if (isSpeedValid && isTermValid) {
        let basePrice = 40;

        if (valueStaticIPRequired === _valueCopperStaticIpSubnet1) {
          basePrice = 52;
        } else if (valueStaticIPRequired === _valueCopperStaticIpSubnet5) {
          basePrice = 60;
        }

        const total = basePrice + valueAccessPoints * 15;
        setDueMonthly(total);
      }
    }
    if (formFields && formStepName === productInformation) {
      const valueProductSelection = getFieldValue(
        fieldProductSelection,
        formFields
      );
      const valueProductType = getFieldValue(fieldProductType, formFields);

      setEligibility(
        formStepName,
        valueProductSelection,
        valueProductType,
        formFields
      );
    }
  }, [formFields, orderData]);

  useEffect(() => {
    if (
      orderData &&
      !orderData.isLastQuoteStep &&
      formStepBackendKey === BACKEND_KEYS.quoteSummary
    ) {
      const defaultValueRO = _.get(orderData, 'redeemOfferData', {});
      const priceRedeemOffer = _.get(
        defaultValueRO,
        'redeemOfferAdjustedTotalPrice',
        {}
      );
      if (priceRedeemOffer.monthlyPrice && !isFormValidated) {
        setDueMonthly(orderData.dueMonthly - priceRedeemOffer.monthlyPrice);
      }
      if (priceRedeemOffer.oneTimePrice && !isFormValidated) {
        setDueNow(orderData.dueMonthly - priceRedeemOffer.oneTimePrice);
      }
    }
  }, [orderData]);

  useEffect(() => {
    if (formFields.telusSecureBusinessSecurityPackage) {
      formFields[keySmartCameraIncludedEquipment] =
        defaultFormFields[keySmartCameraIncludedEquipment];
      formFields[keySecurityCameraEquipment] =
        defaultFormFields[keySecurityCameraEquipment];
      formFields[keyMonitorAdditionalEquipment] =
        defaultFormFields[keyMonitorAdditionalEquipment];
      formFields[keyProtectIncludedEquipmentSelection] =
        defaultFormFields[keyProtectIncludedEquipmentSelection];
      formFields[keyProtectAdditionalEquipment] =
        defaultFormFields[keyProtectAdditionalEquipment];
      formFields[keyControlIncludedEquipmentSelection] =
        defaultFormFields[keyControlIncludedEquipmentSelection];
      formFields[keyControlAdditionalEquipment] =
        defaultFormFields[keyControlAdditionalEquipment];
    }
  }, [
    formFields.telusSecureBusinessSecurityPackage &&
    formFields.telusSecureBusinessSecurityPackage.value
  ]);

  useEffect(() => {
    // Reseting existingconnection & telusUpgrade key when isEligible is false
    if (formStepName === productInformation && resetQualificationFields) {
      const updatedPayload = {};
      Object.keys(secureBusinessResetFields).forEach(resetField => {
        updatedPayload[resetField] = { ...formFields[resetField], value: '' };
      });
      setFormFields({
        ...formFields,
        ...updatedPayload
      });
    }
  }, [resetQualificationFields]);

  const fieldTelusSecureBusinessSecurityPackageValue = getFieldValue(
    fieldTelusSecureBusinessSecurityPackage,
    formFields
  );

  const calculateSecureBusinessRates = newValue => {
    let addAmountToMonthly = 0;
    let subtractAmountFromMonthly = 0;
    let addAmountToNow = 0;
    let subtractAmountFromNow = 0;

    const smartCameraOffersOldValue = getFieldValue(
      fieldSmartCameraOffers,
      formFields
    );
    const secureBusinessOffersOldValue = getFieldValue(
      fieldSecureBusinessOffers,
      formFields
    );
    const secureBusinessPackageMonthlyPrice = getFieldOption(
      'monthlyPayment',
      fieldTelusSecureBusinessSecurityPackage,
      formFields
    );

    const {
      secureBusinessOfferDiscounts
    } = secureBusinessFields;

    if (
      newValue &&
      newValue.includes(threeMonthFree) &&
      (!(secureBusinessOffersOldValue || []).includes(threeMonthFree) ||
        secureBusinessOffersOldValue.length === 0)
    ) {
      let subAmount = secureBusinessPackageMonthlyPrice;
      if (newValue.includes(tenOffMpp))
        subAmount -= secureBusinessOfferDiscounts[tenOffMpp];
      if (newValue.includes(twentyOffMpp))
        subAmount -= secureBusinessOfferDiscounts[twentyOffMpp];
      if (newValue.includes(tenOffWirelene))
        subAmount -= secureBusinessOfferDiscounts[tenOffWirelene];
      if (newValue.includes(twentyOffWireline))
        subAmount -= secureBusinessOfferDiscounts[twentyOffWireline];
      subtractAmountFromMonthly += subAmount < 0 ? 0 : subAmount;
    }

    if (
      newValue &&
      newValue.includes(sixMonthsFree) &&
      (!(secureBusinessOffersOldValue || []).includes(sixMonthsFree) ||
        secureBusinessOffersOldValue.length === 0)
    ) {
      let subAmount = secureBusinessPackageMonthlyPrice;
      if (newValue.includes(tenOffMpp))
        subAmount -= secureBusinessOfferDiscounts[tenOffMpp];
      if (newValue.includes(twentyOffMpp))
        subAmount -= secureBusinessOfferDiscounts[twentyOffMpp];
      if (newValue.includes(tenOffWirelene))
        subAmount -= secureBusinessOfferDiscounts[tenOffWirelene];
      if (newValue.includes(twentyOffWireline))
        subAmount -= secureBusinessOfferDiscounts[twentyOffWireline];
      subtractAmountFromMonthly += subAmount;
    }

    if (
      newValue &&
      newValue.includes(tsbSecurityOffersObject.sixMonthsFreeEn) &&
      (!(secureBusinessOffersOldValue || []).includes(
          tsbSecurityOffersObject.sixMonthsFreeEn
        ) ||
        secureBusinessOffersOldValue.length === 0)
    ) {
      let subAmount = secureBusinessPackageMonthlyPrice;
      if (newValue.includes(tenOffMpp))
        subAmount -= secureBusinessOfferDiscounts[tenOffMpp];
      if (newValue.includes(twentyOffMpp))
        subAmount -= secureBusinessOfferDiscounts[twentyOffMpp];
      if (newValue.includes(tenOffWirelene))
        subAmount -= secureBusinessOfferDiscounts[tenOffWirelene];
      if (newValue.includes(twentyOffWireline))
        subAmount -= secureBusinessOfferDiscounts[twentyOffWireline];
      subtractAmountFromMonthly += subAmount;
    }

    if (
      newValue &&
      (secureBusinessOffersOldValue || []).includes(threeMonthFree) &&
      (!newValue.includes(threeMonthFree) || newValue.length === 0)
    ) {
      let addAmount = secureBusinessPackageMonthlyPrice;
      if (newValue.includes(tenOffMpp))
        addAmount -= secureBusinessOfferDiscounts[tenOffMpp];
      if (newValue.includes(twentyOffMpp))
        addAmount -= secureBusinessOfferDiscounts[twentyOffMpp];
      if (newValue.includes(tenOffWirelene))
        addAmount -= secureBusinessOfferDiscounts[tenOffWirelene];
      if (newValue.includes(twentyOffWireline))
        addAmount -= secureBusinessOfferDiscounts[twentyOffWireline];
      addAmountToMonthly += addAmount < 0 ? 0 : addAmount;
    }

    if (
      newValue &&
      (secureBusinessOffersOldValue || []).includes(sixMonthsFree) &&
      (!newValue.includes(sixMonthsFree) || newValue.length === 0)
    ) {
      let addAmount = secureBusinessPackageMonthlyPrice;
      if (newValue.includes(tenOffMpp))
        addAmount -= secureBusinessOfferDiscounts[tenOffMpp];
      if (newValue.includes(twentyOffMpp))
        addAmount -= secureBusinessOfferDiscounts[twentyOffMpp];

      if (newValue.includes(tenOffWirelene))
        addAmount -= secureBusinessOfferDiscounts[tenOffWirelene];
      if (newValue.includes(twentyOffWireline))
        addAmount -= secureBusinessOfferDiscounts[twentyOffWireline];
      addAmountToMonthly += addAmount;
    }

    if (
      newValue &&
      (secureBusinessOffersOldValue || []).includes(
        tsbSecurityOffersObject.sixMonthsFreeEn
      ) &&
      (!newValue.includes(tsbSecurityOffersObject.sixMonthsFreeEn) ||
        newValue.length === 0)
    ) {
      let addAmount = secureBusinessPackageMonthlyPrice;
      if (newValue.includes(tenOffMpp))
        addAmount -= secureBusinessOfferDiscounts[tenOffMpp];
      if (newValue.includes(twentyOffMpp))
        addAmount -= secureBusinessOfferDiscounts[twentyOffMpp];
      if (newValue.includes(tenOffWirelene))
        addAmount -= secureBusinessOfferDiscounts[tenOffWirelene];
      if (newValue.includes(twentyOffWireline))
        addAmount -= secureBusinessOfferDiscounts[twentyOffWireline];
      addAmountToMonthly += addAmount;
    }

    // Hardware Credit
    if (
      newValue &&
      newValue.includes(hardwareCredit) &&
      (!(secureBusinessOffersOldValue || []).includes(hardwareCredit) ||
        secureBusinessOffersOldValue.length === 0)
    ) {
      subtractAmountFromNow += hardwareDiscountAmount;
      setIsHardwareDiscount(true);
    }
    if (
      newValue &&
      (secureBusinessOffersOldValue || []).includes(hardwareCredit) &&
      (!newValue.includes(hardwareCredit) || newValue.length === 0)
    ) {
      addAmountToNow += hardwareDiscountAmount;
      setIsHardwareDiscount(false);
    }

    // Waived Installation Fee Discount
    if (fieldTelusSecureBusinessSecurityPackageValue === fieldProtect) {
      if (
        newValue &&
        newValue.includes(waivedInstallationFee) &&
        (!(secureBusinessOffersOldValue || []).includes(waivedInstallationFee) ||
          secureBusinessOffersOldValue.length === 0)
      ) {
        subtractAmountFromNow += installationFeeDiscountAmount;
        setIsInstallationFeeDiscount(true);
      }
      if (
        newValue &&
        (secureBusinessOffersOldValue || []).includes(waivedInstallationFee) &&
        (!newValue.includes(waivedInstallationFee) || newValue.length === 0)
      ) {
        addAmountToNow += installationFeeDiscountAmount;
        setIsInstallationFeeDiscount(false);
      }
    } else if (fieldTelusSecureBusinessSecurityPackageValue === fieldSmartCamera) {
      if (
        newValue &&
        newValue.includes(waivedInstallationFee) &&
        (!(smartCameraOffersOldValue || []).includes(waivedInstallationFee) ||
          smartCameraOffersOldValue.length === 0)
      ) {
        subtractAmountFromNow += installationFeeDiscountAmount;
        setIsInstallationFeeDiscount(true);
      }
      if (
        newValue &&
        (smartCameraOffersOldValue || []).includes(waivedInstallationFee) &&
        (!newValue.includes(waivedInstallationFee) || newValue.length === 0)
      ) {
        addAmountToNow += installationFeeDiscountAmount;
        setIsInstallationFeeDiscount(false);
      }
    }

    // Calculate 10 and 20 dollar discounts
    Object.keys(secureBusinessOfferDiscounts).forEach(offerKey => {
      //  get discount amount to add or remove
      const currentDiscountAmountSum = getDiscountAmountSum(
        secureBusinessOfferDiscounts,
        newValue,
        offerKey
      );

      const subAmount =
        secureBusinessPackageMonthlyPrice >= currentDiscountAmountSum
          ? secureBusinessPackageMonthlyPrice - currentDiscountAmountSum
          : 0;
      const subOfferAmount =
        subAmount >= secureBusinessOfferDiscounts[offerKey]
          ? secureBusinessOfferDiscounts[offerKey]
          : subAmount;

      // Add new offer discount amount
      if (
        newValue &&
        newValue.includes(offerKey) &&
        (!(secureBusinessOffersOldValue || []).includes(offerKey) ||
          secureBusinessOffersOldValue.length === 0)
      ) {
        if (
          newValue.includes(threeMonthFree) ||
          newValue.includes(sixMonthsFree) ||
          newValue.includes(tsbSecurityOffersObject.sixMonthsFreeEn)
        )
          subtractAmountFromMonthly += 0;
        else subtractAmountFromMonthly += subOfferAmount;
      }
      // Remove existing offer discount amout
      if (
        newValue &&
        (secureBusinessOffersOldValue || []).includes(offerKey) &&
        (!newValue.includes(offerKey) || newValue.length === 0)
      ) {
        if (
          newValue.includes(threeMonthFree) ||
          newValue.includes(sixMonthsFree) ||
          newValue.includes(tsbSecurityOffersObject.sixMonthsFreeEn)
        )
          addAmountToMonthly += 0;
        else addAmountToMonthly += subOfferAmount;
      }
    });

    return {
      addAmountToMonthly,
      subtractAmountFromMonthly,
      addAmountToNow,
      subtractAmountFromNow
    };
  };

  // tsb reset values when security package value changes (SOF-2050)
  useEffect(() => {
    if (fieldTelusSecureBusinessSecurityPackageValue === smartCameraKey) {
      if (
        formFields &&
        (formFields[fieldSecureBusinessOffers] ||
          formFields[fieldSmartCameraOffers])
      ) {
        if (firstTotalCalculation.includes('firstCheckSmartCameraOffers')) {
          formFields[fieldSecureBusinessOffers].value = '';
          formFields[fieldSecureBusinessOffers].monthlyPayment = 0;
          formFields[fieldSecureBusinessOffers].price = 0;
          formFields[fieldSmartCameraOffers].value = '';
          formFields[fieldSmartCameraOffers].monthlyPayment = 0;
          formFields[fieldSmartCameraOffers].price = 0;
        } else {
          setFirstTotalCalculation([
            ...firstTotalCalculation,
            'firstCheckSmartCameraOffers'
          ]);
        }
      }
    } else if (fieldTelusSecureBusinessSecurityPackageValue) {
      setTwentyDollarsDiscountAmount(20);
    }

    // Waived Installation Fee
    const discountAmount = calcInstallationFeeDiscount(formFields);
    if (discountAmount !== undefined) {
      setInstallationFeeDiscountAmount(discountAmount);
      setIsInstallationFeeDiscount(true);
    }
  }, [fieldTelusSecureBusinessSecurityPackageValue]);

  const TelusOptikTvProfileType = getFieldValue(
    fieldTelusOptikTvProfileType,
    formFields
  );
  // Reset Installation field value if Profile Type value changes
  useEffect(()=> {
    if (formFields && formFields[fieldInstallation] && !orderData.telusOptikTvProfileType) {
      formFields[fieldInstallation].value = '';
    }
  },[TelusOptikTvProfileType]);

  useEffect(() => {
    setIsEligible(!officePhoneRequired);
  }, [officePhoneRequired]);

  const checkNoteVisibility = (
    eligibilityFields,
    fieldDetails,
    valueProductSelection,
    ...rest
  ) => {
    const fieldValues = rest.map(fieldName => {
      return getFieldValue(fieldName, eligibilityFields);
    });

    const displayWarningNote =
      valueProductSelection.includes(telusOptikTv) &&
      !(
        valueProductSelection.includes(officeInternetFiber) ||
        valueProductSelection.includes(officeInternetCopper)
      );

    if (
      (fieldDetails.name === complexNote && !fieldValues.includes(yes)) ||
      (fieldDetails.name === channelComplexNote &&
        !fieldValues.includes(yes)) ||
      (fieldDetails.name === warningNote && !displayWarningNote)
    ) {
      fieldDetails.note = '';
    }

    if (
      fieldDetails.name === fieldHBBQualificationErrorNote &&
      getFieldValue(fieldProductHomeBasedBusiness, formFields) === yes &&
      !getHBBQualificationAnswers(formFields).includes(no)
    ) {
      fieldDetails.note = '';
    }
    return fieldDetails.note;
  };

  const updateProductSelection = currentFormFields => {
    const valueProductType = currentFormFields[fieldProductType].value;
    let updatedValue = [];
    let updatedOptions = [];
    if (valueProductType !== standalone) {
      updatedOptions = disableOptions(true, currentFormFields);
      if (valueProductType === betterBusinessBundleCopper) {
        updatedValue.push(officeInternetCopper, officePhone, secureBusiness);
      } else if (valueProductType === betterBusinessBundleFibre) {
        updatedValue.push(officeInternetFiber, officePhone, secureBusiness);
      }
    } else {
      updatedOptions = disableOptions(false, currentFormFields);
      updatedValue = '';
    }
    currentFormFields[fieldProductSelection].options = updatedOptions;
    currentFormFields[fieldProductSelection].value = updatedValue;
  };

  const handleBlurField = ({ name, value }, ref, isQuoteTool) => {
    if (
      formCategoriesWirelineWireless.QUOTE_TOOL !== isQuoteTool &&
      name === businessLegalName &&
      formFields[businessType].value === fieldBusinessRegular
    ) {
      const regex = regexBusinessInc;
      const regexLogic = new RegExp(regex);
      const hasError = !regexLogic.test(value);
      if (hasError) {
        const obj = {
          [name]: {
            ref,
            text:
              locale !== localeFrench ? errorMessageInc[0] : errorMessageInc[1]
          }
        };
        setFormErrors(obj);
      } else if (formErrors[name]) {
        delete formErrors[name];
      }
    } else {
      delete formErrors[name];
      setFormErrors({});
    }
  };

  const setWifiAccessError = (value, fieldName) => {
    setFormErrors(
      value > 3
        ? {
          [`${fieldName}`]: {
            text: errorNumberTelusWifiAccessPoints
          }
        }
        : {}
    );
  };

  const resetFormFields = (fields, currentFieldName) => {
    const { resetFields, customResetFields } = fields[currentFieldName];
    const updatedFields = Object.keys(fields).reduce((acc, fieldKey) => {
      const currentFormField = findField(formStepFields, fieldKey);
      const isVisible = isRelatedFieldExisted(
        _.get(currentFormField, 'fields', {}),
        fields,
        orderData,
        true
      );

      if (!isVisible)
        return { ...acc, [fieldKey]: { ...fields[fieldKey], value: '' } };
      return { ...acc, [fieldKey]: { ...fields[fieldKey] } };
    }, {});
    if (resetFields) {
      resetFields.forEach(field => {
        const fieldName = _.get(field, 'fields.name', '');
        if (fieldName && _.has(updatedFields[fieldName], 'value'))
          updatedFields[fieldName].value = '';
      });
    }
    if (customResetFields) {
      customResetFields.forEach(field => {
        const fieldName = _.get(field, 'fields.key', '');
        if (fieldName && _.has(updatedFields[fieldName], 'value'))
          updatedFields[fieldName].value = '';
        else delete updatedFields[fieldName];
      });
    }
    return updatedFields;
  };

  const resetSelectedFields = (fields, isCustom = false) => {
    if (fields.length > 0) {
      const updatedOrderData = { ...orderData };
      fields.forEach(field => {
        const keyPath = isCustom ? 'fields.key' : 'fields.name';
        const fieldName = _.get(field, keyPath, '');
        if (_.has(orderData, fieldName)) {
          updatedOrderData[fieldName] = '';
        }
      });
      setIsFieldReset(true);
      setDueMonthly(0);
      setDueNow(0);
      setOrderData(updatedOrderData);
    }
  };

  const handleFormField = (
    { name, value, checked, files },
    ref,
    isFieldModified
  ) => {
    const resetValue = field => {
      field.value = '';
    };
    const {
      location: { pathname }
    } = history || {};
    const [, , , isQuoteTool] = pathname && pathname.split('/');

    handleBlurField({ name, value }, ref, isQuoteTool);
    const filterFieldValues = (field, valueToFilter) => {
      if (Array.isArray(field.value))
        field.value = field.value.filter(
          filterable => filterable !== valueToFilter
        );
    };
    const fields = { ...formFields };
    let needToCheck = 1;
    let addAmountToNow = 0;
    let addAmountToMonthly = 0;
    let subtractAmountFromNow = 0;
    let subtractAmountFromMonthly = 0;
    // const addAmountToFiveYearMonthly = 0;
    // const subtractAmountFromFiveYearMonthly = 0;

    if (isFieldReset) {
      setDueMonthly(0);
      setDueNow(0);
    }

    setIsFieldReset(false);
    setIsFormValidated(false);

    if (name === 'TelusMobility' && formFields.secureBusinessOffers.value) {
      if (formFields.secureBusinessOffers.value.includes('$199 off installation')) {
        formFields.secureBusinessOffers.value = formFields.secureBusinessOffers.value.filter(x => x !== '$199 off installation');
        addAmountToNow += 199;
        formFields.secureBusinessOffers.price += 199;
      }
    }

    if (name === fieldStoreCodeWLN) {
      formFields[fieldOutletStoreCode].value = storeCodeOutletMapping[value];
    }

    if (name === businessType) {
      const isBusinessLegalNameQuoteToolValue = orderData[businessLegalNameQuoteTool];
      if (value === valueBusinessPersonal) {
        formFields.businessLegalName.value = '';
      } else {
        formFields.businessLegalName.value = isBusinessLegalNameQuoteToolValue;
      }
    }

    if (name === fieldStaticIPRequiredFibre) {
      fields[fieldStaticIpPromotion].value = '';
    }

    if (name === fieldTelusOptikTvProfileType) {
      if (fields[fieldTelusOptikTvPricingAndOffers].monthlyPayment) {
        if (fields[fieldTelusOptikTvPricingAndOffers].monthlyPayment > 0) {
          addAmountToMonthly -= fields[fieldTelusOptikTvPricingAndOffers].monthlyPayment;
        } else if (fields[fieldTelusOptikTvPricingAndOffers].monthlyPayment < 0) {
          addAmountToMonthly -= fields[fieldTelusOptikTvPricingAndOffers].monthlyPayment;
        }
      }
      fields[fieldTelusOptikTvPricingAndOffers].monthlyPayment = 0;
      fields[fieldTelusOptikTvPricingAndOffers].value = undefined;
    }
    /**
     * FOR COPPER INTERNET:
     * Auto Select TELUS Business Wifi to Yes if
     * Regular Offer = Bunduled AND
     * Product(s) being added with Internet includes Business Wifi
     */
    if (['regularOffers36MonthTerm', 'productThatIsAdded'].includes(name)) {
      const valueRegularOffers36MonthTerm =
        name === 'regularOffers36MonthTerm'
          ? value
          : getFieldValue('regularOffers36MonthTerm', formFields);
      const valueProductThatIsAdded =
        name === 'productThatIsAdded'
          ? value
          : getFieldValue('productThatIsAdded', formFields);
        
    }

    /**
     * FOR FIBRE INTERNET:
     * Auto Select TELUS Business Wifi to Yes if
     * Regular Offer = Bunduled AND
     * Product(s) being added with Internet includes Business Wifi
     */
    if (['regularYearlyOfferFibreBundled', 'productSelectionFibre'].includes(name)) {
      const valueFibreSpeed = getFieldValue(
        fieldQualifiedSpeedFibre,
        formFields
      );
      const valueRegularYearlyOfferFibreBundled =
        name === 'regularYearlyOfferFibreBundled'
          ? value
          : getFieldValue('regularYearlyOfferFibreBundled', formFields);
      const valueProductSelectionFibre =
        name === 'productSelectionFibre'
          ? value
          : getFieldValue('productSelectionFibre', formFields);
      if (
        valueFibreSpeed !== '15/1 mbps' &&
        valueRegularYearlyOfferFibreBundled === 'bundled' &&
        valueProductSelectionFibre.includes('Telus Business Wi-Fi')
      )
        formFields.telusBusinessWifi.value = yes;
    }
    /**
     Hide wirelineSecondaryInstallDate and wirelinePreferedInstallDate
     if product selection includes only secureBusiness
     */
    if (name === fieldCustomerRequestFibre3G) {
      formFields.productSelection.value = undefined;
    }

    if (
      name === numberTelusWifiAccessPointsFibre ||
      name === numberTelusWifiAccessPointsTelusBusiness ||
      name === numberTelusWifiAccessPointsCopper
    ) {
      setWifiAccessError(value, name);
    }

    if (!_.get(orderData, 'productSelection', []).includes(keySecureBusiness)
      && !_.get(orderData, 'productSelection', []).includes(telusBusinessWifi)) {
      if (
        (name === tsbPreferedInstallDate &&
          !getFieldValue(wirelinePreferedInstallDate, formFields)) ||
        (name === tsbSecondaryPreferredInstallDate &&
          !getFieldValue(wirelineSecondaryInstallDate, formFields))
      ) {
        window.alert(`Please select ${winbackFields[name]} first`);
        return;
      }
    }
    if (name === wirelinePreferedInstallDate) {
      resetValue(formFields[tsbPreferedInstallDate]);
    }
    if (name === wirelineSecondaryInstallDate) {
      resetValue(formFields[tsbSecondaryPreferredInstallDate]);
    }
    if (isFieldModified && !isFormTouched) {
      setIsFormTouched(true);
    }
    // check if two months offer is selected then remove three months offer
    // from limited time basic offers
    if (name === twoMonthsDuration) {
      filterFieldValues(
        formFields[fieldLimitedTimeBasicOffer],
        threeMonthsFree
      );
    }
    if (name === 'telusOptikTvExtraThemePackHomeBased') {
      const telusOptikTvMonthlyRatePlanValue =
        name === fieldTelusOptikTvMonthlyRatePlan
          ? value
          : getFieldValue(fieldTelusOptikTvMonthlyRatePlan, fields);

      const maxAllowedValue = {
        [telusOptikTvMonthlyRatePlanOptionValues.corePlus]: 1,
        [telusOptikTvMonthlyRatePlanOptionValues.fourTheme]: 1
      };
      const valueToCheck =
        name === fieldTelusOptikTvMonthlyRatePlan
          ? fields[fieldTelusOptikTvFreeThemePacks].value
          : value;
      if (
        telusOptikTvMonthlyRatePlanValue &&
        valueToCheck &&
        valueToCheck.length > maxAllowedValue[telusOptikTvMonthlyRatePlanValue]
      ) {
        // eslint-disable-next-line no-alert
        window.alert(
          stringInterpolation(
            maxAllowedFreeThemePacksMessage,
            maxAllowedValue[telusOptikTvMonthlyRatePlanValue],
            telusOptikTvMonthlyRatePlanValue
          )
        );
        return;
      }
    }
    if (name === fieldTelusOptikTvPricingAndOffers) {
      const valueToCheck =
        name === fieldTelusOptikTvMonthlyRatePlan
          ? fields[fieldTelusOptikTvFreeThemePacks].value
          : value;
      if (
        (valueToCheck.includes('12 Month promo optik') ||
          valueToCheck.includes('6 Month promo optik')) &&
        valueToCheck.includes('Standard Rate')
      ) {
        return;
      }
    }

    // Check if maximum amount of items selected with multi checkbox
    if (
      name === fieldTelusOptikTvFreeThemePacks ||
      name === fieldTelusOptikTvFreeThemePacksForHomeBased ||
      name === fieldTelusOptikTvMonthlyRatePlan
    ) {
      const telusOptikTvMonthlyRatePlanValue =
        name === fieldTelusOptikTvMonthlyRatePlan
          ? value
          : getFieldValue(fieldTelusOptikTvMonthlyRatePlan, fields);

      const maxAllowedValue = {
        [telusOptikTvMonthlyRatePlanOptionValues.tv]: 3,
        [telusOptikTvMonthlyRatePlanOptionValues.threeTheme]: 3,
        [telusOptikTvMonthlyRatePlanOptionValues.tvElite]: 4,
        [telusOptikTvMonthlyRatePlanOptionValues.fourTheme]: 4
      };
      const valueToCheck =
        name === fieldTelusOptikTvMonthlyRatePlan
          ? fields[fieldTelusOptikTvFreeThemePacks].value
          : value;
      if (
        telusOptikTvMonthlyRatePlanValue &&
        valueToCheck &&
        valueToCheck.length > maxAllowedValue[telusOptikTvMonthlyRatePlanValue]
      ) {
        // eslint-disable-next-line no-alert
        window.alert(
          stringInterpolation(
            maxAllowedFreeThemePacksMessage,
            maxAllowedValue[telusOptikTvMonthlyRatePlanValue],
            telusOptikTvMonthlyRatePlanValue
          )
        );
        return;
      }
    }

    // Check OptikTV SetTop Box total restrictions
    const monthlyPlan = getFieldValue(
      fieldTelusOptikTvMonthlyRatePlan,
      formFields
    );

    if (name === fieldTelusOptikTvProfileType) {
      const wirelessSetTopBoxes = getFieldValue(
        fieldTelusOptikTvNumberWirelessSetTopBoxes,
        formFields
      );
      const wiredSetTopBoxes = getFieldValue(
        fieldTelusOptikTvNumberWiredSetTopBoxes,
        formFields
      );
      orderData.telusOptikTvAdditionalSetTopBoxes = '';
      const wiredPrice =
        (wiredSetTopBoxes - 1) * telusOptikTvPricing.topBoxes[monthlyPlan];
      const wirelessPrice =
        wirelessSetTopBoxes * telusOptikTvPricing.topBoxes[monthlyPlan];
      formFields[fieldTelusOptikTvNumberWirelessSetTopBoxes].value = 0;
      formFields[fieldTelusOptikTvNumberWiredSetTopBoxes].value = 1;
      if (wirelessSetTopBoxes > 0 || wiredSetTopBoxes > 1) {
        const price = wiredPrice + wirelessPrice;
        addAmountToMonthly -= price;
      }
    }
    if (
      [
        fieldTelusOptikTvNumberWiredSetTopBoxes,
        fieldTelusOptikTvNumberWirelessSetTopBoxes
      ].includes(name)
    ) {
      const valueTelusOptikTvMonthlyRatePlan = getFieldValue(
        fieldTelusOptikTvMonthlyRatePlan,
        formFields
      );
      // Assuming these variables are available in the scope
      const wiredOldCount =
        +getFieldValue(fieldTelusOptikTvNumberWiredSetTopBoxes, formFields) ||
        0;
      const wirelessOldCount =
        +getFieldValue(
          fieldTelusOptikTvNumberWirelessSetTopBoxes,
          formFields
        ) || 0;

      let newCount = 0;
      let previousCount = wiredOldCount + wirelessOldCount;

      // Update the count based on which field is being updated
      if (name === fieldTelusOptikTvNumberWirelessSetTopBoxes) {
        newCount = wiredOldCount + parseInt(value || 0, 10);
      } else {
        newCount = wirelessOldCount + parseInt(value || 0, 10);
      }

      // Check for count increase
      if (
        newCount > previousCount &&
        newCount > 1 &&
        newCount <= telusOptikTvSetTopBoxTotalLimit
      ) {
        if (valueTelusOptikTvMonthlyRatePlan === telusOptikTvMonthlyRatePlanOptionValues.tvBasic) {
          addAmountToMonthly += 5;
        } else if (valueTelusOptikTvMonthlyRatePlan === telusOptikTvMonthlyRatePlanOptionValues.tvElite) {
          addAmountToMonthly += 5;
        } else if (valueTelusOptikTvMonthlyRatePlan === telusOptikTvMonthlyRatePlanOptionValues.tv) {
          addAmountToMonthly += 5;
        } else if (valueTelusOptikTvMonthlyRatePlan === telusOptikTvMonthlyRatePlanOptionValues.basics) {
          addAmountToMonthly += 10;
        } else if (valueTelusOptikTvMonthlyRatePlan === telusOptikTvMonthlyRatePlanOptionValues.core) {
          addAmountToMonthly += 10;
        } else if (valueTelusOptikTvMonthlyRatePlan === telusOptikTvMonthlyRatePlanOptionValues.threeTheme) {
          addAmountToMonthly += 10;
        } else if (valueTelusOptikTvMonthlyRatePlan === telusOptikTvMonthlyRatePlanOptionValues.fourTheme) {
          addAmountToMonthly += 10;
        }
      }

      // Check for count decrease
      if (newCount < previousCount && newCount >= 0) {
        if (valueTelusOptikTvMonthlyRatePlan === telusOptikTvMonthlyRatePlanOptionValues.tvBasic) {
          addAmountToMonthly -= 5;
        } else if (valueTelusOptikTvMonthlyRatePlan === telusOptikTvMonthlyRatePlanOptionValues.tvElite) {
          addAmountToMonthly -= 5;
        } else if (valueTelusOptikTvMonthlyRatePlan === telusOptikTvMonthlyRatePlanOptionValues.tv) {
          addAmountToMonthly -= 5;
        } else if (valueTelusOptikTvMonthlyRatePlan === telusOptikTvMonthlyRatePlanOptionValues.basics) {
          addAmountToMonthly -= 10;
        } else if (valueTelusOptikTvMonthlyRatePlan === telusOptikTvMonthlyRatePlanOptionValues.core) {
          addAmountToMonthly -= 10;
        } else if (valueTelusOptikTvMonthlyRatePlan === telusOptikTvMonthlyRatePlanOptionValues.threeTheme) {
          addAmountToMonthly -= 10;
        } else if (valueTelusOptikTvMonthlyRatePlan === telusOptikTvMonthlyRatePlanOptionValues.fourTheme) {
          addAmountToMonthly -= 10;
        }
      }

      // Save the current count as the previous count for the next update
      previousCount = newCount;

      if (newCount > telusOptikTvSetTopBoxTotalLimit) {
        // eslint-disable-next-line no-alert
        window.alert(
          stringInterpolation(
            maxNumberOfSetTopBoxes
          )
        );
        return;
      }
    }

    if ([fieldSecureBusinessOffers, fieldSmartCameraOffers].includes(name)) {
      if (fieldTelusSecureBusinessSecurityPackageValue) {
        const securePrice = calculateSecureBusinessRates(value);
        addAmountToMonthly += securePrice.addAmountToMonthly;
        subtractAmountFromMonthly += securePrice.subtractAmountFromMonthly;
        addAmountToNow += securePrice.addAmountToNow;
        subtractAmountFromNow += securePrice.subtractAmountFromNow;
      } else {
        // eslint-disable-next-line no-alert
        window.alert(secureBusinessSelectPackageError);
        return;
      }
    }
    fields[name] = { ...fields[name], value, checked, isVisible: true };

    if (name === fieldProductSelection) {
      updateProgressBarSteps(value);
    }

    if (name === fieldTelusSecureBusinessSecurityPackage) {
      const updatedSecureOffers = updateSecureBusinessRates(formFields, dueMonthly, value);
      addAmountToMonthly += updatedSecureOffers.addAmountToMonthly || 0;
      subtractAmountFromMonthly += updatedSecureOffers.subtractAmountFromMonthly;
      subtractAmountFromNow += equipmentTotalPrice.addAmountToPrice;
      if (isHardwareDiscount) {
        subtractAmountFromNow -= hardwareDiscountAmount;
      }
      if (isInstallationFeeDiscount) {
        subtractAmountFromNow -= installationFeeDiscountAmount;
      }
      subtractAmountFromMonthly += equipmentTotalPrice.addAmountToMonthly;
      setHardwareDiscountAmount(0);
      // setInstallationFeeDiscountAmount(0);
      setEquipmentTotalPrice(initEquipmentPrices);
    }

    if (
      name === fieldRegularMonthlyOffers ||
      (value === yes &&
        (name === fieldTwoMonthsDuration ||
          name === fieldTwoMonthsDurationFibre)) ||
      (name === fieldRegularMonthlyOffersFibre && value === standardPricing)
    ) {
      const fieldValueFibre = getFieldValue(
        fieldLimitedMonthlyOfferFibre,
        fields
      );
      const officeCopperValue = getFieldValue(fieldLimitedTimeOffer, fields);
      if (fieldValueFibre === threeMonthsFree) {
        fields[fieldLimitedMonthlyOfferFibre] = '';
      }
      if (officeCopperValue && officeCopperValue.includes(threeMonthsFree)) {
        fields[fieldLimitedTimeOffer] = '';
      }
    }

    const isCustomLogic = false;
    if (isCustomLogic) {
      // Custom logic for related fields
    } else {
      // Handle dueMonthly and dueNow
      updateTotals(name, fields[name]);

      if (fields[name].type === 'MultiCheckbox') {
        const currentField = findField(formStepFields, name);
        const mappedValues = value.reduce(
          (ac, a) => ({ ...ac, [a]: true }),
          {}
        );

        // Price
        let oldAmount = fields[name].price || 0;
        let currentAmount = currentField.fields.options.reduce(
          (ac, a) =>
            ac + ((mappedValues[a.fields.value] && a.fields.price) || 0),
          0
        );
        subtractAmountFromNow += oldAmount;
        addAmountToNow += currentAmount;
        fields[name].price = currentAmount;

        // Monthly Payment
        oldAmount = fields[name].monthlyPayment || 0;
        currentAmount = currentField.fields.options.reduce(
          (ac, a) =>
            ac +
            ((mappedValues[a.fields.value] && a.fields.monthlyPayment) || 0),
          0
        );

        subtractAmountFromMonthly += oldAmount;
        addAmountToMonthly += currentAmount;
        fields[name].monthlyPayment = currentAmount;
      }

      if (['Select', 'Radio'].includes(fields[name].type)) {
        const currentField = findField(formStepFields, name);
        if (
          currentField &&
          currentField.fields &&
          currentField.fields.options
        ) {
          const currentOption = currentField.fields.options.find(
            item => item.fields.value === value
          );

          if (typeof currentOption !== 'undefined') {
            // Price

            let amount = currentOption.fields.price || 0;
            let oldPrice = fields[name].price || 0;
            subtractAmountFromNow += oldPrice;
            addAmountToNow += amount;
            fields[name].price = amount;

            // Monthly payment
            amount = currentOption.fields.monthlyPayment || 0;
            oldPrice = fields[name].monthlyPayment || 0;
            subtractAmountFromMonthly += oldPrice;
            addAmountToMonthly += amount;
            fields[name].monthlyPayment = amount;
          } else {
            if (fields[name].price) {
              subtractAmountFromNow += fields[name].price;
              fields[name].price = 0;
            }
            if (fields[name].monthlyPayment) {
              subtractAmountFromMonthly += fields[name].monthlyPayment;
              fields[name].monthlyPayment = 0;
            }
          }
        }
      }

      if (
        name === fieldLimitedTimeBasicOffer &&
        !getFieldValue(fieldLimitedTimeBasicOffer, formFields)
      ) {
        subtractAmountFromMonthly = 12;
      }
    }

    updateSections(getHiddenSections(fields));

    const getDisabledFields = (data, initFields) => {
      let result = initFields;

      const filter = !data
        ? []
        : data.filter(item => {
          const { sys, fields: itemFields } = item;
          const { name: itemName, appearsAfterField } = itemFields;
          const {
            contentType: {
              sys: { id }
            }
          } = sys;

          if (id === formFieldsGroup) {
            result = getDisabledFields(itemFields.fields, result);
          } else if (id === formSection) {
            result = getDisabledFields(itemFields.formFields, result);
          } else if (fields[itemName] && appearsAfterField) {
            const isVisible = isRelatedFieldExisted(
              item.fields,
              fields,
              orderData,
              isFormTouched
            );
            if (fields[itemName].isVisible) {
              fields[itemName].isVisible = isVisible;
              return !isVisible;
            }
            if (isVisible) {
              if (
                isFieldCalculated(
                  fields[itemName].type,
                  fields[itemName].value,
                  fields[itemName].checked,
                  fields[itemName].price
                )
              ) {
                const itemPrice =
                  fields[itemName].type === 'Number'
                    ? Number(fields[itemName].initPrice) *
                    Number(fields[itemName].value)
                    : Number(fields[itemName].price);
                addAmountToNow += itemPrice;
              }
              if (
                isFieldCalculated(
                  fields[itemName].type,
                  fields[itemName].value,
                  fields[itemName].checked,
                  fields[itemName].monthlyPayment
                )
              ) {
                const itemPrice =
                  fields[itemName].type === 'Number'
                    ? Number(fields[itemName].initMonthlyPayment) *
                    Number(fields[itemName].value)
                    : Number(fields[itemName].monthlyPayment);
                addAmountToMonthly += itemPrice;
              }
              if (
                isFieldCalculated(
                  fields[itemName].type,
                  fields[itemName].value,
                  fields[itemName].checked,
                  fields[itemName].fiveYearEasyPayment
                )
              ) {
                const itemPrice =
                  fields[itemName].type === 'Number'
                    ? Number(fields[itemName].initFiveYearMonthlyPayment) *
                    Number(fields[itemName].value)
                    : Number(fields[itemName].fiveYearEasyPayment);
                addAmountToMonthly += itemPrice;
              }
            }
            fields[itemName].isVisible = isVisible;
          }

          return false;
        });

      return [...result, ...filter];
    };

    while (needToCheck > 0 && needToCheck < 5) {
      const disabledFields = getDisabledFields(formStepFields, []);

      // eslint-disable-next-line no-loop-func
      disabledFields.forEach(item => {
        const {
          fields: { name: itemName }
        } = item;

        if (
          isFieldCalculated(
            fields[itemName].type,
            fields[itemName].value,
            fields[itemName].checked,
            fields[itemName].price
          )
        ) {
          const itemPrice =
            fields[itemName].type === 'Number'
              ? Number(fields[itemName].initPrice) *
              Number(fields[itemName].value)
              : Number(fields[itemName].price);
          subtractAmountFromNow += itemPrice;
        }
        if (
          isFieldCalculated(
            fields[itemName].type,
            fields[itemName].value,
            fields[itemName].checked,
            fields[itemName].monthlyPayment
          )
        ) {
          const itemPrice =
            fields[itemName].type === 'Number'
              ? Number(fields[itemName].initMonthlyPayment) *
              Number(fields[itemName].value)
              : Number(fields[itemName].monthlyPayment);
          subtractAmountFromMonthly += itemPrice;
        }
        if (
          isFieldCalculated(
            fields[itemName].type,
            fields[itemName].value,
            fields[itemName].checked,
            fields[itemName].fiveYearEasyPayment
          )
        ) {
          const itemPrice =
            fields[itemName].type === 'Number'
              ? Number(fields[itemName].initFiveYearMonthlyPayment) *
              Number(fields[itemName].value)
              : Number(fields[itemName].fiveYearEasyPayment);
          subtractAmountFromMonthly += itemPrice;
        }
      });

      needToCheck = disabledFields.length > 0 ? needToCheck + 1 : 0;
    }

    // Update prices
    if (addAmountToNow || subtractAmountFromNow) {
      // reset dueNow when package switched to TSB from Smart Camera
      // @Todo: check if it is still actual
      if (dueNow === 0 && value === smartCameraKey) {
        setDueNow(199);
      } else if (
        value instanceof Array &&
        value.includes(zeroInstallation) &&
        value.length === 1
      ) {
        if (dueNow > 199) {
          setDueNow(dueNow - 199);
        } else {
          setDueNow(0);
        }
      } else {
        setDueNow((dueNow || 0) - subtractAmountFromNow + addAmountToNow);
      }
    }
    if (addAmountToMonthly || subtractAmountFromMonthly) {
      setDueMonthly((dueMonthly - subtractAmountFromMonthly || 0) + (addAmountToMonthly || 0));
    }

    if (name === fieldProductType) {
      updateProductSelection(fields);
      updateProgressBarSteps(formFields[fieldProductSelection].value);
    }

    if (files && files.length) {
      const [file] = files;
      const checkFileExists = (filesToCheck, fileKey) =>
        filesToCheck.find(fileDetails => fileDetails[fileKey]);
      const updateFile = (fileList, fileKey, updatedFile) => {
        return fileList.map(fileDetails => {
          if (fileDetails[fileKey]) {
            fileDetails[name] = updatedFile;
          }
          return fileDetails;
        });
      };
      if (
        fields.files &&
        fields.files.length &&
        !checkFileExists(fields.files, name)
      ) {
        fields.files.push({ [name]: file });
      } else if (
        fields.files &&
        fields.files.length &&
        checkFileExists(fields.files, name)
      ) {
        const updatedFileList = updateFile(fields.files, name, file);
        fields.files = updatedFileList;
      } else {
        fields.files = [{ [name]: file }];
      }
      fields[name].value = file.name;
    }

    if (Array.isArray(orderData.officePhoneData) && !orderData.tollFree) {
      const isTollFree = !!orderData.officePhoneData.find(phoneLine =>
        phoneLine.tollFree.value.includes(yes)
      );
      if (isTollFree) {
        fields.tollFreePhone = yes;
      }
    }
    // Clearing all values below whenever copper speed value is changed
    if (name === fieldTerm) {
      fields[fieldQualifiedSpeed].value = '';
      fields[fieldRegularMonthlyOffers].value = '';
      fields[fieldRegularYearlyOffers].value = '';
      fields[fieldLimitedTimeBasicOffer].value = '';
      fields[fieldProductThatIsAdded].value = '';
      fields[fieldStaticIPRequired].value = '';
    }
    if (name === fieldQualifiedSpeed) {
      fields[fieldRegularMonthlyOffers].value = '';
      fields[fieldRegularYearlyOffers].value = '';
      fields[fieldLimitedTimeBasicOffer].value = '';
      fields[fieldProductThatIsAdded].value = '';
      fields[fieldStaticIPRequired].value = '';
    }
    // Clearing all values below whenever fibre speed value is changed
    if (name === fieldQualifiedSpeedFibre) {
      fields[fieldRegularMonthlyOffersFibre].value = '';
      fields[fieldRegularYearlyOffersFibre].value = '';
      fields[fieldProductSelectionFibre].value = '';
      fields[fieldRegularYearlyOffersFibreBundled].value = '';
      fields[fieldLimitedYearlyOffersFibre].value = '';
      fields[fieldPromoDurationFibre].value = '';
      fields[fieldStaticIPRequiredFibre].value = '';
      fields[switchCredit$100].value = '';
    }
    if (name === fieldTermFibre) {
      fields[fieldQualifiedSpeedFibre].value = '';
      fields[fieldRegularMonthlyOffersFibre].value = '';
      fields[fieldRegularYearlyOffersFibre].value = '';
      fields[fieldProductSelectionFibre].value = '';
      fields[fieldRegularYearlyOffersFibreBundled].value = '';
      fields[fieldLimitedYearlyOffersFibre].value = '';
      fields[fieldPromoDurationFibre].value = '';
      fields[fieldStaticIPRequiredFibre].value = '';
      fields[switchCredit$100].value = '';
    }

    const valueBusinessTVMigrationOptik = getFieldValue(fieldBusinessTVmigrationOptik, fields);
    if (name === fieldBusinessTVmigrationOptik && valueBusinessTVMigrationOptik && valueBusinessTVMigrationOptik === yes) {
      setIsEligible(false);
    } else if (name === fieldBusinessTVmigrationOptik && valueBusinessTVMigrationOptik && valueBusinessTVMigrationOptik === no) {
      setIsEligible(true);
    }
    // Clearing all values and prices below whenever monthly rate plan is changed
    if (name === fieldTelusOptikTvProfileType) {
      fields.termBusinessTV.value = '';
      fields.telusOptikTvAccessibleToEmpAndStaff.value = undefined;
      setIsEligible(true);
    }
    if (
      name === fieldTelusOptikTvMonthlyRatePlan ||
      name === fieldTelusOptikTvProfileType
    ) {
      fields.telusOptikTvFreeThemePacksForHomeBased.value = undefined;
      fields.telusOptikTvAdditionalThemePacksHomeBased.value = undefined;
      fields.telusOptikTvExtraThemePackHomeBased.value = undefined;
      fields.telusOptikTvFreeThemePacks.value = undefined;
      fields.telusOptikTvAdditionalThemePacks.value = undefined;
      fields.telusOptikTvExtraThemePackMulticultural.value = undefined;

      const oldMonthlyPrice =
        fields.telusOptikTvAdditionalThemePacksHomeBased.monthlyPayment +
        fields.telusOptikTvExtraThemePackHomeBased.monthlyPayment +
        fields.telusOptikTvAdditionalThemePacks.monthlyPayment +
        fields.telusOptikTvExtraThemePackMulticultural.monthlyPayment;

      setDueMonthly((currentDueMonthly) => currentDueMonthly - oldMonthlyPrice);
      fields.telusOptikTvAdditionalThemePacksHomeBased.monthlyPayment = 0;
      fields.telusOptikTvExtraThemePackHomeBased.monthlyPayment = 0;
      fields.telusOptikTvAdditionalThemePacks.monthlyPayment = 0;
      fields.telusOptikTvExtraThemePackMulticultural.monthlyPayment = 0;
    }
    // Update form fields
    setFormFields(resetFormFields(fields, name));

    // Reset Selected Fields Logic
    if (_.has(fields, `${name}.resetFields`)) {
      resetSelectedFields(_.get(fields, `${name}.resetFields`, []));
    } else if (_.has(fields, `${name}.customResetFields`)) {
      resetSelectedFields(_.get(fields, `${name}.customResetFields`, []), true);
    }
  };

  useEffect(() => {
    const formFieldsKeys = Object.keys(formFields);
    if (formFieldsKeys.length && typeof fieldsWithValue === 'undefined') {
      const initFieldsWithValue = [];
      formFieldsKeys.forEach(name => {
        if (formFields[name]) {
          const { value } = formFields[name];

          if (value) {
            initFieldsWithValue.push({ name, value });
            updateTotals(name, formFields[name]);
          }
        }
      });
      setFieldsWithValue(initFieldsWithValue);
    }
  }, [Object.keys(formFields).length]);

  const isAllPrequalQuestionAnswered = () => {
    let allQuestionAnswered = true;
    PRE_QUALIFICATION_QUESTIONS.forEach(prequalQuestion => {
      if (!getFieldValue(prequalQuestion, formFields))
        allQuestionAnswered = false;
    });
    return allQuestionAnswered;
  };

  const renderFormFields = data =>
    data &&
    data.length > 0 &&
    data.map(({ sys, fields }, indexRoot) => {
      const {
        contentType: {
          sys: { id }
        },
        id: sysId
      } = sys;
      const { name: fieldName, title, expiredDate } = fields;
      let obj = {};

      // This function is use to handel Dashboard Prequalification Section logic
      const returnValueOfPrequalification = PrequalificationHelpers({
        isCreateOrderButtonVisible,
        formFields,
        fieldName
      });
      if ( returnValueOfPrequalification ) {
        return null;
      }
      const disableOption = (options, target, value) => {
        const updatedOptions = options;
        updatedOptions.forEach(option => {
          if (option.fields.value === target) {
            option.fields.disabledOption = value;
          }
        });
        return updatedOptions;
      };
      const gisIdConditon = fieldName === fieldGisId &&
        !(
          orderData.productType === fieldBetterBusinessBundleFibre ||
          _.get(orderData, 'productSelection', []).includes(fieldFiberInternet)
        );

      if (fieldName === fieldPrefferedDateSecurityNote
        && winbackPrefferedInstallationNoteProvinces.includes(request.getProvince())
      ) {
        return null;
      }
      if (isChannelVulcanCompatible(userChannelName) && fieldName === fieldIsVulcanOrderWLN) {
        formFields.isVulcanOrderWLN.isRequired = false;
        return null;
      }
      if (!isChannelVulcanCompatible(userChannelName) && fieldName === fieldIsPureFibreEastLeadWLN) {
        formFields.isPureFibreEastLeadWLN.isRequired = false;
        return null;
      }

      const copiedFields = JSON.parse(JSON.stringify(fields));
      if (fieldName === 'telusOptikTvAdditionalSetTopBoxes') {
        if ([valuePrivateHomeBasedOpus, valuePublicOpus].includes(formFields.telusOptikTvProfileType.value)) {
          if (copiedFields.name === 'telusOptikTvAdditionalSetTopBoxes') {
            if (
              copiedFields.name === 'telusOptikTvAdditionalSetTopBoxes'
              && Array.isArray(copiedFields.formFields)
            ) {
              for (let i = 0; i < copiedFields.formFields.length; i+=1) {
                const field = copiedFields.formFields[i];
                if (field.fields.backendKey === 'telusOptikTvAdditionalSetTopBox'
                  && Array.isArray(field.fields.options)
                ) {
                  topBoxDetailOptions = JSON.parse(JSON.stringify(field.fields.options));
                  field.fields.options = field.fields.options.filter(
                    option => option.fields.value !== 'Rent ($5 a month)'
                  );
                }
              }
            }
          }
        }
        if (![valuePrivateHomeBasedOpus, valuePublicOpus].includes(formFields.telusOptikTvProfileType.value)) {
          if (copiedFields.name === 'telusOptikTvAdditionalSetTopBoxes') {
            if (copiedFields.name === 'telusOptikTvAdditionalSetTopBoxes'
              && Array.isArray(copiedFields.formFields)
            ) {
              for (let i = 0; i < copiedFields.formFields.length; i+=1) {
                const field = copiedFields.formFields[i];
                if (field.fields.backendKey === 'telusOptikTvAdditionalSetTopBox'
                  && Array.isArray(field.fields.options)
                ) {
                  topBoxDetailOptions = JSON.parse(JSON.stringify(field.fields.options));
                  field.fields.options = field.fields.options.filter(
                    option => option.fields.value !== 'Rent ($10 a month)'
                  );
                }
              }
            }
          }
        }
      }
      // Prequalification logic for cop store
      if (
        (fieldName === fieldStoreCodeWLN || fieldName === fieldOutletStoreCode) &&
        userChannelName !== 'CORP_STORE'
      ) {
        formFields[fieldName].isRequired = false;
        return null;
      }

      if (fieldName === fieldStoreCodeWLN) {
        if (!formFields[fieldStoreCodeWLN].options) {
          formFields[fieldStoreCodeWLN].options = storeCodes.map(codeValue => ({
            fields: {
              label: codeValue,
              value: codeValue
            }
          }));
        }
      }

      if (fieldName === fieldOutletStoreCode) {
        formFields[fieldOutletStoreCode].isDisabled = true;
      }

      const valueProductSelectionFibre = getFieldValue(fieldProductSelectionFibre, formFields);
      const valueForTermFibre = getFieldValue(fieldTermFibre, formFields);
      const qualifiedSpeedForFibreValue = getFieldValue(fieldQualifiedSpeedFibre, formFields);

      if (
        fieldName === fieldStaticIPRequiredFibre &&
        ['QC'].includes(request.getProvince())
      ) {
        const allowedOptionsForQuebec = [_valueStaticIpSubnet1Fibre, _valueStaticIpSubnet5Fibre, _no];
        if (
          formFields &&
          formFields[fieldName] &&
          formFields[fieldName].options
        ) {
          fields.options = formFields[fieldName].options.filter(opt => {
            return allowedOptionsForQuebec.includes(opt.fields.value);
          });
        }
      } else if (
        ['AB', 'BC'].includes(request.getProvince()) &&
        qualifiedSpeedForFibreValue === _valueFiveGSpeed
      ) {
        // for province, values in allowed options will not appear on FE
        const allowedOptions = [fieldOptionStaticIp5,fieldOptionStaticIp0,fieldOptionStaticIpDynamic5];
        if (
          formFields &&
          formFields[fieldName] &&
          formFields[fieldName].options
        ) {
          fields.options = formFields[fieldName].options.filter(opt => {
            return !allowedOptions.includes(opt.fields.value);
          });
        }
      } else {
        const allowedOptionsForQuebec = [fieldOptionStaticIp5, fieldOptionStaticIp0, fieldOptionStaticIpDynamic5];
        if (
          formFields &&
          formFields[fieldName] &&
          formFields[fieldName].options
        ) {
          fields.options = formFields[fieldName].options.filter(opt => {
            return !allowedOptionsForQuebec.includes(opt.fields.value);
          });
        }
      }

      if (
        fieldName === fieldTermFibre &&
        ['QC'].includes(request.getProvince())
      ) {
        const allowedOptionsForQuebec = [_monthly, _valueTerm36Month];
        if (
          formFields &&
          formFields[fieldName] &&
          formFields[fieldName].options
        ) {
          fields.options = formFields[fieldName].options.filter(opt => {
            return allowedOptionsForQuebec.includes(opt.fields.value);
          });
        }
      }

      if (
        fieldName === fieldRegularMonthlyOffersFibre &&
        ['QC'].includes(request.getProvince()) &&
        valueForTermFibre === _monthly
      ) {
        const allowedOptionsForQuebec = [_standardPricing];
        if (
          formFields &&
          formFields[fieldName] &&
          formFields[fieldName].options
        ) {
          fields.options = formFields[fieldName].options.filter(opt => {
            return allowedOptionsForQuebec.includes(opt.fields.value);
          });
        }
      }

      if (
        valueForTermFibre === _valueTerm36Month &&
        ['QC'].includes(request.getProvince()) &&
        qualifiedSpeedForFibreValue === valueQualifiedSpeed150mbps
      ) {
        if (fieldName === fieldLimitedYearlyOffersFibre150) return null;
        if (fieldName === switchCredit$100) return null;
        if (fieldName === fieldMppOffers) {
          const valueRegularOffers = getFieldValue(
            'regularYearlyOfferFibreBundled',
            formFields
          );
          if (valueRegularOffers === _bundled) {
            fields.options = formFields[fieldMppOffers].options.filter(opt => {
              return ![mppCrossSellOffer15].includes(opt.fields.value);
            });
          }
        }
      }

      if (
        valueForTermFibre === _valueTerm36Month &&
        ['QC'].includes(request.getProvince()) &&
        qualifiedSpeedForFibreValue === valueQualifiedSpeed300mbps
      ) {
        if (fieldName === fieldLimitedYearlyOffersFibre300) return null;
        if (fieldName === switchCredit$100) return null;
        if (fieldName === fieldMppOffers) {
          const valueRegularOffers = getFieldValue(
            'regularYearlyOfferFibreBundled',
            formFields
          );
          if (valueRegularOffers === _bundled) {
            fields.options = formFields[fieldMppOffers].options.filter(opt => {
              return ![mppCrossSellOffer15].includes(opt.fields.value);
            });
          }
        }
      }

      if (
        valueForTermFibre === _valueTerm36Month &&
        ['QC'].includes(request.getProvince()) &&
        qualifiedSpeedForFibreValue === valueQualifiedSpeed940mbps
      ) {
        if (fieldName === fieldLimitedYearlyOffersFibre) return null;
        if (
          fieldName === fieldManagerSpecialDiscount &&
          valueProductSelectionFibre &&
          !valueProductSelectionFibre.includes(mobility)
        ) {
          formFields[fieldManagerSpecialDiscount].value = undefined;
          return null;
        }
        if (fieldName === switchCredit$100) return null;
        if (fieldName === fieldMppOffers) {
          fields.options = formFields[fieldMppOffers].options.filter(opt => {
            return ![mppFibreInternet1G].includes(opt.fields.value);
          });
        }
      }

      if (
        valueForTermFibre === _valueTerm36Month &&
        ['QC'].includes(request.getProvince()) ){
        if (fieldName === fieldMppOffers) return null;
      }

      // release 12.1
      if (
        formFields[fieldObdOrder] &&
        formFields[fieldObdOrder].value !== keyYes &&
        fieldName === fieldObdNoteOnCustomerInformation
      ) {
        return null;
      }
      if (
        formFields[fieldObdOrder] &&
        formFields[fieldObdOrder].value !== keyYes &&
        (fieldName === fibreNoteOnCustomerInfomationPage ||
          fieldName === fibreNoteCheckbox)
      ) {
        return null;
      }
      // end release 12.1

      const qualifiedSpeedFibreValue = getFieldValue(
        fieldQualifiedSpeedFibre,
        formFields
      );

      const telusPublicWifiFibreValue = getFieldValue(
        telusPublicWifiFibre,
        formFields
      );
      const valuePublicWifiCopper = getFieldValue('publicWifi', formFields);
      const valueTelusBusinessWifi = getFieldValue(
        fieldTelusBusinessWifi,
        formFields
      );

      if (
        fieldName === fiveYearlyFibrePromos &&
        [mbps750, mbps3g].includes(qualifiedSpeedFibreValue)
      ) {
        return null;
      }

      if (
        fieldName === fieldRegularYearlyOffersFibre &&
        qualifiedSpeedFibreValue &&
        qualifiedSpeedFibreValue === mbps15
      ) {
        return null;
      }
      if (fieldName === numberTelusAccessPoints) {
        if (profile && profile.dealership) {
          return null;
        }
      }

      if (formStepBackendKey === BACKEND_KEYS.optikTv) {
        const valueProfileType = getFieldValue(
          fieldTelusOptikTvProfileType,
          formFields
        );

        const valueTelusOptikTv = getFieldValue(
          fieldTelusOptikTvMonthlyRatePlan,
          formFields
        );

        const valueTelusOptikTvPricingAndOffers = getFieldValue(
          fieldTelusOptikTvPricingAndOffers,
          formFields
        );
        const valueCustomerHaveLiquorLicense = getFieldValue(
          fieldCustomerHaveLiquorLicense,
          formFields
        );
        if (fieldName === fieldTelusOptikTvProfileType) {
          const allowedOptionsForHomeBased = [
            valuePrivateHomeBasedOpus,
            valuePublicOpus,
            valuePrivateLegacy,
            valuePublicLegacy
          ];
          const allowedOptionsForNonHomeBased = [
            valuePrivateLegacy,
            valuePublicLegacy
          ];
          const optionsWhenLiquorLicense = [valuePublicLegacy];

          if (valueCustomerHaveLiquorLicense === Yes) {
            fields.options = formFields[
              fieldTelusOptikTvProfileType
              ].options.filter(opt => {
              return optionsWhenLiquorLicense.includes(opt.fields.value);
            });
          } else if (valueCustomerHaveLiquorLicense === no) {
            fields.options = formFields[
              fieldTelusOptikTvProfileType
              ].options.filter(opt => {
              return !optionsWhenLiquorLicense.includes(opt.fields.value);
            });
          } else {
            const allowedOptions = allowedChannelsListForHomeBased.includes(
              userChannelName
            )
              ? allowedOptionsForHomeBased
              : allowedOptionsForNonHomeBased;
            fields.options = formFields[
              fieldTelusOptikTvProfileType
              ].options.filter(opt => {
              return allowedOptions.includes(opt.fields.value);
            });
          }
        }
        if (fieldName === fieldTelusOptikTvExtraThemePackHomeBased) {
          const allowedOptionsForFourTheme = ['Crave ($0)'];
          const allowedOptionsForOtherThemes = ['Crave($20)'];

          if (valueTelusOptikTv === telusOptikTvMonthlyRatePlanOptionValues.fourTheme) {
            fields.options = formFields[
              fieldTelusOptikTvExtraThemePackHomeBased
              ].options.filter(opt => {
              return allowedOptionsForFourTheme.includes(opt.fields.value);
            });
          } else {
            fields.options = formFields[
              fieldTelusOptikTvExtraThemePackHomeBased
              ].options.filter(opt => {
              return allowedOptionsForOtherThemes.includes(opt.fields.value);
            });
          }
        }

        if (fieldName === fieldTelusOptikTvPromoDuration) {
          if (
            valueTelusOptikTvPricingAndOffers === undefined ||
            (Array.isArray(valueTelusOptikTvPricingAndOffers) &&
              (!valueTelusOptikTvPricingAndOffers.includes('12 Month promo optik') ||
                !valueTelusOptikTvPricingAndOffers.includes('6 Month promo optik')))
          ) {
            formFields.telusOptikTvPromoDuration.isRequired = false;
            return null;
          }

          formFields.telusOptikTvPromoDuration.isRequired = true;
        }
        if (fieldName === 'telusOptikTvExtraThemePackHomeBased') {
          if (
            !valueTelusOptikTv.includes(
              telusOptikTvMonthlyRatePlanOptionValues.fourTheme
            )
          ) {
            formFields.telusOptikTvExtraThemePackHomeBased.isRequired = false;
            fields.required = false;
          } else {
            formFields.telusOptikTvExtraThemePackHomeBased.isRequired = true;
            fields.required = true;
          }
        }

        if (fieldName === fieldtelusOptikTvAccessibleToEmpAndStaff) {
          if (valueCustomerHaveLiquorLicense === Yes) {
            return null;
          }
        }
        // Logics reconstructed
        if (fieldName === fieldTelusOptikTvMonthlyRatePlan) {
          const ratePlanField = formFields[fieldTelusOptikTvMonthlyRatePlan];
          if ([valuePrivateHomeBasedOpus, valuePublicOpus].includes(valueProfileType)) {
            if (ratePlanField && ratePlanField.options) {
              const excludedOptions = [
                telusOptikTvMonthlyRatePlanOptionValues.tv,
                telusOptikTvMonthlyRatePlanOptionValues.tvBasic,
                telusOptikTvMonthlyRatePlanOptionValues.tvElite
              ];

              fields.options = ratePlanField.options.filter(opt =>
                !excludedOptions.includes(opt.fields.value)
              );
            }

            if (
              [
                telusOptikTvMonthlyRatePlanOptionValues.tv,
                telusOptikTvMonthlyRatePlanOptionValues.tvBasic,
                telusOptikTvMonthlyRatePlanOptionValues.tvElite
              ].includes(valueTelusOptikTv)
            ) {
              formFields[fieldTelusOptikTvMonthlyRatePlan].value = undefined;
            }
          } else {
            const allowedOptions = [
              telusOptikTvMonthlyRatePlanOptionValues.tv,
              telusOptikTvMonthlyRatePlanOptionValues.tvBasic,
              telusOptikTvMonthlyRatePlanOptionValues.tvElite,
            ];
            fields.options = ratePlanField.options.filter(opt => {
              return allowedOptions.includes(opt.fields.value);
            });

            if (!allowedOptions.includes(valueTelusOptikTv)) {
              formFields[fieldTelusOptikTvMonthlyRatePlan].value = undefined;
            }
          }
        }
      }

      if (formStepBackendKey === BACKEND_KEYS.officeInternetFiber) {
        const validProvinces = [britishColumbia, alberta, ab, bc];
        if (validProvinces.includes(orderData.parsedProvince)) {
          if (
            [
              fieldLimitedYearlyOffersFibre150,
              'limitedYearlyOffersFibre',
              'limitedYearlyOffersFibre300',
              'limitedTimeOfferYearly15g',
              'limitedMonthlyOfferFibre2_5G',
              'limitedTimeOfferYearly3g_3000'
            ].includes(fieldName)
          ) {
            if (formFields.limitedTimeOfferYearly3g_3000) {
              formFields.limitedTimeOfferYearly3g_3000.isRequired = false;
            }
            return null;
          }
        } else if (
          [
            'limitedTimeOfferYearly15gAlbertaBC',
            'limitedYearlyOffersFibreAlbertaBC',
            'limitedTimeOfferYearly3g_3000AlbertaBC'
          ].includes(fieldName)
        ) {
          return null;
        }

        if (
          fieldName === 'numberTelusWifiAccessPointsFibre' &&
          validProvinces.includes(orderData.parsedProvince)
        ) {
          fields.note = noteNumberTelusWifiAccessPointsFibre;
        }

        if (
          [
            numberTelusWifiAccessPointsFibre,
            fieldTelusBusinessWifi,
            fieldTelusBusinessWifiTypeFibre
          ].includes(fieldName)
        ) {
          if (telusPublicWifiFibreValue && telusPublicWifiFibreValue === yes) {
            return null;
          }
        }
        const valueTermFibre = getFieldValue(fieldTermFibre, formFields);
        const valueTermCopper = getFieldValue(fieldTerm, formFields);
        const valueRegularYearlyPromoFibre = getFieldValue(fieldRegularYearlyOffersFibreBundled, formFields);
        const valueRegularYearlyOfferFibreBundled = getFieldValue('regularYearlyOfferFibreBundled', formFields);
        const filterSwitchCreditPromoOptions = (hideOptions) => {
          const { options } = formFields[switchCredit$100];
          return options.filter(opt => {
            return !hideOptions.includes(opt.fields.value);
          });
        };

        // SOF-2032 (Switch Credit $100 Promo)
        if (fieldName === switchCredit$100 && !valueTermCopper) {
          if (
            valueTermFibre !== _valueTerm36Month &&
            valueTermFibre !== _valueTerm60Month
          ) {
            return null;
          }
          if (
            valueTermFibre === _valueTerm36Month ||
            valueTermFibre === _valueTerm60Month
          ) {
            // SOF-2032 (Removing Switch Credit promo for 15mbps)
            if (
              !qualifiedSpeedFibreValue ||
              qualifiedSpeedFibreValue === valueQualifiedSpeed15mbps
            ) {
              return null;
            }
            // SOF-2188 (removing 600 buyoutcreditpromo for 150 and 300)
            if (fieldName === switchCredit$100) {
              const filterOptions = [];
              const isBusinessConnectSelected =
                valueProductSelectionFibre &&
                valueProductSelectionFibre.includes(fieldBusinessConnect);
              const isBundledSelected =
                valueRegularYearlyOfferFibreBundled &&
                valueRegularYearlyOfferFibreBundled === 'bundled';
              if (!(isBundledSelected && isBusinessConnectSelected)) {
                filterOptions.push(
                  internetAndBusinessConnectBundleBillCredit200
                );
              }
              if (
                qualifiedSpeedFibreValue &&
                (qualifiedSpeedFibreValue === valueQualifiedSpeed150mbps ||
                  qualifiedSpeedFibreValue === valueQualifiedSpeed300mbps)
              ) {
                filterOptions.push(contractBuyoutBillCredit600);
              }
              fields.options = [
                ...filterSwitchCreditPromoOptions(filterOptions)
              ];
            }

            if (!valueRegularYearlyPromoFibre) {
              return null;
            }
          }
        }

        // SOF-1844  (Promo Visibility)
        const filterPromoForNonAdmin = () => {
          const {options} = formFields[fiveYearlyFibrePromos];
          const optionsToRemove = [fiveDollarsOff];
          if (
            valueTermFibre === _valueTerm60Month &&
            qualifiedSpeedFibreValue === valueQualifiedSpeed150mbps
          )
            optionsToRemove.push(sixMonthsFreePromo);
          return options.filter(
            opt => !optionsToRemove.includes(opt.fields.value)
          );
        };

        const filterPromoOptions = () => {
          const {options} = formFields[fiveYearlyFibrePromos];
          return options.filter(opt => {
            return ![sixMonthsFreePromo].includes(opt.fields.value);
          });
        };

        if (
          valueRegularYearlyOfferFibreBundled === standaloneOffer &&
          qualifiedSpeedFibreValue !== valueQualifiedSpeed940mbps &&
          fieldName === fieldMppOffers
        ) {
          return null;
        }

        if (
          qualifiedSpeedFibreValue === _valueFiveGSpeed &&
          fieldName === fieldMppOffers
        ) {
          return null;
        }

        if (
          fieldName === fieldMppOffers &&
          !['QC'].includes(request.getProvince())
        ) {
          const valueRegularOffers = getFieldValue(
            'regularYearlyOfferFibreBundled',
            formFields
          );

          if (valueRegularOffers === _bundled) {
            fields.options = formFields[fieldMppOffers].options.filter(opt => {
              return ![mppFibreInternet1G].includes(opt.fields.value);
            });
          } else if (valueRegularOffers === standaloneOffer) {
            fields.options = formFields[fieldMppOffers].options.filter(opt => {
              return ![mppCrossSellOffer15].includes(opt.fields.value);
            });
          } else if (formFields[fieldMppOffers]) {
            fields.options = formFields[fieldMppOffers].options;
          }
        }

        if (
          fieldName === fieldQualifiedSpeedFibre &&
          ['QC'].includes(request.getProvince())
        ) {
          const allowedOptionsForQuebec = [
            '150/25 mbps',
            '300/300 mbps',
            '940/940 mbps'
          ];

          if (
            formFields &&
            formFields[fieldQualifiedSpeedFibre] &&
            formFields[fieldQualifiedSpeedFibre].options
          ) {
            fields.options = formFields[
              fieldQualifiedSpeedFibre
            ].options.filter(opt => {
              return allowedOptionsForQuebec.includes(opt.fields.value);
            });
          }
        }

        const conditionsForFiveG =
          ![_valueTerm60Month].includes(valueForTermFibre) &&
          ['AB', 'BC'].includes(request.getProvince());
        if (fieldName === fieldQualifiedSpeedFibre && !conditionsForFiveG) {
          const notAllowedOptions = [_valueFiveGSpeed];

          if (
            formFields &&
            formFields[fieldQualifiedSpeedFibre] &&
            formFields[fieldQualifiedSpeedFibre].options
          ) {
            fields.options = formFields[
              fieldQualifiedSpeedFibre
              ].options.filter(opt => {
              return !notAllowedOptions.includes(opt.fields.value);
            });
          }
        }

        if (fieldName === fiveYearlyFibrePromos) {
          if (
            valueTermFibre !== _valueTerm60Month &&
            valueTermCopper !== _valueTerm60Month
          ) {
            return null;
          } if (
            fieldName === fiveYearlyFibrePromos &&
            !valueRegularYearlyPromoFibre
          ) {
            return null;
          }
          if (
            valueTermFibre === _valueTerm60Month &&
            qualifiedSpeedFibreValue === valueQualifiedSpeed150mbps
          ) {
            fields.options = [...filterPromoOptions()];
            fields.options = [...filterPromoForNonAdmin()];
          } else if (
            // SOF-1847 Hide 6monthsFree FOR 750/750 Mbps Speed For Non Admin
            role.name !== ROLES.ADMIN &&
            valueTermFibre === _valueTerm60Month &&
            qualifiedSpeedFibreValue === valueQualifiedSpeed750mbps
          ) {
            return null;
          } else if (
            valueTermFibre === _valueTerm60Month &&
            qualifiedSpeedFibreValue === valueQualifiedSpeed150mbps
          ) {
            fields.options = [...filterPromoForNonAdmin()];
          } else if (
            // SOF-1847 Hide 6monthsFree FOR 750/750 Mbps Speed
            valueTermFibre === _valueTerm60Month &&
            qualifiedSpeedFibreValue === valueQualifiedSpeed750mbps
          ) {
            fields.options = [...filterPromoOptions()];
            // clear already selected value of fiveYearlyFibrePromos if previous value was 6MonthsFree
            if (
              formFields[fiveYearlyFibrePromos].value === sixMonthsFreePromo
            ) {
              formFields[fiveYearlyFibrePromos].value = undefined;
            }
          } else {
            fields.options = formFields[fiveYearlyFibrePromos].options;
          }
        }
        if (fieldName === fiveYearlyFibrePromos && role.name !== ROLES.ADMIN) {
          fields.options = [...filterPromoForNonAdmin()];
        }

        // SOF-1847 HIDE CBM & MPP from Limited Offers For 60 Month Term
        if (valueTermFibre === _valueTerm60Month) {
          // 75Mbps
          if (fieldName === fieldLimitedOfferFI
            && qualifiedSpeedFibreValue === valueQualifiedSpeed75mbps
          ) {
            return null;
          }
        }
        const filterLiimited300Options = () => {
          const {options} = formFields[fieldLimitedYearlyOffersFibre300];
          return options.filter(opt => {
            return ![
              FibreInternet300CBMGroup1,
              FibreInternet300CBMGroup2,
              FibreInternet300MPP
            ].includes(opt.fields.value);
          });
        };
        // 300Mbps
        if (
          fieldName === fieldLimitedYearlyOffersFibre300 &&
          valueTermFibre === _valueTerm60Month
        ) {
          if (qualifiedSpeedFibreValue === valueQualifiedSpeed300mbps) {
            fields.options = [...filterLiimited300Options()];
            // clear already selected values
            if (
              formFields[fieldLimitedYearlyOffersFibre300].value ===
              FibreInternet300CBMGroup1 ||
              formFields[fieldLimitedYearlyOffersFibre300].value ===
              FibreInternet300CBMGroup2 ||
              formFields[fieldLimitedYearlyOffersFibre300].value ===
              FibreInternet300MPP
            ) {
              formFields[fieldLimitedYearlyOffersFibre300].value = undefined;
            }
          }
        } else if (
          fieldName === fieldLimitedYearlyOffersFibre300 &&
          valueTermFibre === _valueTerm36Month
        ) {
          fields.options = formFields[fieldLimitedYearlyOffersFibre300].options;
        }

        // 940 || 1G Mbps
        const filterLiimited1GOptions = () => {
          const {options} = formFields[fieldLimitedYearlyOffersFibre];
          return options.filter(opt => {
            return ![
              fieldFiberInternetG1,
              fieldFiberInternetG2,
              fieldFiberInternetMPP,
              fieldFiberSwitch1GSwitch
            ].includes(opt.fields.value);
          });
        };
        if (
          fieldName === fieldLimitedYearlyOffersFibre &&
          valueTermFibre === _valueTerm60Month
        ) {
          if (qualifiedSpeedFibreValue === valueQualifiedSpeed940mbps) {
            fields.options = [...filterLiimited1GOptions()];
            // clear already selected values
            if (
              formFields[fieldLimitedYearlyOffersFibre].value ===
              fieldFiberInternetG1 ||
              formFields[fieldLimitedYearlyOffersFibre].value ===
              fieldFiberInternetG2 ||
              formFields[fieldLimitedYearlyOffersFibre].value ===
              fieldFiberInternetMPP
            ) {
              formFields[fieldLimitedYearlyOffersFibre].value = undefined;
            }
          }
        } else if (
          fieldName === fieldLimitedYearlyOffersFibre &&
          valueTermFibre === _valueTerm36Month
        ) {
          fields.options = formFields[fieldLimitedYearlyOffersFibre].options;
        }

        // 1.5G Mbps
        const filterLimited15GOptions = () => {
          const {options} = formFields[fieldLimitedTimeOfferYearly15g];
          return options.filter(opt => {
            return ![fieldFiberSwitch15GSwitch].includes(opt.fields.value);
          });
        };
        if (
          fieldName === fieldLimitedTimeOfferYearly15g &&
          valueTermFibre === _valueTerm60Month
        ) {
          if (qualifiedSpeedFibreValue === valueQualifiedSpeed15gFibre) {
            fields.options = [...filterLimited15GOptions()];
            // clear already selected values
            if (
              formFields[fieldLimitedTimeOfferYearly15g].value ===
              fieldFiberSwitch15GSwitch
            ) {
              formFields[fieldLimitedTimeOfferYearly15g].value = undefined;
            }
          }
        } else if (
          fieldName === fieldLimitedTimeOfferYearly15g &&
          valueTermFibre === _valueTerm36Month
        ) {
          fields.options = formFields[fieldLimitedTimeOfferYearly15g].options;
        }

        if ([
          numberTelusWifiAccessPointsFibre,
          fieldTelusBusinessWifiTypeFibre
        ].includes(fieldName)) {
          if (!(valueTelusBusinessWifi && valueTelusBusinessWifi === yes)) {
            return null;
          }
        }
        if (
          valueTermFibre === _valueTerm36Month &&
          qualifiedSpeedFibreValue === valueQualifiedSpeed940mbps &&
          valueRegularYearlyPromoFibre === standaloneOffer &&
          fieldName === numberTelusWifiAccessPointsFibre
        ) {
          formFields[numberTelusWifiAccessPointsFibre].monthlyPayment = 0;
        } else if (
          fieldName === numberTelusWifiAccessPointsFibre &&
          _.get(formFields, fieldName, false)
        ) {
          formFields[numberTelusWifiAccessPointsFibre].monthlyPayment = 15;
        }
        if (fieldName === fieldTelusBusinessWifi) {
          if (
            ![
              valueQualifiedSpeed15mbps,
              valueQualifiedSpeed25mbps,
              valueQualifiedSpeed75mbps,
              valueQualifiedSpeed150mbps,
              valueQualifiedSpeed300mbps,
              valueQualifiedSpeed750mbps,
              valueQualifiedSpeed940mbps,
              valueQualifiedSpeed15gFibre,
              valueQualifiedSpeed3gFibre,
              mbps3g3000,
              _valueFiveGSpeed
            ].includes(getFieldValue(fieldQualifiedSpeedFibre, formFields))
          ) {
            return null;
          }
        }
      }

      if (formStepBackendKey === BACKEND_KEYS.officeInternetCopper) {
        if (
          [
            numberTelusWifiAccessPointsCopper,
            fieldTelusBusinessWifi,
            fieldTelusBusinessWifiTypeCopper
          ].includes(fieldName)
        ) {
          if (valuePublicWifiCopper && valuePublicWifiCopper === yes) {
            return null;
          }
        }
        if (
          [
            numberTelusWifiAccessPointsCopper,
            fieldTelusBusinessWifiTypeCopper
          ].includes(fieldName)
        ) {
          if (!(valueTelusBusinessWifi && valueTelusBusinessWifi === yes)) {
            return null;
          }
        }
      }

      if (
        fieldName === fieldLimitedTimeBasicOffer &&
        getFieldValue(fieldQualifiedSpeed, formFields) &&
        getFieldValue(fieldQualifiedSpeed, formFields) !==
        valueOfficeInternetBasic &&
        getFieldValue(fieldTerm, formFields) &&
        (getFieldValue(fieldTerm, formFields) !== _valueTerm36Month ||
          getFieldValue(fieldTerm, formFields) !== _valueTerm60Month) &&
        formStepBackendKey === BACKEND_KEYS.officeInternetCopper
      ) {
        return null;
      }
      const qualifiedSpeedValue = getFieldValue(
        fieldQualifiedSpeedFibre,
        formFields
      );

      const valueRegularYearlyPromoCopper = getFieldValue(
        fieldRegularYearlyOffers,
        formFields
      );
      const valueHighestQualifiedSpeed = getFieldValue(
        fieldHighestQualifiedSpeed,
        formFields
      );
      const valueTermFibre = getFieldValue(fieldTermFibre, formFields);
      const valueTermCopper = getFieldValue(fieldTerm, formFields);
      const filterPromoForNonAdmin = () => {
        const {options} = formFields[fiveYearlyCopperPromos];
        return options.filter(opt => {
          return ![fiveDollarsOff].includes(opt.fields.value);
        });
      };
      // Hide Internet Copper Promos five yearly promos if user is not an Admin
      if (fieldName === fiveYearlyCopperPromos) {
        if (valueTermCopper !== _valueTerm60Month) {
          return null;
        }
        if (
          valueHighestQualifiedSpeed !== 'fifteenMBPS' &&
          !valueRegularYearlyPromoCopper
        )
          return null;
      }
      if (fieldName === fiveYearlyCopperPromos && role.name !== ROLES.ADMIN) {
        fields.options = [...filterPromoForNonAdmin()];
      }
      if (
        fieldName === fieldLimitedMonthlyOfferFibre
        // && formStepBackendKey === BACKEND_KEYS.officeInternetFiber
        // && qualifiedSpeedValue !== mbps3g
      ) {
        return null;
      }
      const locality = localStorage.getItem('locality');
      if (
        formStepBackendKey === BACKEND_KEYS.officeInternetFiber &&
        fieldName === fieldQualifiedSpeedFibre
      ) {
        if (getFieldValue(fieldCustomerRequestFibre3G, formFields) === no) {
          fields.options = fields.options.filter(
            option => option.fields.value !== mbps3g
          );
        }
      }
      // SOF-2032 (Switch Credit $100 Promo)
      if (fieldName === switchCreditCopper && !valueTermFibre) {
        if (
          valueTermCopper !== _valueTerm36Month &&
          valueTermCopper !== _valueTerm60Month
        ) {
          return null;
        }
        if (
          valueTermCopper === _valueTerm36Month ||
          valueTermCopper === _valueTerm60Month
        ) {
          // SOF-2032 (Removing Switch Credit promo for 15mbps)
          if (
            !valueHighestQualifiedSpeed ||
            valueHighestQualifiedSpeed === valueQualifiedSpeed15mbps
          ) {
            return null;
          }
          if (!valueRegularYearlyPromoCopper) {
            return null;
          }
        }
      }

      if (
        formStepBackendKey === BACKEND_KEYS.productInformation &&
        fieldName === fieldCustomerRequestFibre3G
      ) {
        const {
          British_Columbia: bColumbiaProvince,
          Alberta: albertaProvince
        } = provinceAlias;
        if (!locality === fibre25GLocality) {
          return null;
        }
        // if province in address is Alberta or British Columbia then show 'requesting Fibre 2.5G'
        // else hide and remove
        if ([albertaProvince, bColumbiaProvince].includes(localStorage.getItem('province'))) {
          // console.log('SHOW')
        } else {
          return null;
        }
      }
      // logic to save productSelectionFibreOptions in local storage so that we do not shallow copy its
      // field options while filtering in the next check in case of fibre speed 1.5G
      if (fieldName === fieldProductSelectionFibre
        && !JSON.parse(localStorage.getItem('productSelectionFibreOptions'))
      ) {
        // condition is such that if there is nothing saved in localStorage with the variable name
        // productSelectionFibreOptions, only then it should call setItem. Otherwise, skip this check
        // to avoid re-writing the productSelectionFibreOptions variable.
        window.localStorage.setItem(
          'productSelectionFibreOptions',
          JSON.stringify(fields.options)
        );
      }
      const productSelectionValue = _.get(orderData, fieldProductSelection, []);
      if (productSelectionValue.includes(telusTVforBusiness)
        && fieldName === fieldInstallation && !formFields[fieldInstallation].value) {
        // Check if 'TELUS TV for Business' is the only item in the array
        if (orderData.productSelection.length === 1 && ![valuePublicLegacy, valuePrivateLegacy].includes(TelusOptikTvProfileType)) {
          formFields[fieldInstallation].value = selfInstall;
          // Check if 'TELUS TV for Business' and at least one more product are present
        } else if (orderData.productSelection.length > 1 && ![valuePublicLegacy, valuePrivateLegacy].includes(TelusOptikTvProfileType)) {
          formFields[fieldInstallation].value = waivedMultiProductOrder;
        } else{
          formFields[fieldInstallation].value = '';
        }
      }

      const {
        British_Columbia: bColumbiaProvince,
        Alberta: albertaProvince
      } = provinceAlias;
      let pro = localStorage.getItem('province');
      if (!pro) pro = orderData.parsedProvince;
      if (userChannelName) {
        if (
          !MM_CHANNELS.includes(userChannelName) &&
          Object.keys(MM_CHANNELS_FLOW_KEYS).includes(fieldName)
        ) {
          return null;
        }
        const isValidSelection = value => !(Array.isArray(value) && value.includes('Secure Business') && value.length >= 1);
        const productSelectionValuesArr = getFieldValue(
          'productSelection',
          formFields
        );
        if (isValidSelection(productSelectionValuesArr)
          && MM_CHANNELS.includes(userChannelName)
          && Object.keys(MM_CHANNELS_FLOW_KEYS).includes(fieldName)
        ) {
          return null;
        }
        if (
          MM_CHANNELS.includes(userChannelName) &&
          Object.keys(productSelectionValues).includes(fieldName)
        ) {
          return null;
        }
        if (
          ![albertaProvince, bColumbiaProvince].includes(pro) &&
          !MM_CHANNELS.includes(userChannelName) &&
          Object.keys(MM_CHANNELS_FLOW_KEYS).includes(fieldName)
        ) {
          return null;
        }
      } else if (Object.keys(MM_CHANNELS_FLOW_KEYS).includes(fieldName)) {
        return null;
      }

      if (isAllPrequalQuestionAnswered()) {
        const flow = getFlow(formFields);
        if (MM_CHANNELS.includes(userChannelName)) {
          if (['QC'].includes(request.getProvince())) {
            if (
              [0, 1].includes(flow) &&
              Object.keys(MM_CHANNELS_KEYS_NOTES).includes(fieldName)
            ) {
              hardStop = false;
              return null;
            }
            if (
              [2].includes(flow) &&
              [
                MM_CHANNELS_KEYS_NOTES.customerQualifyForTSB,
                MM_CHANNELS_KEYS_NOTES.customerQualifyForTSBEnhanced,
                MM_CHANNELS_KEYS_NOTES.channelComplexNoteForMMChannels
              ].includes(fieldName)
            ) {
              hardStop = true;
              return null;
            }
            if (
              [3].includes(flow) &&
              [
                MM_CHANNELS_KEYS_NOTES.customerQualifyForTSB,
                MM_CHANNELS_KEYS_NOTES.customerQualifyForTSBPlus,
                MM_CHANNELS_KEYS_NOTES.channelComplexNoteForMMChannels
              ].includes(fieldName)
            ) {
              hardStop = true;
              return null;
            }
            if (
              [4].includes(flow) &&
              [
                MM_CHANNELS_KEYS_NOTES.customerQualifyForTSB,
                MM_CHANNELS_KEYS_NOTES.customerQualifyForTSBPlus,
                MM_CHANNELS_KEYS_NOTES.customerQualifyForTSBEnhanced
              ].includes(fieldName)
            ) {
              hardStop = true;
              return null;
            }

          } else {
            if (
              [1].includes(flow) &&
              [
                MM_CHANNELS_KEYS_NOTES.customerQualifyForTSBPlus,
                MM_CHANNELS_KEYS_NOTES.customerQualifyForTSBEnhanced,
                MM_CHANNELS_KEYS_NOTES.channelComplexNoteForMMChannels
              ].includes(fieldName)
            ) {
              hardStop = true;
              return null;
            }
            if (
              [2].includes(flow) &&
              [
                MM_CHANNELS_KEYS_NOTES.customerQualifyForTSB,
                MM_CHANNELS_KEYS_NOTES.customerQualifyForTSBEnhanced,
                MM_CHANNELS_KEYS_NOTES.channelComplexNoteForMMChannels
              ].includes(fieldName)
            ) {
              hardStop = true;
              return null;
            }
            if (
              [3].includes(flow) &&
              [
                MM_CHANNELS_KEYS_NOTES.customerQualifyForTSB,
                MM_CHANNELS_KEYS_NOTES.customerQualifyForTSBPlus,
                MM_CHANNELS_KEYS_NOTES.channelComplexNoteForMMChannels
              ].includes(fieldName)
            ) {
              hardStop = true;
              return null;
            }
            if (
              [4].includes(flow) &&
              [
                MM_CHANNELS_KEYS_NOTES.customerQualifyForTSB,
                MM_CHANNELS_KEYS_NOTES.customerQualifyForTSBPlus,
                MM_CHANNELS_KEYS_NOTES.customerQualifyForTSBEnhanced
              ].includes(fieldName)
            ) {
              hardStop = true;
              return null;
            }
          }
        }
      } else if (Object.keys(MM_CHANNELS_KEYS_NOTES).includes(fieldName)) {
        return null;
      }

      telusSecureBusinessSelection =
        _.get(orderData, 'productSelection', []).includes(productSelection.telusSecureBusiness) ||
        orderData.productType === feildBetterBusinessBundleCopper ||
        orderData.productType === feildBetterBusinessBundleFibre;
      const fieldValue = getFieldValue(fieldName, formFields);
      const isBusinessLegalNameQuoteToolValue = orderData[businessLegalNameQuoteTool];
      const setBusinessLegalValues = value => {
        Object.keys(secureBusinessLegalNameFieldTypes).forEach(key => {
          if (!(formFields[key] && formFields[key].value)) {
            if (formFields[key]) formFields[key].value = value;
          }
        });
      };
      const {
        businessLegalName,
        businessLegalNameNonProfit,
        businessLegalNamePersonal
      } = secureBusinessLegalNameFieldTypes;

      if (
        formFields[businessLegalNameNonProfit] ||
        formFields[businessLegalNamePersonal]
      ) {
        setBusinessLegalValues(isBusinessLegalNameQuoteToolValue);
      }
      if (fieldName === 'confirmExistingTelusHSIA' || fieldName === 'existingCustomerAccountNumber') {
        const internetChoice = _.get(orderData, 'productSelection', []);
        if (
          internetChoice.includes(officeInternetCopper) ||
          internetChoice.includes(officeInternetFiber)
        ) {
          if (formFields.confirmExistingTelusHSIA) {
            formFields.confirmExistingTelusHSIA.isRequired = false;
          }
          return null;
        }
      };
      if (fieldName === fieldRegularMonthlyOffers || fieldName === fieldTerm) {
        const limitedTimeOffersField = findField(
          data,
          fieldLimitedTimeBasicOffer
        );
        const {
          fields: { options }
        } = limitedTimeOffersField && limitedTimeOffersField;
        if (
          fieldValue === sixByTweleveonthPromo ||
          qualifiedSpeedValue === mbps3g
        ) {
          limitedTimeOffersField.fields.options = disableOption(
            options,
            threeMonthsFree,
            false
          );
        } else {
          limitedTimeOffersField.fields.options = disableOption(
            options,
            threeMonthsFree,
            true
          );
        }
      }
      if (
        fieldName === fieldRegularMonthlyOffersFibre ||
        fieldName === fieldTermFibre
      ) {
        const limitedTimeOffersField = findField(
          data,
          fieldLimitedMonthlyOfferFibre
        );
        const {
          fields: { options }
        } = limitedTimeOffersField && limitedTimeOffersField;
        // if (fieldValue === sixByTweleveonthPromo || qualifiedSpeedValue === mbps3g) {
        if (fieldValue === sixByTweleveonthPromo) {
          limitedTimeOffersField.fields.options = disableOption(
            options,
            threeMonthsFree,
            false
          );
        } else {
          limitedTimeOffersField.fields.options = disableOption(
            options,
            threeMonthsFree,
            true
          );
        }
      }
      const permitNumber = getFieldValue(
        fieldPermitNumberUserAccountDetail,
        formFields
      );

      let selectOptions;
      const error = formErrors[fieldName];
      const key = `FormField${fieldName}${indexRoot}${sysId}`;
      let result;
      if (expiredDate && new Date(expiredDate) < new Date()) return null;
      if (!isRelatedFieldExisted(fields, formFields, orderData, isFormTouched))
        return null;
      if (
        fieldName === feildSourceOfSale &&
        !sourceOfChannelsList.includes(userChannelName)
      ) {
        return null;
      }
      // 613
      const { orderType, customerExistingServices } = orderData;
      if (
        (fieldName === fieldWinbackFibre || fieldName === fieldWinback) &&
        orderType &&
        orderType !== valueNewTelusBusinessOrder
      ) {
        return null;
      }

      if (fieldName === fieldTelusOptikTvPricingAndOffers) {
        const valueProfileType = getFieldValue(
          fieldTelusOptikTvProfileType,
          formFields
        );

        const valueTelusOptikTvPricingAndOffers = getFieldValue(
          fieldTelusOptikTvPricingAndOffers,
          formFields
        );

        const valueTelusOptikTv = getFieldValue(
          fieldTelusOptikTvMonthlyRatePlan,
          formFields
        );

        if ([valuePrivateHomeBasedOpus, valuePublicOpus].includes(valueProfileType)) {
          const notAllowedRatePlan = [
            telusOptikTvMonthlyRatePlanOptionValues.core,
            telusOptikTvMonthlyRatePlanOptionValues.basics
          ];
          selectOptions = fields.options.filter(opt => {
            return !['12 Month promo optik', '6 Month promo optik'].includes(
              opt.fields.value
            );
          });

          if (valueProfileType === valuePublicOpus) {
            selectOptions = fields.options.filter(opt => {
              return !['12 Month promo optik', '6 Month promo optik', 'Add Recordings / Cloud Personal Video Recorder (cPVR)'].includes(
                opt.fields.value
              );
            });
          }

          if (!valueTelusOptikTv) {
            selectOptions = fields.options.filter(opt => {
              return ![
                '12 Month promo optik',
                'Add Recordings / Cloud Personal Video Recorder (cPVR)',
                '6 Month promo optik'
              ].includes(opt.fields.value);
            });
          }

          if (!notAllowedRatePlan.includes(valueTelusOptikTv)) {
            selectOptions = fields.options.filter(opt => {
              return ![
                '12 Month promo optik',
                'Add Recordings / Cloud Personal Video Recorder (cPVR)',
                '6 Month promo optik'
              ].includes(opt.fields.value);
            });

            if (
              valueTelusOptikTvPricingAndOffers &&
              valueTelusOptikTvPricingAndOffers.includes('Add Recordings / Cloud Personal Video Recorder (cPVR)')
            ) {
              formFields[fieldTelusOptikTvPricingAndOffers].value = [];
            }
          }

          if (valueTelusOptikTvPricingAndOffers) {
            if (valueTelusOptikTvPricingAndOffers.includes('Add Recordings / Cloud Personal Video Recorder (cPVR)')) {
              selectOptions = fields.options.filter(opt => {
                return ![
                  '12 Month promo optik',
                  '6 Month promo optik'
                ].includes(opt.fields.value);
              });
            }
          }
        }

        if (![valuePrivateHomeBasedOpus, valuePublicOpus].includes(valueProfileType)) {
          selectOptions = fields.options.filter(opt => {
            return !['Add Recordings / Cloud Personal Video Recorder (cPVR)'].includes(opt.fields.value);
          });

          if (
            valueTelusOptikTv ===
            telusOptikTvMonthlyRatePlanOptionValues.tvBasic
          ) {
            selectOptions = fields.options.filter(opt => {
              return ['Standard Rate'].includes(opt.fields.value);
            });
          }
          if (
            valueTelusOptikTvPricingAndOffers &&
            valueTelusOptikTvPricingAndOffers.includes('Standard Rate')
          ) {
            selectOptions = fields.options.filter(opt => {
              return ![
                '12 Month promo optik',
                'Add Recordings / Cloud Personal Video Recorder (cPVR)',
                '6 Month promo optik'
              ].includes(opt.fields.value);
            });
          }

          if (
            valueTelusOptikTvPricingAndOffers &&
            valueTelusOptikTvPricingAndOffers.includes('12 Month promo optik')
          ) {
            selectOptions = fields.options.filter(opt => {
              return !['Standard Rate', 'Add Recordings / Cloud Personal Video Recorder (cPVR)', '6 Month promo optik'].includes(
                opt.fields.value
              );
            });
          }

          if (
            valueTelusOptikTvPricingAndOffers &&
            valueTelusOptikTvPricingAndOffers.includes('6 Month promo optik')
          ) {
            selectOptions = fields.options.filter(opt => {
              return ![
                'Standard Rate',
                'Add Recordings / Cloud Personal Video Recorder (cPVR)',
                '12 Month promo optik'
              ].includes(opt.fields.value);
            });
          }
        }
      }
      if (fieldName === fieldInternetType) {
        if (!customerExistingServices.includes(fieldValueHSIA)) {
          if (!internetTypeoptions) setInternetTypeoptions(fields.options);
          fields.options = fields.options.filter(
            option => !internetTypesOptionLables.includes(option.fields.value)
          );
        } else if (internetTypeoptions) {
          fields.options = internetTypeoptions;
        }
      }
      if (
        (fieldName === fieldProductHomeBasedBusiness ||
          hBBQualificationFields.includes(fieldName)) &&
        getFieldValue(existingConnection, formFields) === existingNo &&
        getFieldValue(telusUpgrade, formFields) === telusNo
      ) {
        return null;
      }

      const selectedChannel = 'CORP_STORE';
      const valueSecurityPackages = getFieldValue(
        fieldTelusSecureBusinessSecurityPackage,
        formFields
      );
      const valueVulcanOrder = _.get(orderData, fieldIsPureFibreEastLeadWLN);

      if (userChannelName
        && selectedChannel.includes(userChannelName)
        && valueVulcanOrder === "Yes") {
        if (fieldName === secureBusinessTerm) {
          const allowedTermOptionsForCorpStore = ['36 Month Term'];

          if (
            formFields &&
            formFields[secureBusinessTerm] &&
            formFields[secureBusinessTerm].options
          ) {
            fields.options = formFields[secureBusinessTerm].options.filter(
              opt => {
                return allowedTermOptionsForCorpStore.includes(
                  opt.fields.value
                );
              }
            );
          }
        }
        if (fieldName === fieldTelusSecureBusinessSecurityPackage) {
          const allowedSecurityPackageOptionsForCorpStore = [
            'Monitor',
            'Protect',
            'Control'
          ];

          if (
            formFields &&
            formFields[fieldName] &&
            formFields[fieldName].options
          ) {
            fields.options = formFields[fieldName].options.filter(opt => {
              return allowedSecurityPackageOptionsForCorpStore.includes(opt.fields.value);
            });
          }
        }
        const allowedSecurityPackageOptionsForCorpStore = ['Monitor', 'Protect', 'Control'];
        if (allowedSecurityPackageOptionsForCorpStore.includes(valueSecurityPackages)
          && fieldName === fieldSecureBusinessOffers ) {
          const allowedOffersForCorpStore = [
            _tenDollarOff,
            _valueThreeMonthsFree,
            _tenDollarBundleDiscount,
            _100DollarOffInstallation
          ];

          if (formFields && formFields[fieldName] && formFields[fieldName].options) {
            fields.options = formFields[fieldName].options.filter(opt => {
              return allowedOffersForCorpStore.includes(opt.fields.value);
            });
          }
        }
      }

      if (!(orderData.serviceAddress && hasQuebecInAddress(orderData.serviceAddress))) {
        if (fieldName === fieldContractLanguagePreference) {
          return null;
        }
      }
      if (!_.get(orderData, 'productSelection', []).includes('Secure Business')) {
        if (fieldName === fieldIsThisHomeBasedBusiness) {
          return null;
        }
        if (fieldName === fieldDoesCustomerHaveLawnOrFenceOnPremise) {
          return null;
        }
      }
      if (orderData.productHomeBasedBusiness) {
        if (fieldName === fieldIsThisHomeBasedBusiness) {
          if (formFields[fieldIsThisHomeBasedBusiness]) {
            formFields[fieldIsThisHomeBasedBusiness].value =
              orderData.productHomeBasedBusiness;
          }
        }
      }
      if (!permitNumber) {
        // eslint-disable-next-line no-unused-expressions
        fields &&
        fields.formStepFields &&
        fields.formStepFields.forEach((el, index) => {
          if (el.fields.name === fieldExpirationKey) {
            obj = el;
            setItem(fieldsKeyLocalStorage, obj);
            delete fields.formStepFields[index];
          }
        });
      } else if (
        localStorage.getItem(fieldsKeyLocalStorage) &&
        fields &&
        fields.formStepFields &&
        (fieldName === fieldAccountDetails ||
          fieldName === fieldAccountDetailsFr)
      ) {
        fields.formStepFields.push(
          JSON.parse(localStorage.getItem(fieldsKeyLocalStorage))
        );
        removeItem(fieldsKeyLocalStorage);
      }
      if (gisIdConditon) {
        return null; // eslint-disable-line
      }

      const internetChoice = getFieldValue(fieldProductSelection, formFields);
      const isthisSpecialRetailer = getFieldValue(
        productSelectionValues.isthisSpecialRetailer,
        formFields
      );
      const isProtectingHighValueItems = getFieldValue(
        productSelectionValues.isProtectingHighValueItems,
        formFields
      );
      const isBuildingOverSize = getFieldValue(
        productSelectionValues.isBuildingOverSize,
        formFields
      );
      const moreThanEightCameras = getFieldValue(
        productSelectionValues.moreThanEightCameras,
        formFields
      );
      const camerasInstalledAtHeight = getFieldValue(
        productSelectionValues.camerasInstalledAtHeight,
        formFields
      );
      if (
        [productSelectionValues.complexNote].includes(fieldName) &&
        isEqual(isthisSpecialRetailer, no) &&
        isEqual(isProtectingHighValueItems, no) &&
        isEqual(isBuildingOverSize, no) &&
        isEqual(moreThanEightCameras, no) &&
        isEqual(camerasInstalledAtHeight, no)
      ) {
        return null;
      }
      if (
        fieldName === channelComplexNote &&
        !complexChannels.includes(userChannelName)
      ) {
        return null;
      }
      if (
        fieldName === complexNote &&
        complexChannels.includes(userChannelName)
      ) {
        return null;
      }
      const validProvinces = [britishColumbia, alberta, manitoba, saskatchewan, ab, mb, sk, bc];
      const valueProdSelection = _.get(orderData, 'parsedProvince', []);
      const isValidProvinceProduct = orderData.parsedProvince &&
        validProvinces.includes(valueProdSelection);
      if (
        (fieldName === smbPlatinum) &&
        !isValidProvinceProduct
      ) {
        return true;
      }
      if (title === reminder && !isValidProvinceProduct) {
        if (formFields[smbPlatinumForm]
        ) {
          formFields[smbPlatinumForm].isRequired = false;
        }
        return true;
      }
      if (
        internetChoice &&
        (internetChoice.includes(productSelectionValues.officeInternetcopper) ||
          internetChoice.includes(productSelectionValues.telusOptikTV) ||
          internetChoice.includes(productSelectionValues.fibreInternet)) &&
        [productSelectionValues.uploadSpeedBeingSold].includes(fieldName) &&
        [productSelectionValues.customerProfileID].includes(fieldName) &&
        (!isEqual(isthisSpecialRetailer, no) ||
          !isEqual(isProtectingHighValueItems, no) ||
          !isEqual(isBuildingOverSize, no) ||
          !isEqual(moreThanEightCameras, no) ||
          !isEqual(camerasInstalledAtHeight, no))
      ) {
        return null;
      }

      if (fieldName === fieldTermBusinessTV
        && [valuePublicLegacy, valuePrivateLegacy].includes(getFieldValue(fieldTelusOptikTvProfileType, formFields))) {
        selectOptions = fields.options.filter(opt => {
          return ![_valueTerm36MonthBT].includes(opt.fields.value);
        });
      }
      if (internetChoice
        && internetChoice.includes(productSelectionValues.telusOptikTV)
        && [productSelectionValues.customerProfileID].includes(fieldName)
      ) {
        return null;
      }

      if (!getFieldValue(businessType, formFields)
        && fieldName === businessLegalName
        && formName === orderDetailsForm
      ) {
        return null;
      }
      if (internetChoice
        && !(
          internetChoice.includes(productSelectionValues.officeInternetcopper)
          || internetChoice.includes(productSelectionValues.fibreInternet)
        )
        && [productSelectionValues.uploadSpeedBeingSold].includes(fieldName)
      ) {
        return null;
      }
      if (
        internetChoice &&
        !internetChoice.includes(productSelectionValues.telusOptikTV) &&
        [productSelectionValues.customerProfileID].includes(fieldName)
      ) {
        return null;
      }
      if (fieldName === telusUpgrade || fieldName === existingConnection) {
        const productSelectionVal = getFieldValue(
          fieldProductSelection,
          formFields
        );
        if (
          productSelectionVal &&
          productSelectionVal.length > 1 &&
          productSelectionVal.includes(keySecureBusiness)
        ) {
          return null;
        }
      }
      if (
        (fieldName === productSelectionValues.existingConnection ||
          fieldName === existingInternetProvider ||
          fieldName === telusUpgrade ||
          fieldName === existingInternetProviderAlberta ||
          fieldName === privateWifi ||
          fieldName === uploadSpeed ||
          fieldName === existingProvider ||
          fieldName === uploadSpeedTrue ||
          fieldName === upgradeCaseNumber ||
          fieldName === uploadSpeedLogic ||
          fieldName === wifiPrivate ||
          fieldName === wifiSecurityErrorNote ||
          fieldName === telusCaseNumber ||
          fieldName === telusUploadSpeed) &&
        internetChoice &&
        (internetChoice.includes(productSelectionValues.officeInternetcopper) ||
          internetChoice.includes(productSelectionValues.fibreInternet))
      ) {
        return null;
      }
      if (
        isEligible &&
        getFieldValue(existingConnection, formFields) === existingNo &&
        getFieldValue(telusUpgrade, formFields) === telusNo
      ) {
        setIsEligible(!isEligible);
      }
      const selectedProvince = window.localStorage.getItem(storageItemProvince);
      if (
        isEligible &&
        !nonRoSProvinces.includes(selectedProvince) &&
        getFieldValue(existingConnection, formFields) === existingNo
      ) {
        setIsEligible(!isEligible);
      }

      if (
        isEligible &&
        getFieldValue(telusUpgrade, formFields) === telusNo &&
        getFieldValue(privateWifi, formFields) === no
      ) {
        setIsEligible(false);
      }

      if (isEligible && getFieldValue(wifiPrivate, formFields) === no) {
        setIsEligible(false);
      }
      if (
        isEligible &&
        getFieldValue(newAndAcquired.key, formFields) === newAndAcquired.yes
      ) {
        setIsEligible(!isEligible);
      }
      if (
        !isEligible &&
        getFieldValue(newAndAcquired.key, formFields) === newAndAcquired.no
      ) {
        setIsEligible(!isEligible);
      }
      if (
        formFields[productSelectionValues.existingConnection] &&
        !isEligible &&
        internetChoice &&
        internetChoice.includes(keySecureBusiness) &&
        (internetChoice.includes(productSelectionValues.officeInternetcopper) ||
          internetChoice.includes(productSelectionValues.fibreInternet))
      ) {
        setIsEligible(false);
        delete formFields[productSelectionValues.existingConnection];
      }
      if (
        isEligible &&
        getFieldValue(fieldProductHomeBasedBusiness, formFields) === yes &&
        getHBBQualificationAnswers(formFields).includes(no)
      ) {
        setIsEligible(!isEligible);
      }
      if (
        isEligible &&
        getFieldValue(fieldCustomerPrivateWifiConnection, formFields) === no
      ) {
        setIsEligible(!isEligible);
      }
      if (
        isEligible &&
        getFieldValue(fieldDoesTheCustomerHaveLteCoverage, formFields) === no
      ) {
        setIsEligible(!isEligible);
      }
      // Disable continue button if "Does the customer have a security system" question's option is selected as "yes"
      if (
        isEligible &&
        getFieldValue(fieldCustomerSecuritySystems, formFields) === yes
      ) {
        setIsEligible(!isEligible);
      }

      if (
        isEligible &&
        getFieldValue(fieldtelusOptikTvAccessibleToEmpAndStaff, formFields) ===
        no
      ) {
        setIsEligible(!isEligible);
      } else if (
        !isEligible &&
        getFieldValue(fieldtelusOptikTvAccessibleToEmpAndStaff, formFields) ===
        yes
      ) {
        setIsEligible(!isEligible);
      }

      if (
        (fieldName === productSelectionValues.existingConnection ||
          fieldName === existingInternetProvider ||
          fieldName === telusUpgrade ||
          fieldName === existingInternetProviderAlberta ||
          fieldName === privateWifi ||
          fieldName === uploadSpeed ||
          fieldName === existingProvider ||
          fieldName === uploadSpeedTrue ||
          fieldName === upgradeCaseNumber ||
          fieldName === uploadSpeedLogic ||
          fieldName === wifiPrivate ||
          fieldName === wifiSecurityErrorNote ||
          fieldName === telusCaseNumber ||
          fieldName === telusUploadSpeed) &&
        [
          isEqual(isthisSpecialRetailer, no) &&
          isEqual(isProtectingHighValueItems, no) &&
          isEqual(isBuildingOverSize, no) &&
          isEqual(moreThanEightCameras, no) &&
          isEqual(camerasInstalledAtHeight, no)
        ].some(el => !el)
      ) {
        return null;
      }

      if (
        [productSelectionValues.complexLeads].includes(fieldName) &&
        !isEqual(isthisSpecialRetailer, yes) &&
        !isEqual(isProtectingHighValueItems, yes) &&
        !isEqual(isBuildingOverSize, yes) &&
        !isEqual(moreThanEightCameras, yes) &&
        !isEqual(camerasInstalledAtHeight, yes)
      ) {
        return null;
      }

      if (
        !telusSecureBusinessSelection &&
        [
          fieldSigningAuthority,
          fieldEmergencyContactDetails,
          fieldAccountDetails
        ].includes(fieldName)
      )
        return null;
      if (fieldName === existingInternetProvider || fieldName === wifiError) {
        return null;
      }
      if (!is7XChannel(userChannelName) && fieldName === fieldLeadID) {
        return null;
      }
      if (
        orderData.productSelection &&
        !_.get(orderData, 'productSelection', []).includes(internetFibre) &&
        fieldName === fieldObdOrder
      ) {
        return null;
      }

      if (officePhoneExclusionChannels.includes(userChannelName)) {
        // Hide some fields for the selected channels
        if (fieldsToHideforNonOptikAndPhoneChannels.includes(fieldName)) {
          return null;
        }
        if (
          orderData.productSelection &&
          _.get(orderData, 'productSelection', []).includes('TELUS Business Wi-Fi') &&
          (fieldName === fieldPrefferedDateSecurityNote ||
            fieldName === fieldObdNoteOnCustomerInformation)
        ) {
          return null;
        }
      } else if (fieldsToShowforNonOptikAndPhoneChannels.includes(fieldName)) {
        // Show some fields ONLY for the selected channels
        return null;
      }

      if (
        formName === quoteToolForm &&
        fieldName === fieldTwBasicWifiApAmount &&
        initialPricingUpdate &&
        !orderData[fieldTwBasicWifiApAmount]
      ) {
        setInitialPricingUpdate(false);
        const basicWifiApValue =
          getFieldValue(fieldTwBasicWifiApAmount, formFields) || 1;
        const updatedMonthlyAmount =
          dueMonthly + _.get(fields, 'monthlyPayment', 0) * basicWifiApValue;
        const updatedNowAmount = (dueNow || 0) + _.get(fields, 'price', 0);
        setOrderData({
          ...orderData,
          dueNow: updatedNowAmount,
          dueMonthly: updatedMonthlyAmount
        });
        setDueMonthly(updatedMonthlyAmount);
        setDueNow(updatedNowAmount);
      }
      if (id === formFieldsGroup) {
        const groupIsVisible = fields.fields.find(item => {
          const { fields: itemFields } = item;

          if (!formFields[itemFields.name]) return null;
          const { value, isVisible } = formFields[itemFields.name];
          return (
            (value && isVisible) ||
            isRelatedFieldExisted(
              itemFields,
              formFields,
              orderData,
              isFormTouched
            )
          );
        });

        if (typeof groupIsVisible !== 'undefined') {
          result = (
            <GroupWrapper key={key}>
              {title && title !== reminder && <GroupTitle>{title}</GroupTitle>}
              {renderFormFields(fields.fields)}
            </GroupWrapper>
          );
        }
      } else if (id === formSection) {
        const { note } = fields;

        let renderNote = note && note.content && (
          <Note data={note} type="richText" />
        );

        if (fieldName === sectionTelusOptikTvInstallDetails) {
          let qualifiedSpeedValue = null;
          if (formFields && !isEditing) {
            qualifiedSpeedValue = getFieldValue(
              fieldQualifiedSpeed,
              formFields
            );
          } else if (orderData && orderData[fieldQualifiedSpeed]) {
            qualifiedSpeedValue = orderData[fieldQualifiedSpeed];
          }

          if (qualifiedSpeedValue && qualifiedSpeedValue === mbps15) {
            renderNote = <Note text={telusOptikCopperDisclaimerMessage} />;
          } else {
            renderNote = <Note text={telusOptikMustBeQualifiedMessage} />;
          }
        }
        if (fieldName !== 'salesRepInfo') {
          const { name } = role || {};
          result = sectionIsVisible(fieldName) && (
            <ExpandCollapse.Panel
              key={key}
              id={fieldName}
              header={
                formStepBackendKey === stepKeyMain && fieldName !== 'WLNPreQualification' && locale !== localeFrench
                  ? `${roleLabels[name]} ${title}`
                  : `${title}`
              }
            >
              <>
                {renderNote && renderNote}
                {renderFormFields(fields.formFields)}
              </>
            </ExpandCollapse.Panel>
          );
        }
      } else if (id === userDetailsKey) {
        result = (
          <UserDetailsForm
            key={key}
            data={fields}
            setFormFields={setFormFields}
            orderData={orderData}
            formErrors={formErrors}
            formFields={formFields}
            isEditing={isEditing}
            isFormTouched={isFormTouched}
            setIsFormTouched={setIsFormTouched}
            resetSelectedFields={resetSelectedFields}
          />
        );
      } else if (id === repeatedFormKey) {
        if (fields.key === keyTelusOptikTvAdditionalSetTopBoxes) {
          result = (
            <OptikRepeaterForm
              key={key}
              data={copiedFields}
              setFormFields={setFormFields}
              orderData={orderData}
              formErrors={formErrors}
              formFields={formFields}
              isEditing={isEditing}
              isFormTouched={isFormTouched}
              setIsFormTouched={setIsFormTouched}
              dueNow={dueNow}
              setDueNow={setDueNow}
              dueMonthly={dueMonthly}
              setDueMonthly={setDueMonthly}
            />
          );
        } else {
          result = (
            <RepeatedForm
              key={key}
              data={fields}
              setFormFields={setFormFields}
              orderData={orderData}
              formErrors={formErrors}
              formFields={formFields}
              isEditing={isEditing}
              isFormTouched={isFormTouched}
              setIsFormTouched={setIsFormTouched}
            />
          );
        }
      } else if (id === equipmentGroupSectionKey) {
        const tempError = formErrors[fields.name];
        result = (
          <>
            <EquipmentSectionForm
              key={key}
              data={fields}
              setFormFields={setFormFields}
              formErrors={formErrors}
              formFields={formFields}
              isEditing={isEditing}
              isFormTouched={isFormTouched}
              setIsFormTouched={setIsFormTouched}
              equipmentTotalPrice={equipmentTotalPrice}
              setEquipmentTotalPrice={setEquipmentTotalPrice}
              hardwareDiscountAmount={hardwareDiscountAmount}
              setHardwareDiscountAmount={setHardwareDiscountAmount}
              isHardwareDiscount={isHardwareDiscount}
              dueNow={dueNow}
              setDueNow={setDueNow}
              renderTempSensor={renderTempSensor}
              setRenderTempSensor={setRenderTempSensor}
            />
            {tempError && <Error text={tempError.text} />}
            <Modal
              heading="Alert"
              isOpen={isAlert}
              bodyText={bodyText}
              onClose={() => setIsAlertOpen(false)}
            />
          </>
        );
      } else {
        const fieldButtonProps = fields.type === 'Button' ? { modalForms } : {};
        let ref;
        let isDisabled;
        if (formFields[fieldName]) {
          ({ ref, isDisabled } = formFields[fieldName]);
        }
        const secureBusinessTermValue = getFieldValue(
          secureBusinessTerm,
          formFields
        );
        if (fieldName === fieldTelusSecureBusinessSecurityPackage) {
          if (!secureBusinessTermValue) {
            return null;
          }
        }
        if (fieldName === fieldSecureBusinessOffers) {
          const oldOptionsList = [...(selectOptions || fields.options)];
          selectOptions = getSecureBusinessOffersList(
            userChannelName,
            oldOptionsList,
            fieldValue,
            getFieldValue(
              fieldTelusSecureBusinessSecurityPackage,
              formFields
            )
          );
          // here we are handling the offers of secure business if you want to add or remove on slection of package
          // TSB TERMS & ADJUST OFFERS (SOF-2053)
          // Offers For 36 Month Term -> Monitor Selected
          if (
            selectOptions &&
            selectOptions.length > 0 &&
            secureBusinessTermValue === term36MonthValue &&
            fieldTelusSecureBusinessSecurityPackageValue === Monitor
          ) {
            selectOptions = selectOptions.filter(
              item =>
                ![
                  tsbSecurityOffersObject.sixMonthsFreeEn,
                  tsbSecurityOffersObject.zeroDollarOffEn,
                  tsbSecurityOffersObject.fiveDollarOffEn,
                  tsbSecurityOffersObject.fiveDollarOffFr
                ].includes(item.fields.value)
            );
          }
          // Offers For 60 Month Term -> Monitor Selected
          if (
            selectOptions &&
            selectOptions.length > 0 &&
            secureBusinessTermValue === _term60MonthValue &&
            fieldTelusSecureBusinessSecurityPackageValue === Monitor
          ) {
            selectOptions = selectOptions.filter(
              item =>
                ![
                  threeMonthFree,
                  tsbSecurityOffersObject.fiveDollarOffEn,
                  tsbSecurityOffersObject.fiveDollarOffFr,
                  tsbSecurityOffersObject.zeroDollarOffEn
                ].includes(item.fields.value)
            );
          }

          // Offers For 36 Month Term -> Protect & Control Selected
          if (
            selectOptions &&
            selectOptions.length > 0 &&
            secureBusinessTermValue === term36MonthValue &&
            (fieldTelusSecureBusinessSecurityPackageValue === fieldProtect ||
              fieldTelusSecureBusinessSecurityPackageValue === fieldControl)
          ) {
            selectOptions = selectOptions.filter(
              item =>
                ![
                  tsbSecurityOffersObject.sixMonthsFreeEn,
                  tsbSecurityOffersObject.zeroDollarOffEn,
                  tsbSecurityOffersObject.twentyDollarOffEn,
                  tsbSecurityOffersObject.twentyDollarOffFr,
                  tsbSecurityOffersObject.fiveDollarOffEn,
                  tsbSecurityOffersObject.fiveDollarOffFr
                ].includes(item.fields.value)
            );
          }
          // Offers For 60 Month Term -> Protect & Control Selected
          if (
            selectOptions &&
            selectOptions.length > 0 &&
            secureBusinessTermValue === _term60MonthValue &&
            (fieldTelusSecureBusinessSecurityPackageValue === fieldProtect ||
              fieldTelusSecureBusinessSecurityPackageValue === fieldControl)
          ) {
            selectOptions = selectOptions.filter(
              item =>
                ![
                  threeMonthFree,
                  tsbSecurityOffersObject.zeroDollarOffEn,
                  tsbSecurityOffersObject.twentyDollarOffEn,
                  tsbSecurityOffersObject.twentyDollarOffFr,
                  tsbSecurityOffersObject.fiveDollarOffEn,
                  tsbSecurityOffersObject.fiveDollarOffFr
                ].includes(item.fields.value)
            );
          }
          // end logic here

          // Offers and Installation Fee - Start
          if (formFields[fieldSecureBusinessOffers]) {
            // Disable offers
            setDisabledOptions(
              formFields[fieldSecureBusinessOffers].options,
              [twentyDollarMonthlyDiscount, waivedInstallationFee],
              true
            );
            // Set the value
            if (!formFields[fieldSecureBusinessOffers].value) {
              formFields[fieldSecureBusinessOffers].value = [twentyDollarMonthlyDiscount, waivedInstallationFee];
            }
          }
          // Offers and Installation Fee - End
        }

        if (fieldName === fieldSmartCameraOffers) {
          const oldOptionsList = [...(selectOptions || fields.options)];
          selectOptions = getSmartCameraOffersList(oldOptionsList, fieldValue);

          // to handle offers of smart camers add logic here
          // SOF-2150 hiding 10$ bundle discount from smart Camera
          // Offers For 36 Month Term -> Smart Camera
          if (
            selectOptions &&
            selectOptions.length > 0 &&
            secureBusinessTermValue === term36MonthValue &&
            fieldTelusSecureBusinessSecurityPackageValue === smartCameraKey
          ) {
            selectOptions = selectOptions.filter(
              item =>
                ![
                  tsbSecurityOffersObject.zeroDollarOffEn,
                  tsbSecurityOffersObject.tenBundleDiscountEn,
                  tsbSecurityOffersObject.tenBundleDiscountFr
                ].includes(item.fields.value)
            );
          }
          // Offers For 60 Month Term -> Smart Camera
          if (
            selectOptions &&
            selectOptions.length > 0 &&
            secureBusinessTermValue === _term60MonthValue &&
            fieldTelusSecureBusinessSecurityPackageValue === smartCameraKey
          ) {
            selectOptions = selectOptions.filter(
              item =>
                ![
                  tsbSecurityOffersObject.zeroDollarOffEn,
                  tsbSecurityOffersObject.tenBundleDiscountEn,
                  tsbSecurityOffersObject.tenBundleDiscountFr
                ].includes(item.fields.value)
            );
          }

          // Offers and Installation Fee - Start
          if (formFields[fieldSmartCameraOffers]) {
            // Disable offers
            setDisabledOptions(
              formFields[fieldSmartCameraOffers].options,
              [twentyDollarMonthlyDiscount, waivedInstallationFee],
              true
            );
            // Set the value
            if (!formFields[fieldSmartCameraOffers].value) {
              formFields[fieldSmartCameraOffers].value = [waivedInstallationFee];
            }
          }
          // Offers and Installation Fee - End
        }

        if ([
            wirelinePreferedInstallDate,
            tsbPreferedInstallDate
          ].includes(fieldName)
          && getFieldValue(wirelinePreferedInstallDate, formFields)
        ) {
          const installDate = moment(getFieldValue(wirelinePreferedInstallDate, formFields)).toDate();
          formFields.tsbPreferedInstallDate.minDate = addDays(installDate, 7);
        }
        if ([
            wirelineSecondaryInstallDate,
            tsbSecondaryPreferredInstallDate
          ].includes(fieldName)
          && getFieldValue(wirelineSecondaryInstallDate, formFields)
        ) {
          const installDate = moment(getFieldValue(wirelineSecondaryInstallDate, formFields)).toDate();
          formFields.tsbSecondaryPreferredInstallDate.minDate = addDays(installDate, 8);
        }
        const productSelectionValueFromFormFields = getFieldValue(
          fieldProductSelection,
          formFields
        );
        const selectProvince = window.localStorage.getItem(storageItemProvince);
        if (
          productSelectionValueFromFormFields &&
          productSelectionValueFromFormFields.includes(keySecureBusiness) &&
          !nonRoSProvinces.includes(selectProvince)
        ) {
          if (fieldName === telusUpgrade) {
            return null;
          }
        } else if (
          fieldName === fieldExistingInternetProviderRoC ||
          fieldName === fieldExistingInternetProviderErrorNote
        ) {
          return null;
        }

        if (fieldName === fieldRegularMonthlyOffersFibre) {
          const valueFibreSpeed = getFieldValue(
            fieldQualifiedSpeedFibre,
            formFields
          );
          if (['3G/3000 mbps', mbps3g, _valueFiveGSpeed].includes(valueFibreSpeed)) {
            selectOptions = _.get(fields, 'options', []).filter(
              option => _.get(option, 'fields.value', '') !== monthPromo
            );
          }
        }

        /**
         * FOR COPPER INTERNET
         * Disable TELUS Business Wifi if
         * Regular Offer = Bunduled AND
         * Product(s) being added with Internet includes Business Wifi
         */
        if (fieldName === fieldTelusBusinessWifi) {
          const valueRegularOffers36MonthTerm = getFieldValue(
            'regularOffers36MonthTerm',
            formFields
          );
          const valueProductThatIsAdded = getFieldValue(
            'productThatIsAdded',
            formFields
          );
          if (
            valueRegularOffers36MonthTerm === 'bundled' &&
            valueProductThatIsAdded.includes('Telus Business Wi-Fi')
          )
            isDisabled = true;
        }

        /**
         * FOR FIBRE INTERNET:
         * Disable TELUS Business Wifi if
         * Regular Offer = Bunduled AND
         * Product(s) being added with Internet includes Business Wifi
         */
        if (fieldName === fieldTelusBusinessWifi) {
          const valueFibreSpeed = getFieldValue(
            fieldQualifiedSpeedFibre,
            formFields
          );
          const valueRegularYearlyOfferFibreBundled = getFieldValue(
            'regularYearlyOfferFibreBundled',
            formFields
          );
          if (
            valueFibreSpeed !== '15/1 mbps' &&
            valueRegularYearlyOfferFibreBundled === 'bundled' &&
            valueProductSelectionFibre &&
            valueProductSelectionFibre.includes('Telus Business Wi-Fi')
          )
            isDisabled = true;
        }

        if (orderData) {
          const isOptikTVIncluded =
            Array.isArray(orderData.productSelection) &&
            _.get(orderData, 'productSelection', []).includes(nameTelusTVForBusiness);
          if (isOptikTVIncluded && fieldName === 'tradeNameOrName') {
            // Set isRequired to true
            formFields[tradeNameOrName].isRequired = true;
            fields.required = true;
          }
          if (!isOptikTVIncluded && fieldName === 'customerProfileID') {
            // Set isRequired to false
            formFields[customerProfileID].isRequired = false;
            return null;
          }
        }

        if (orderData) {
          const isOptikTVIncluded =
            Array.isArray(orderData.productSelection) &&
            _.get(orderData, 'productSelection', []).includes(nameTelusTVForBusiness);
          if (
            !isOptikTVIncluded &&
            fieldsToShowforOptikTV.includes(fieldName)
          ) {
            return null;
          }
          if (
            isOptikTVIncluded &&
            optikTvIncludedChannels.includes(userChannelName) &&
            fieldsToShowforNonOptikAndPhoneChannels.includes(fieldName)
          ) {
            return null;
          }
        }

        const validProvincesForAB = [britishColumbia, alberta, ab, bc];

        if (fieldName === fiveYearlyFibrePromos && validProvincesForAB.includes(orderData.parsedProvince)) {
          fields.options = fields.options.filter(
            promoOptions =>
              !['6 months free', '6 mois à 0 $'].includes(
                promoOptions.fields.value
              )
          );
        }

        const fieldData = {
          ...fields,
          options: selectOptions || fields.options,
          ...fieldButtonProps,
          ref,
          formFields,
          name: fieldName,
          value: fieldValue,
          disabled: isDisabled,
          sysId,
          minDate: formFields[fieldName] && formFields[fieldName].minDate,
          onChange: (e, refV) => handleFormField(e.target, refV, true),
          onBlur: (e, refV) => handleBlurField(e.target, refV, true),
          resetSelectedFields
        };
        const valueInstallation = getFieldValue(
          fieldInstallation,
          formFields
        );

        // All Logics related to Installation field for Telus Tv
        if (fieldName === fieldInstallation) {
          let updatedOptions = fieldData.options;
          const getUpdatedOptions = (options, valuesToFilter) => {
            return options.filter(
              option => !valuesToFilter.includes(option.fields.value)
            );
          };
          if (!([selfInstall].includes(valueInstallation))) {
            fieldData.note = undefined;
          }
          if ([valuePublicLegacy, valuePrivateLegacy].includes(TelusOptikTvProfileType)) {
            updatedOptions = getUpdatedOptions(fieldData.options,[selfInstall,waivedMultiProductOrder]);
            fieldData.options = [...updatedOptions];
          } else {
            // If profile type is not public, remove waivedMovingFromCompetitor
            updatedOptions = getUpdatedOptions(fieldData.options,[waivedMovingFromCompetitor]);
            fieldData.options = [...updatedOptions];
          }
        }
        if (userChannelName && selectedChannel.includes(userChannelName)) {
          if (!valueVulcanOrder) {
            if (fieldName === 'serviceAddress') {
              fieldData.note = undefined;
            }
          }
          if (valueVulcanOrder === _yes) {
            if (fieldName === 'serviceAddressNote') {
              return null;
            }
          }
          if (valueVulcanOrder === _no) {
            if (fieldName === 'serviceAddress') {
              fieldData.note = undefined;
            }
          }
        } else if (fieldName === 'serviceAddress') {
          fieldData.note = undefined;
        }

        if (
          fieldName === fieldIsThePurposeToProtectHBB ||
          fieldName === fieldDoesCustomerAgreeToAltercations ||
          fieldName === fieldIsThisHBBRegisteredBusiness ||
          fieldName === fieldProductHomeBasedBusiness
        ) {
          fieldData.note = undefined;
        }
        const isLimitedOfferCopperSelected =
          (formFields[fieldLimitedTimeOffer] &&
            formFields[fieldLimitedTimeOffer].value &&
            formFields[fieldLimitedTimeOffer].value.length) ||
          (formFields[fieldLimitedTimeBasicOffer] &&
            formFields[fieldLimitedTimeBasicOffer].value &&
            formFields[fieldLimitedTimeBasicOffer].value.length);

        const isLimitedOfferFibreSelected = !!(
          getFieldValue(fieldLimitedYearlyOffersFibre, formFields) ||
          getFieldValue(fieldLimitedMonthlyOfferFibre75, formFields) ||
          getFieldValue(fieldLimitedMonthlyOfferFibre, formFields)
        );

        const isStandardRegularOfferFibre =
          getFieldValue(fieldRegularMonthlyOffersFibre, formFields) ===
          standardPricing;

        const valueRegularMonthlyPromoFibre = getFieldValue(
          fieldRegularMonthlyOffersFibre,
          formFields
        );
        const valueRegularMonthlyPromoCopper = getFieldValue(
          fieldRegularMonthlyOffers,
          formFields
        );
        const valueWinbackCopper = getFieldValue(fieldWinback, formFields);
        const valueWinbackFibre = getFieldValue(fieldWinbackFibre, formFields);
        const valueTwoMonthsfree = getFieldValue(
          fieldTwoMonthsDuration,
          formFields
        );
        const valueTwoMonthsfreeFibre = getFieldValue(
          fieldTwoMonthsDurationFibre,
          formFields
        );

        if (!isFormTouched && fields.type === 'Checkbox') {
          fieldData.checked = fieldValue;
        }

        if (
          (valueRegularMonthlyPromoCopper === monthPromo &&
            [fieldLimitedTimeOffer, fieldLimitedTimeBasicOffer].includes(
              fieldName
            )) ||
          (valueRegularMonthlyPromoFibre === monthPromo &&
            valueWinbackFibre === yes &&
            [
              fieldLimitedMonthlyOfferFibre,
              fieldLimitedMonthlyOfferFibre75
            ].includes(fieldName))
        ) {
          if (
            (fieldData &&
              fieldData.options &&
              formStepName === internetCopper &&
              valueTwoMonthsfree === yes) ||
            ((formStepName === internetFibre ||
                formStepName === orderFibreInternet) &&
              valueTwoMonthsfreeFibre === yes)
          ) {
            const updatedOptions = fieldData.options.map(option => {
              option.fields.disabledOption = option.fields.value === threeMonthsFree;
              return option;
            });
            fieldData.options = [...updatedOptions];
          } else {
            const updatedOptions = fieldData.options.map(option => {
              const op = option;
              const {
                fields: { value }
              } = option;
              if (!formStepName === internetCopper)
                op.fields.disabledOption = value !== threeMonthsFree;
              if (formStepName === internetCopper && valueTwoMonthsfree === no)
                op.fields.disabledOption = false;
              return option;
            });
            fieldData.options = [...updatedOptions];
          }
        } else if (
          fieldData &&
          fieldData.options &&
          (valueWinbackCopper || valueTermFibre)
        ) {
          const updatedOptions = fieldData.options.map(option => {
            if (!formStepName === internetCopper) {
              option.fields.disabledOption = option.fields.value === threeMonthsFree;
            }
            return option;
          });
          fieldData.options = [...updatedOptions];
        }
        if (orderData) {
          if (
            !(
              Array.isArray(orderData.productSelection) &&
              _.get(orderData, 'productSelection', []).includes(nameTelusTVForBusiness)
            ) &&
            fieldName === 'telusOptictvTimeZone'
          ) {
            // Set isRequired to true
            formFields[telusOptictvTimeZone].isRequired = false;
            return null;
          }
        }

        const getUpdatedOptions = (options, valuesToFilter) => {
          return options.filter(
            option => !valuesToFilter.includes(option.fields.value)
          );
        };
        const checkValue = (fieldDetails, valueToCheck) => {
          return (
            fieldDetails.value &&
            fieldDetails.value.length &&
            fieldDetails.value.includes(valueToCheck)
          );
        };
        if (
          fieldData &&
          fieldData.options &&
          formStepName === productInformation &&
          fieldData.name === fieldProductSelection
        ) {
          // check to filter product information selection upon yes or no of question
          // Is the customer requesting Fibre 2.5G = yes then show only Fiber Internet option
          // else show rest of the options
          if (getFieldValue(fieldCustomerRequestFibre3G, formFields)) {
            const value = getFieldValue(
              fieldCustomerRequestFibre3G,
              formFields
            );
            fieldData.options = formFields[
              fieldProductSelection
              ].options.filter(option =>
              value === yes
                ? option.fields.value === internetFibre ||
                option.fields.value === telusSecureBusiness
                : option.fields.value
            );
          }
          let updatedOptions = fieldData.options;
          if (checkValue(fieldData, officeInternetCopper)) {
              updatedOptions = getUpdatedOptions(fieldData.options, [
                officeInternetFiber
              ]);
          }
          if (checkValue(fieldData, officeInternetFiber)) {
              updatedOptions = getUpdatedOptions(fieldData.options, [
                officeInternetCopper
              ]);
          }
          // if (
          //   checkValue(fieldData, telusBusinessWifi) && !isChannelSMBDigitalFr(userChannelName)) {
          //   updatedOptions = getUpdatedOptions(fieldData.options, [
          //     officeInternetCopper,
          //     officeInternetFiber
          //   ]);
          // }
          // SOF-3111 If the order is from BC / AB, show optik tv else hide it
          const allowedOptikTvProvinces = [alberta, britishColumbia, ab, bc];
          if (!allowedOptikTvProvinces.includes(orderData.parsedProvince)) {
            updatedOptions = getUpdatedOptions(fieldData.options, [
              telusOptikTv
            ]);
          }

          if (userChannelName === 'CORP_STORE') {
            updatedOptions = getUpdatedOptions(fieldData.options, [
              officePhone,
              telusOptikTv
            ]);
          }

          if (officePhoneExclusionChannels.includes(userChannelName)) {
            updatedOptions = getUpdatedOptions(updatedOptions, [officePhone]);
          }
          if (isChannelSMBDigitalFr(userChannelName)) {
            updatedOptions = getUpdatedOptions(updatedOptions, [officePhone]);
            if (checkValue(fieldData, telusBusinessWifi)) {
              updatedOptions = getUpdatedOptions(updatedOptions, [
                telusSecureBusiness
              ]);
            }
            if (checkValue(fieldData, telusSecureBusiness)) {
              updatedOptions = getUpdatedOptions(updatedOptions, [
                telusBusinessWifi
              ]);
            }
          }

          fieldData.options = [...updatedOptions];
        }

        if (fieldName === fieldStaticIpPromotion || fieldName === fieldStaticIPRequiredFibre) {
          const valueStaticIPRequired = getFieldValue(fieldStaticIPRequiredFibre, formFields);
          // If static IP is not selected or the required static IP is not 'staticIpLabel5'
          if (formFields && formFields[fieldStaticIpPromotion]) {
            if (valueStaticIPRequired !== fieldStaticIpSubnet5) {
              formFields[fieldStaticIpPromotion].monthlyPayment = 0;  // Set payment to 0
            }
          }
        }

        if (
          fieldName === fieldStaticIpPromotion &&
          ['QC'].includes(request.getProvince()) &&
          [
            valueQualifiedSpeed940mbps,
            valueQualifiedSpeed150mbps,
            valueQualifiedSpeed300mbps
          ].includes(qualifiedSpeedFibreValue)
        ) {
          formFields[fieldStaticIpPromotion].isRequired = false;
          return null;
        }

        if (fieldName === fieldStaticIpPromotion) {
          const province = orderData.parsedProvince;
          if (province === alberta || province === britishColumbia || province === ab || province === bc) {
            if(![
                valueQualifiedSpeed15gFibre,
                'Fibre Internet 3G: 3G/3GMbps',
                '3G/3000 mbps'
              ].includes(getFieldValue(fieldQualifiedSpeedFibre, formFields)) ||
              getFieldValue(fieldStaticIPRequiredFibre, formFields) !== fieldStaticIpSubnet1
            ) {
              return null;
            };
            // Filter out the 5 IP for $0 promo for AB/BC
            if (fields.options) {
              formFields[fieldName].options = fields.options.filter(
                opt => opt.fields.label !== staticIp5LabelPromotion
              );
            }
          } else {
            if(
              getFieldValue(fieldStaticIPRequiredFibre, formFields) !== fieldStaticIpSubnet5
            ) {
              return null;
            };
            // For other provinces, filter out other options as needed
            // Example: keep only the 5 IP for $0 promo
            if (fields.options) {
              formFields[fieldName].options = fields.options.filter(
                opt => opt.fields.label !== staticIp1LabelPromotion
              );
            }
          }
        }

        if (fieldName === warningNoteSmbTiDigitalFr) {
          const valueProductSelection = getFieldValue(
            fieldProductSelection,
            formFields
          );
          const shouldShowWarningNoteSmbTiDigitalFr =
            isChannelSMBDigitalFr(userChannelName) &&
            valueProductSelection &&
            (valueProductSelection.includes(telusBusinessWifi) ||
              valueProductSelection.includes(telusSecureBusiness)) &&
            !valueProductSelection.includes(officeInternetCopper) &&
            !valueProductSelection.includes(officeInternetFiber) &&
            parseProvince(orderData.serviceAddress) !== provinceAlias.Quebec;

          if (!shouldShowWarningNoteSmbTiDigitalFr) {
            return null;
          }
        }

        const valueRegularYearlyOfferFibreBundled = getFieldValue(
          'regularYearlyOfferFibreBundled',
          formFields
        );
        const telusSecureBusinessSecurityPackageValue = getFieldValue(
          fieldTelusSecureBusinessSecurityPackage,
          formFields
        );
        if (!listChannelForTSB.includes(userChannelName)) {

          if([Monitor, Protect, Control].includes(telusSecureBusinessSecurityPackageValue) &&
            [term36MonthValue, _term60MonthValue].includes(secureBusinessTermValue) &&
            fieldName === fieldSecureBusinessOffers
          ){
            selectOptions = formFields[fieldName].options.filter(opt => {
              return [$199offInstallation].includes(opt.fields.value);
            });
          }

          if(formFields && telusSecureBusinessSecurityPackageValue === Monitor && fieldName === fieldSecureBusinessOffers)
          {
            fieldData.options = getUpdatedOptions(fieldData.options, $199offInstallation);
          }

          if (fieldName === 'TelusMobility') {
            if (formFields.TelusMobility) {
              formFields.TelusMobility.isRequired = false;
            }
            return null;
          }
        }

        if (listChannelForTSB.includes(userChannelName)) {
          if (fieldName === fieldSecureBusinessOffers) {
            if (formFields.TelusMobility && formFields.TelusMobility.value === 'Yes') {
              selectOptions = formFields[fieldName].options.filter(opt => {
                return [$199offInstallation].includes(opt.fields.value);
              });
            } else {
              fieldData.options = getUpdatedOptions(
                fieldData.options,
                $199offInstallation
              );
            }
          }
        }
        // Remove 3 months free when term is 5 years (60 months)
        const fibreThreeMonthsFreeLtoSpeeds = [
          fieldLimitedYearlyOffersFibre300,
          fieldLimitedYearlyOffersFibre,
          fieldLimitedTimeOfferYearly15g,
          fieldLimitedTimeOfferYearly3g3000
        ];
        if (
          formFields[fieldName] &&
          fibreThreeMonthsFreeLtoSpeeds.includes(fieldName) &&
          (valueTermFibre !== _valueTerm36Month ||
            valueRegularYearlyOfferFibreBundled !== bundled)
        ) {
          fieldData.options = getUpdatedOptions(
            fieldData.options,
            threeMonthFree
          );
        }

        if (
          valueTermFibre === _valueTerm36Month &&
          valueRegularYearlyOfferFibreBundled === bundled &&
          valueProductSelectionFibre &&
          valueProductSelectionFibre.includes('Telus Business Wi-Fi') &&
          fibreThreeMonthsFreeLtoSpeeds.includes(fieldName)
        ) {
          fieldData.options = getUpdatedOptions(
            fieldData.options,
            threeMonthFree
          );
        }

        const valueRegularOffers36MonthTerm = getFieldValue(
          'regularYearlyOfferFibreBundled',
          formFields
        );

        if(!validProvincesForAB.includes(orderData.parsedProvince) && fieldName === 'fiberManagerSpecialAB'){
          return null;
        }

        if (
          fieldName === 'fiberManagerSpecialAB' &&
          ((![
                valueQualifiedSpeed940mbps,
                valueQualifiedSpeed15gFibre,
                'Fibre Internet 3G: 3G/3GMbps',
                '3G/3000 mbps'
              ].includes(getFieldValue(fieldQualifiedSpeedFibre, formFields)) &&
              valueRegularYearlyOfferFibreBundled === 'Bundled') ||
            valueRegularYearlyOfferFibreBundled === standaloneOffer ||
            (formFields[promosForAB[getFieldValue(fieldQualifiedSpeedFibre, formFields)]] && formFields[promosForAB[getFieldValue(fieldQualifiedSpeedFibre, formFields)]].value) ||
            (!valueProductSelectionFibre.includes('Mobility') && valueTermFibre === _valueTerm60Month))
        ) {
          formFields.fiberManagerSpecialAB.value = undefined;
          return null;
        }

        if (
          fieldName === 'fiberManagerSpecial' &&
          ((!valueProductSelectionFibre.includes('Mobility') && valueTermFibre === _valueTerm60Month && (getFieldValue(fieldQualifiedSpeedFibre, formFields) === mbps300)))
        ) {
          formFields.fiberManagerSpecial.value = undefined;
          return null;
        }

        if (validProvincesForAB.includes(orderData.parsedProvince) && fieldName === fieldManagerSpecialDiscount) {
          if (
            [
              valueQualifiedSpeed940mbps,
              valueQualifiedSpeed15gFibre,
              'Fibre Internet 3G: 3G/3GMbps',
              '3G/3000 mbps'
            ].includes(getFieldValue(fieldQualifiedSpeedFibre, formFields)) &&
            valueRegularYearlyOfferFibreBundled === 'Bundled' &&
            (!valueProductSelectionFibre.includes('Mobility') ||
              !formFields[promosForAB[getFieldValue(fieldQualifiedSpeedFibre, formFields)]].value)
          ) {
            formFields[fieldManagerSpecialDiscount].value = undefined;
            return null;
          }

          if(valueForTermFibre === _valueTerm36Month &&
            qualifiedSpeedForFibreValue === _valueFiveGSpeed &&
            (
              [standaloneOffer, _bundled].includes(valueRegularOffers36MonthTerm)
            )){
            if (
              !(valueForTermFibre === _valueTerm36Month &&
                qualifiedSpeedForFibreValue === _valueFiveGSpeed &&
                (
                  [standaloneOffer].includes(valueRegularOffers36MonthTerm) ||
                  (valueProductSelectionFibre.includes(mobility) && [_bundled].includes(valueRegularOffers36MonthTerm))
                ))
            ) {
              formFields[fieldManagerSpecialDiscount].value = undefined;
              return null;
            }}
        }

        // Hiding Manager's special Discount on some selections
        if(!( valueForTermFibre === _valueTerm36Month &&
          qualifiedSpeedForFibreValue === _valueFiveGSpeed &&
          (
            [standaloneOffer].includes(valueRegularOffers36MonthTerm) ||
            (valueProductSelectionFibre.includes(mobility) && [_bundled].includes(valueRegularOffers36MonthTerm))
          ))){
          if (
            formFields &&
            formFields[fieldManagerSpecialDiscount] &&
            !(
              (valueTermFibre === yearsTerm ||
                valueTermFibre === _valueTerm36Month ||
                valueTermFibre === _valueTerm60Month) &&
              [
                valueQualifiedSpeed940mbps,
                valueQualifiedSpeed15gFibre,
                'Fibre Internet 3G: 3G/3GMbps',
                '3G/3000 mbps',
                mbps300
              ].includes(getFieldValue(fieldQualifiedSpeedFibre, formFields)) &&
              valueRegularYearlyOfferFibreBundled
            )
          ) {
            if (
              !(
                valueRegularYearlyOfferFibreBundled === bundled &&
                valueProductSelectionFibre.includes('Telus Business Wi-Fi') &&
                !valueProductSelectionFibre.includes('Secure Business') &&
                !valueProductSelectionFibre.includes('Business Connect')
              )
            ) {
              if (fieldName === fieldManagerSpecialDiscount) {
                fieldData.options = getUpdatedOptions(
                  fieldData.options,
                  'managerspecial$5'
                );
              }
            } else if (
              !(valueRegularYearlyOfferFibreBundled === standaloneOffer)
            ) {
              if (fieldName === fieldManagerSpecialDiscount) {
                fieldData.options = getUpdatedOptions(
                  fieldData.options,
                  'managerspecial$5'
                );
              }
            }
          }
        }

        const isPromotionIncluded = (limitedOffer, promotion) => {
          return (
            limitedOffer &&
            limitedOffer.length &&
            limitedOffer.includes(promotion)
          );
        };

        const valueLimitedOffer = getFieldValue(
          fieldLimitedTimeOffer,
          formFields
        );
        const valueLimitedBasicOffer = getFieldValue(
          fieldLimitedTimeBasicOffer,
          formFields
        );
        const valueLimitedMonthlyOffer = getFieldValue(
          fieldLimitedMonthlyOfferFibre,
          formFields
        );
        const valueLimitedMonthlyOffer75 = getFieldValue(
          fieldLimitedMonthlyOfferFibre75,
          formFields
        );
        const valueLimitedYearlyOffer = getFieldValue(
          fieldLimitedYearlyOffersFibre,
          formFields
        );
        const valueProductSelection = getFieldValue(
          fieldProductSelection,
          formFields
        );
        const valueProductType = getFieldValue(fieldProductType, formFields);
        const isAnyFreePromoSelected =
          isPromotionIncluded(valueLimitedOffer, threeMonthsFree) ||
          isPromotionIncluded(valueLimitedBasicOffer, threeMonthsFree) ||
          isPromotionIncluded(valueLimitedMonthlyOffer, threeMonthsFree) ||
          isPromotionIncluded(valueLimitedMonthlyOffer75, threeMonthsFree) ||
          isPromotionIncluded(valueLimitedYearlyOffer, threeMonthsFree);
        if (
          [
            fieldRegularMonthlyOffers,
            fieldRegularYearlyOffers,
            fieldRegularMonthlyOffersFibre,
            fieldRegularYearlyOffersFibreBundled
          ].includes(fieldName)
        ) {
          if (
            (isLimitedOfferCopperSelected && formStepName === internetCopper) ||
            (isLimitedOfferFibreSelected && valueTermFibre !== yearsTerm)
          ) {
            if (!isAnyFreePromoSelected) {
              // removed for fixing sof-827
              // fieldData.disabled = true;
            }
          } else {
            // fieldData.disabled = false;
          }
        }

        if (
          [fieldLimitedMonthlyOfferFibre].includes(fieldName) &&
          isStandardRegularOfferFibre
        ) {
          fieldData.disabled = isStandardRegularOfferFibre;
        }

        if (
          [
            complexNote,
            channelComplexNote,
            warningNote,
            fieldHBBQualificationErrorNote
          ].includes(fieldName)
        ) {
          if (valueProductSelection && valueProductSelection.length) {
            fieldData.note = checkNoteVisibility(
              formFields,
              fieldData,
              valueProductSelection,
              fieldSpecialRetailer,
              fieldHighValueItems,
              fieldBuildingSize,
              fieldEightCameras,
              fieldCamerasInstalled
            );
          } else {
            fieldData.note = '';
          }
        }

        let selectedPackage = getFieldValue(
          fieldTelusSecureBusinessSecurityPackage,
          formFields
        );
        const isSmokeDetectorAdded = products => {
          let isAdded = false;

          products.forEach(product => {
            if (
              formFields[`${selectedPackage}${keyAdditionalEquipment}`] &&
              formFields[`${selectedPackage}${keyAdditionalEquipment}`][
                product
                ] &&
              formFields[`${selectedPackage}${keyAdditionalEquipment}`][product]
                .value > 0
            ) {
              isAdded = true;
            }
          });
          return isAdded;
        };

        if (typeof selectedPackage === 'string') {
          selectedPackage = selectedPackage.toLowerCase();
        } else if (fieldName === smokeDetectorWarningNote) {
          return null;
        } else if (fieldName === temperatureSensorFeeNote1) {
          return null;
        } else if (fieldName === temperatureSensorFeeNote2) {
          return null;
        }
        if (
          selectedPackage &&
          formFields[`${selectedPackage}${keyAdditionalEquipment}`] &&
          fieldName === smokeDetectorWarningNote
        ) {
          if (
            isSmokeDetectorAdded([
              smokeDetector,
              easySmokeFireDetector,
              easySmokeFireDetectorProtector,easyFiveYearSmokeFireDetector
            ]) === false
          ) {
            fieldData.note = '';
          }
        }
        // SOF-1773
        const isTemperatureSensorAdded1 = products => {
          let isAdded = false;
          products.forEach(product => {
            if (
              formFields[`${selectedPackage}${keyAdditionalEquipment}`] &&
              formFields[`${selectedPackage}${keyAdditionalEquipment}`][
                product
                ] &&
              (formFields[`${selectedPackage}${keyAdditionalEquipment}`][
                temperatureSensor
                ].value || 0) +
              (formFields[`${selectedPackage}${keyAdditionalEquipment}`][
                easyTemperatureSensor
                ].value || 0) >
              0 &&
              (formFields[`${selectedPackage}${keyAdditionalEquipment}`][
                temperatureSensor
                ].value || 0) +
              (formFields[`${selectedPackage}${keyAdditionalEquipment}`][
                easyTemperatureSensor
                ].value || 0) <=
              5
            ) {
              isAdded = true;
            }
          });
          return isAdded;
        };

        if (
          selectedPackage &&
          formFields[`${selectedPackage}${keyAdditionalEquipment}`] &&
          fieldName === temperatureSensorFeeNote1
        ) {
          if (
            isTemperatureSensorAdded1([
              temperatureSensor,
              easyTemperatureSensor
            ]) === false
          ) {
            fieldData.note = '';
          }
        }

        const isTemperatureSensorAdded2 = products => {
          let isAdded = false;
          products.forEach(product => {
            if (
              formFields[`${selectedPackage}${keyAdditionalEquipment}`] &&
              formFields[`${selectedPackage}${keyAdditionalEquipment}`][
                product
                ] &&
              (formFields[`${selectedPackage}${keyAdditionalEquipment}`][
                temperatureSensor
                ].value || 0) +
              (formFields[`${selectedPackage}${keyAdditionalEquipment}`][
                easyTemperatureSensor
                ].value || 0) >
              5 &&
              (formFields[`${selectedPackage}${keyAdditionalEquipment}`][
                temperatureSensor
                ].value || 0) +
              (formFields[`${selectedPackage}${keyAdditionalEquipment}`][
                easyTemperatureSensor
                ].value || 0) <=
              10
            ) {
              isAdded = true;
            }
          });
          return isAdded;
        };

        if (
          selectedPackage &&
          formFields[`${selectedPackage}${keyAdditionalEquipment}`] &&
          fieldName === temperatureSensorFeeNote2
        ) {
          if (
            isTemperatureSensorAdded2([
              temperatureSensor,
              easyTemperatureSensor
            ]) === false
          ) {
            fieldData.note = '';
          }
        }

        const isThermostateAdded = () => {
          let isAdded = false;
          if (
            formFields[`${selectedPackage}${keyAdditionalEquipment}`] &&
            formFields[`${selectedPackage}${keyAdditionalEquipment}`][
              smartThermostat
              ] &&
            formFields[`${selectedPackage}${keyAdditionalEquipment}`][
              smartThermostat
              ].value > 0
          ) {
            isAdded = true;
          }
          if (
            formFields[`${selectedPackage}${includedEquipmentSelection}`] &&
            formFields[`${selectedPackage}${includedEquipmentSelection}`][
              smartThermostatFree
              ] &&
            formFields[`${selectedPackage}${includedEquipmentSelection}`][
              smartThermostatFree
              ].value > 0
          ) {
            isAdded = true;
          }
          return isAdded;
        };

        if (selectProvince === 'QC' && fieldName === thermostatWarningNote) {
          if (isThermostateAdded() === false) {
            return null;
          }
        } else if (
          selectProvince !== 'QC' &&
          fieldName === thermostatWarningNote
        ) {
          return null;
        }

        if (
          (!selectedPackage || selectedPackage === packageMonitor) &&
          fieldName === thermostatWarningNote
        ) {
          return null;
        }

        if (!nonRoSProvinces.includes(selectProvince)) {
          if (fieldName === fieldProductHomeBasedBusiness) {
            if (
              getFieldValue(existingConnection, formFields) === existingNo ||
              getFieldValue(fieldCustomerPrivateWifiConnection, formFields) ===
              no ||
              getFieldValue(fieldDoesTheCustomerHaveLteCoverage, formFields) ===
              no
            ) {
              return null;
            }
          }
        }

        if (
          fieldName === fieldLTESpeedErrorNote &&
          getFieldValue(fieldWhatIsUploadSpeed, formFields) > 2
        ) {
          fieldData.note = '';
        }

        if (fieldName === fieldKeyAddress) {
          fieldData.removeLocalStorageOnChange = true;
        }

        // const { provinceValue } = getAddressParts(orderData.serviceAddress);
        if (wireLineDateFields.includes(fieldName)) {
          fieldData.disableHolidays = true;
        }

        const getOffDaysCounter = (initialDate, interval) => {
          let count = 0;
          for (let i = 1; i <= interval; i += 1) {
            const currentDate = moment(
              moment(initialDate) + i * 24 * 3600 * 1000
            ).format(installationCalendarDateFormat);
            if (!getDisabledDates(moment(currentDate).toDate())) {
              count += 1;
            }
          }
          return count;
        };

        const setFutureProperDate = (interval, date = undefined) => {
          return moment(moment(date) + interval * 24 * 3600 * 1000).format(
            installationCalendarDateFormat
          );
        };

        const getFutureDate = (interval, date = undefined) => {
          let holidays = getOffDaysCounter(setFutureProperDate(0), interval);
          while (holidays > 0) {
            const temp = holidays;
            holidays = getOffDaysCounter(
              setFutureProperDate(interval),
              holidays
            );
            interval += temp;
          }
          return setFutureProperDate(interval, date);
        };

        if (fieldName === fieldWirelinePreferedInstallDate) {
          if (
            orderData.productSelection.length > 1 &&
            _.get(orderData, 'productSelection', []).includes(internetFibre)
          ) {
            // TODO ==> winbackInstallationOrderStep -> 9 days out
            fieldData.minDate = getFutureDate(9);
          } else {
            // TODO ==> winbackInstallationOrderStep -> 7 days out
            fieldData.minDate = getFutureDate(7);
          }
        }

        if (fieldName === wirelineSecondaryInstallDate) {
          if (
            orderData.productSelection.length > 1 &&
            _.get(orderData, 'productSelection', []).includes(internetFibre)
          ) {
            // TODO ==> wirelineSecondaryInstallDate -> 10 days out
            fieldData.minDate = getFutureDate(10);
          } else {
            // TODO ==> wirelineSecondaryInstallDate -> 8 days out
            fieldData.minDate = getFutureDate(8);
          }
        }

        // 603
        if (
          fieldName === fieldTsbPreferedInstallDate &&
          formFields.wirelinePreferedInstallDate
        ) {
          const {
            wirelinePreferedInstallDate: { value }
          } = formFields || {};
          if (
            getFieldValue(
              fieldTelusSecureBusinessSecurityPackage,
              formFields
            ) === valueProtect ||
            getFieldValue(
              fieldTelusSecureBusinessSecurityPackage,
              formFields
            ) === valueControl
          ) {
            fieldData.minDate = getFutureDate(9);
          } else if (value) {
            fieldData.minDate = getFutureDate(10, value);
          } else {
            fieldData.minDate = getFutureDate(7);
          }
        }

        if (
          fieldName === fieldTsbSecondaryPreferredInstallDate &&
          formFields.wirelineSecondaryInstallDate
        ) {
          const {
            wirelineSecondaryInstallDate: { value }
          } = formFields || {};
          if (
            getFieldValue(
              fieldTelusSecureBusinessSecurityPackage,
              formFields
            ) === valueProtect ||
            getFieldValue(
              fieldTelusSecureBusinessSecurityPackage,
              formFields
            ) === valueControl
          ) {
            fieldData.minDate = getFutureDate(10);
          } else if (value) {
            fieldData.minDate = getFutureDate(3, value);
          } else {
            fieldData.minDate = getFutureDate(8);
          }
        }

        if (
          fieldName === fieldTsbTertiaryPreferredInstallDate &&
          formFields.wirelinePreferedInstallDate &&
          formFields.wirelineSecondaryInstallDate
        ) {
          const {
            tsbSecondaryPreferredInstallDate: { value }
          } = formFields || {};
          if (
            getFieldValue(
              fieldTelusSecureBusinessSecurityPackage,
              formFields
            ) === valueProtect ||
            getFieldValue(
              fieldTelusSecureBusinessSecurityPackage,
              formFields
            ) === valueControl
          ) {
            fieldData.minDate = getFutureDate(16);
          } else if (value) {
            fieldData.minDate = getFutureDate(8, value);
          } else {
            fieldData.minDate = getFutureDate(14);
          }
        }

        if (
          formFields &&
          formFields[fieldCallToBookIt] &&
          fieldName === fieldCallToBookIt &&
          (isSbsTelesalesTiChannel(userChannelName) || isChannelSMBDigitalFr(userChannelName))
        ) {
          formFields[fieldCallToBookIt].isRequired = false;
          formFields[fieldCallToBookIt].isVisible = false;
          return null;
        }

        /**
         * If the Wireline Preferred install dates are not selected, make the first selection above 14 days out
         */
        if (
          fieldName === fieldTsbTertiaryPreferredInstallDate &&
          !(
            formFields.wirelinePreferedInstallDate &&
            formFields.wirelineSecondaryInstallDate
          )
        ) {
          fieldData.minDate = getFutureDate(15);
        }

        if (
          [fieldProductSelection].includes(fieldName) &&
          valueProductType &&
          valueProductType !== standalone
        ) {
          fieldData.note = '';
        }

        // 603
        if (tsbInstallDateFields.includes(fieldName)) {
          if (!_.get(orderData, 'productSelection', []).includes(keySecureBusiness)) {
            if (nonRoSProvinces.includes(selectProvince)) {
              return null;
            }
          }
        }

        if (fieldName === fieldPrefieldPreferredArrivalWindow) {
          if (_.get(orderData, 'productSelection', []).includes(keySecureBusiness)) {
            if (
              !(
                getFieldValue(
                  fieldTelusSecureBusinessSecurityPackage,
                  formFields
                ) === valueProtect ||
                getFieldValue(
                  fieldTelusSecureBusinessSecurityPackage,
                  formFields
                ) === valueControl
              )
            ) {
              return null;
            }
          } else if (
            !(
              orderData.productSelection.length > 1 &&
              _.get(orderData, 'productSelection', []).includes(internetFibre)
            )
          ) {
            return null;
          }
        }

        if (
          fieldName === fieldInstallationPreferredArrivalWindow &&
          !nonRoSProvinces.includes(selectProvince)
        ) {
          return null;
        }

        /**
         * Hide all product selection fields except TSB for province ROC
         */
        if (fields && fieldName === fieldProductSelection) {
          const prv = parseProvince(orderData.serviceAddress);
          const {
            British_Columbia: bColumbiaProvince,
            Alberta: albertaProvince,
            Prince_Edward_Island: princeEdwardIslandProvince,
            Quebec: quebecProvince
          } = provinceAlias;

          let optionsToShow = [...fieldData.options];
          const tsbFormFieldOpt = fieldData.options.find(
            prdSelObj => prdSelObj.fields.value === keySecureBusiness
          );
          const businessWifiFieldOpt = fieldData.options.find(
            prdSelObj => prdSelObj.fields.value === telusBusinessWifi
          );

          if (!(prv === albertaProvince || prv === bColumbiaProvince)) {
            optionsToShow = [tsbFormFieldOpt, businessWifiFieldOpt];
          }

          if (prv === princeEdwardIslandProvince) {
            const businessWifiPosition = optionsToShow.findIndex(
              prdSelObj =>
                prdSelObj && prdSelObj.fields.value === telusBusinessWifi
            );
            if (businessWifiPosition)
              optionsToShow.splice(businessWifiPosition, 1);
          }
          if (prv === quebecProvince) {
            optionsToShow = fieldData.options.filter(productItem =>
              [
                telusSecureBusiness,
                internetFibre,
                'TELUS Business Wi-Fi'
              ].includes(productItem.fields.value)
            );
          }
          if (isNGM(userChannelName) && fieldName === fieldProductSelection) {
            optionsToShow = fields.options.filter(productItem =>
              [
                internetCopper,
                internetFibre,
                'TELUS Business Wi-Fi',
                nameTelusTVForBusiness,
                telusSecureBusiness
              ].includes(productItem.fields.value)
            );
          }
          if (
            !is7XChannel(userChannelName) &&
            !isChannelValidForPhoneRemoval(userChannelName) &&
            optionsToShow.length === 1
          ) {
            optionsToShow[0].fields.disabledOption = false;
            if (!formFields[fieldProductSelection].value) {
              const updatedFields = formFields;
              formFields[fieldProductSelection].value = [
                optionsToShow[0].fields.value
              ];
              setFormFields(updatedFields);
            }
          }

          /**
           * FOR CHANNEL SBS TELESALES TI SHOW
           * FIBRE, COPPER, TELUS BUSINESS WIFI, TELUS SECURE BUSINESS
           * for AB & BC
           */
          if (isChannelValidForPhoneRemoval(userChannelName)) {
            if ([albertaProvince, bColumbiaProvince].includes(prv)) {
              const valueProductSelected = getFieldValue(
                fieldProductSelection,
                formFields
              );
              let productList = [
                internetCopper,
                internetFibre,
                'TELUS Business Wi-Fi',
                telusSecureBusiness,
                telusOptikTv
              ];
              /**
               * Removing Fibre from list if copper is selected
               */
              if (
                valueProductSelected &&
                valueProductSelected.includes(internetCopper)
              ) {
                productList = _.remove(
                  productList,
                  item => item !== internetFibre
                );
              }
              /**
               * Removing Copper from the list if Fibre is selected
               */
              if (
                valueProductSelected &&
                valueProductSelected.includes(internetFibre)
              ) {
                productList = _.remove(
                  productList,
                  item => item !== internetCopper
                );
              }
              optionsToShow = _.get(
                formFields,
                `${fieldProductSelection}.options`,
                []
              ).filter(productItem => {
                return productList.includes(productItem.fields.value);
              });
            }
          }

          /**
           * FOR CHANNEL 7X SHOW
           * 1. ONLY FIBRE, COPPER, TELUS BUSINESS WIFI for AB & BC
           * 2. ONLY TELUS BUSINESS WIFI for ROC
           */
          if (is7XChannel(userChannelName)) {
            if ([albertaProvince, bColumbiaProvince].includes(prv))
              optionsToShow = fieldData.options.filter(productItem =>
                [
                  internetCopper,
                  internetFibre,
                  'TELUS Business Wi-Fi'
                ].includes(productItem.fields.value)
              );
            if (![albertaProvince, bColumbiaProvince].includes(prv))
              optionsToShow = fieldData.options.filter(
                productItem =>
                  productItem.fields.value === 'TELUS Business Wi-Fi'
              );
          }

          /**
           * FOR CHANNEL SMB Growth Sales CBS SHOW
           * 1. ONLY Telus Secure Business
           */
          if (isSMBGrowthSalesCBS(userChannelName)) {
            optionsToShow = fieldData.options.filter(productItem => [telusSecureBusiness].includes(productItem.fields.value));
          }

          if (optionsToShow.length) {
            fieldData.options = optionsToShow;
          }
        }

        /**
         * Hide Forbearance for province other than Alberta, British Columbia
         */
        if (fieldName === fieldForbearance) {
          const prv = parseProvince(orderData.serviceAddress);
          const {
            British_Columbia: bColumbiaProvince,
            Alberta: albertaProvince
          } = provinceAlias;
          if (!(prv === albertaProvince || prv === bColumbiaProvince)) {
            if (!formFields[fieldProductType].value) {
              const updatedFields = formFields;
              updatedFields[
                fieldProductType
                ].value = valueProductTypeStandaloneFr;
              setFormFields(updatedFields);
            }
            return null;
          }
        }

        if (
          fieldName === fieldExistingInternetProviderErrorNote ||
          fieldName === fieldCustomerServiceAddressNote
        ) {
          fieldData.isWarningMessage = true;
        }

        /**
         Hide wirelineSecondaryInstallDate and wirelinePreferedInstallDate
         if product selection includes only secureBusiness
         */
        const shouldHideWirelineInstallationDates = _.get(orderData, 'productSelection', []).includes(keySecureBusiness);
        if (shouldHideWirelineInstallationDates) {
          if (
            fieldName === fieldWirelinePreferedInstallDate ||
            fieldName === fieldWirelineSecondaryInstallDate
          ) {
            return null;
          }
        }

        // hide the Office Phone and TELUS TV for Business on 7X channel
        if (is7XChannel(userChannelName) && fieldName === fieldProductSelection) {
          const optionsToShow = [...fieldData.options];
          for (let i = optionsToShow.length - 1; i >= 0; i -= 1) {
            const product = optionsToShow[i];
            if (
              product.fields.value === telusOptikTv ||
              product.fields.value === officePhone
            ) {
              optionsToShow.splice(i, 1); // Remove objects that don't meet the filter condition
            }
          }

          if (optionsToShow.length) {
            fieldData.options = optionsToShow;
          }
        }
        result = (
          <FormField key={key} data={fieldData} error={error && error.text} />
        );
      }

      return result;
    });

  const getSummary = () => {
    if (formSummary) {
      const {
        fields: { formSummaryGroup }
      } = formSummary;

      return formSummaryGroup.map((summaryGroup, index) => {
        const {
          fields: { name, formFields: summaryGroupFields }
        } = summaryGroup;
        const key = `formSummaryGroup${index}`;

        return (
          <Fragment key={key}>
            <h1>{name}</h1>
            <SummaryGroupWrapper>
              {summaryGroupFields.map((summaryGroupField, idx) => {
                const {
                  fields: { name: fieldName, label: fieldLabel }
                } = summaryGroupField;
                const summaryGroupFieldKey = `summaryGroupField${idx}`;

                return (
                  <div key={summaryGroupFieldKey}>
                    <span style={{ fontWeight: '400' }}>{fieldLabel}</span>:{' '}
                    {formFields[fieldName].value}
                  </div>
                );
              })}
            </SummaryGroupWrapper>
          </Fragment>
        );
      });
    }

    return Object.keys(formFields).map((item, index) => {
      const key = `summary${index}`;

      return (
        formFields[item].isVisible && (
          <div key={key}>
            <span style={{ fontWeight: '400' }}>{item}</span>:{' '}
            {formFields[item].value}
          </div>
        )
      );
    });
  };

  // if (isLoading)
  //   return (
  //     <ValidateLoader
  //       message="Please wait request is In progress...."
  //       isFormStep
  //     />
  //   );

  return (
    <div ref={formStepRef}>
      {!hideProgressBar && (
        <ProgressBar
          name={formStepName}
          steps={progressBarSteps}
          currentStep={step}
          locale={locale}
        />
      )}
      <div></div>
      {isLoading ? (
        <ValidateLoader
          message="Please wait request is In progress...."
          isFormStep
        />
      ) : (
        <div style={{ backgroundColor: '#fff' }}>
          <div className="container 85%" style={{ marginBottom: '10rem' }}>
            <div id="main">
              <div id="main-wrapper">
                <div id="main-content">
                  {(formStepBackendKey === BACKEND_KEYS.officePhone && (
                      <>
                        <OfficePhone
                          isOrderOfficePhone={
                            hidePricing && formStepName === officePhone
                          }
                          setOfficePhoneRequired={setOfficePhoneRequired}
                          fields={formStepFields}
                          setFormFields={setFormFields}
                          formFields={formFields}
                          setIsFormTouched={setIsFormTouched}
                          orderData={orderData}
                          isEditing={isEditing}
                          dueMonthly={dueMonthly}
                          setDueMonthly={setDueMonthly}
                        />
                      </>
                    )) ||
                    (formStepBackendKey === BACKEND_KEYS.quoteSummary && (
                      <>
                        <QuoteSummary
                          nextStep={nextStep}
                          setQuoteSummaryData={setQuoteSummaryData}
                          steps={steps}
                          setIsFormValidated={setIsFormValidated}
                          formStepFields={formStepFields}
                          orderData={orderData}
                          setOrderData={setOrderData}
                          onchange={setRedeemOfferData}
                          setCodeBasedPromotions={setCodeBasedPromotions}
                          defaultValueCBP={_.get(orderData, 'codeBasedPromotions', '')}
                          defaultValueRO={_.get(orderData, 'redeemOfferData', {})}
                          setDueMonthly={setDueMonthly}
                          setDueNow={setDueNow}
                          setdisableContinue={setdisableContinue}
                        />
                      </>
                    )) ||
                    (formStepBackendKey === BACKEND_KEYS.orderSummary && (
                      <>
                        <OrderSummary
                          stepData={progressBarSteps}
                          orderData={orderData}
                        />
                      </>
                    )) || (
                      <form
                        name={formStepName}
                        onSubmit={e => nextStep(e)}
                        ref={ref => setFormRef && setFormRef(ref)}
                      >
                        {sections.length &&
                        formStepBackendKey !==
                        BACKEND_KEYS.secureBusinessStep ? (
                          <div className="expand">
                            <ExpandCollapse
                              tag="h2"
                              topDivider={false}
                              open={open}
                            >
                              {renderFormFields(formStepFields)}
                            </ExpandCollapse>
                          </div>
                        ) : (
                          <FormFieldsWrapper>
                            {image && (
                              <div
                                className="column"
                                style={{ minWidth: '350px' }}
                              >
                                <Image image={image} name={formStepName} />
                              </div>
                            )}
                            <div className="column">
                              {formStepFields ? (
                                renderFormFields(formStepFields)
                              ) : (
                                <>
                                  <h3 style={{ marginBottom: '1em' }}>
                                    {summaryLabel}
                                  </h3>
                                  {getSummary()}
                                </>
                              )}
                            </div>
                          </FormFieldsWrapper>
                        )}
                      </form>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {showTotal && (
        <StatusBar
          isFirstStep={step === 1}
          isLastStep={formStepBackendKey === BACKEND_KEYS.quoteSummary}
          isOrderLastStep={formStepBackendKey === BACKEND_KEYS.orderSummary}
          isChannelTISales={isChannelTISales}
          isChannelSMBDigitalFr={isChannelSMBDigitalFr(userChannelName)}
          isFormTouched={isFormTouched}
          isFormValidated={isFormValidated}
          dueMonthly={dueMonthly}
          dueNow={dueNow}
          onSaveAndExit={saveAndExit}
          onDownloadClick={onViewPdf}
          onProceedClick={nextStep}
          onBackClick={prevStep}
          hidePricing={hidePricing}
          hideBackButton={hideBackButton}
          isEligible={isEligible && !hardStop}
          onCreateNewOrder={onCreateNewOrder}
          isCreateOrderVisible={isCreateOrderVisible}
          isFieldReset={isFieldReset}
          disableContinue={disableContinue}
        />
      )}
      {
        <Modal
          heading={modalData.title}
          bodyText={modalData.body}
          confirmCTAText={modalData.confirmText}
          cancelCTAText={modalData.cancelText}
          onConfirm={() =>
            history.push({
              pathname: '/'
            })
          }
          onClose={() => setModalData({ ...modalData, open: false })}
          isOpen={modalData.open}
          focusElementAfterClose={formStepRef}
        />
      }
    </div>
  );
};

FormStep.propTypes = {
  stepData: PropTypes.shape({
    fields: PropTypes.shape({
      name: PropTypes.string,
      image: PropTypes.string,
      formStepFields: PropTypes.arrayOf(PropTypes.object),
      formSummary: PropTypes.shape({
        fields: PropTypes.objectOf(PropTypes.any)
      }),
      showTotal: PropTypes.bool,
      modalForms: PropTypes.arrayOf(PropTypes.object),
      backendKey: PropTypes.string
    })
  }),
  steps: PropTypes.arrayOf(PropTypes.object).isRequired,
  progressBarSteps: PropTypes.arrayOf(PropTypes.object).isRequired,
  updateProgressBarSteps: PropTypes.func.isRequired,
  step: PropTypes.number.isRequired,
  updateStep: PropTypes.func,
  setFormRef: PropTypes.func,
  onFormSubmit: PropTypes.func,
  onSaveAndExit: PropTypes.func,
  orderData: PropTypes.objectOf(PropTypes.any),
  hideProgressBar: PropTypes.bool,
  isEditing: PropTypes.string.isRequired,
  formName: PropTypes.string.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired,
  onViewPdf: PropTypes.func.isRequired,
  setQuoteSummaryData: PropTypes.func.isRequired,
  onSaveAndContinue: PropTypes.func,
  onCreateNewOrder: PropTypes.func,
  isCreateOrderVisible: PropTypes.bool,
  setOrderData: PropTypes.func.isRequired
};

FormStep.defaultProps = {
  stepData: null,
  updateStep: () => {},
  setFormRef: null,
  onFormSubmit: null,
  orderData: {},
  onSaveAndExit: () => {},
  hideProgressBar: false,
  onSaveAndContinue: () => {},
  onCreateNewOrder: () => {},
  isCreateOrderVisible: false
};

export default FormStep;
